import * as React from 'react';
import {
  message,
  Button,
  Input,
  Form,
  Row,
  Col,
  Select,
  Radio,
  Tooltip,
  Spin,
  Checkbox,
  Upload,
  Icon,
  Collapse,
  DatePicker,
  Modal,
  InputNumber,
} from 'antd';
import SelectAddress from 'src/components/common/CommonSelect/SelectAddress';
import { MIN_WIDTH } from 'src/globals';
import { getPorts } from 'src/api/containerTracking';
import { createSelector } from 'reselect';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import {
  createInquiry,
  fetchInquiryDetailsForShipper,
  fileUploadOnS3,
  updateInquiry,
  inquiryCreateNegotiation,
  viewBreakDownForShipper,
} from 'src/api/inquiry';
import {
  getInquiryShipperRoute,
  getInquiryDetailRoute,
  getDiscoverRatesRoute,
} from 'src/routing/utils';
import Navbar from 'src/components/navbar/Navbar';
import SendRFQ from './Modals/SendRFQ';
import { uploadImageToS3 } from 'src/api/salesorder';
import { getFileExtension, prettifyString } from 'src/utils/utils';
import FileViewer from 'src/components/common/FileViewer';
import CreateInquiryLoader from './Modals/CreateInquiryLoader';
import CreateInquiryProtip from './Modals/CreateInquiryProtip';
import { INQUIRY_SHIPPER, INQUIRY_FROM_PROCURE } from 'src/utils/partsToShow/partsConstants';
import { isNullOrUndefined } from 'util';
import { CreateEnquiryFormConfig, DISPATCH_MODE_OPTIONS, Docs, EXCLUDED_WEIGHT_UNITS } from './constants';
import { globalShippingLines, globalAirlines } from 'src/selectors/importsFilter';
import { fetchAllTeams, fetchUserTeams } from 'src/api/teams';
import {
  BookingSource,
  disableInquiryClosingDateUtil,
  disableInquiryClosingTimeUtil,
  termsConditionsPlaceholder,
  LocationPreferences,
  productTempValidation,
  visibleAccessTypeLabel,
  defaultAccessKeys,
  visibleAccessTypeLabelsForTeamMapped,
  teamMappedAccessKeys,
  INQUIRY_FORM_GRID_ROWS,
  INQUIRY_FORM_GRID_COLS,
  formFieldConfig,
  ProductContainerRuleSet,
  DEFAULT_PRODUCT_TYPE,
  buildInquiryFieldLabelMap,
  resolveFieldLabel,
  getFclContainerAndQuantityDetails,
  selectContainerDetailsByDispatchMode,
} from './InquiryUtils';
import TeamForInquiryAccessModal from './Modals/TeamForInquiryAccessModal';
import {
  isValidArray,
  stops,
  isValidString,
  isValidNumber,
  highlightDiv,
  clone,
} from 'src/Library/Helper';
import { bindActionCreators } from 'redux';
import { setCreateInquiryData } from 'src/actions/inquiryShipperActions';
import { ContainerList } from 'src/components/common/Types/CommonTypes';
import FFSelectionModal from '../DiscoverRate/FFSelectionModal';
import uniqWith from 'lodash/uniqWith';
import { OrganisationList } from '../DiscoverRate/TypesInDiscoverRates/SelectedFilters';
import SendInquiryInConnectionsModal from '../kycConnections/SendInquiryInConnectionsModal';
import { searchProduct } from '../masters/Product/Product.api';
import NewProduct from '../masters/Product/NewProduct';
import debounce from 'lodash/debounce';
import { fetchAddresses } from 'src/api/organisationProfiling';
import isEmpty from 'lodash/isEmpty';
import { sendEvent, EventCategories } from 'src/utils/gaService';
import { InquiryModes, InquiryType, CargoOperationType, CargoTypes, ALLOWED_PICKUP_AND_DROP, PICKUP_AND_DROP_POINT, PICKUP_AND_DROP_SPLITUP, VALID_LOCATION_TYPES } from 'src/Library/Constants';
import classNames from 'classnames';
import { CargoType } from './Booking/BookingUtils';
import CreateTruckingInquiry from './CreateTruckingInquiry';
import { getCountryId } from './Cards/InquiryCommon';
import uniq from 'lodash/uniq';
import GenericHoc from 'src/components/hoc/GenericHoc';
import { PermissionTypes, HocOptions } from 'src/components/hoc/GenericHoc.types';
import { CreateEnquiryStyles as styles } from './CreateEnquiry.styles';
import Divider from 'antd/lib/divider';
import CreateDomesticInquiry from './CreateDomesticInquiry';
import { fetchAllStakeholdersPaginated } from 'src/api/masters';
import FormGridContainer from './FormGridContainer';
import { containerTypeKeyLabelMap } from '../invoicing/enums/container_type.enum';
import { hasMasterCategoryEditPermission } from 'src/utils/partsToShow/helper';
import { tokens } from 'src/design-system';
import Asterisk from 'src/components/common/Asterisk';


const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const { LCL, FCL, AIRCARGO, TRAILER, DOMESTIC, RPTL }  = InquiryModes;
// https://en.wikipedia.org/wiki/Dimensional_weight
const VOLUMETRIC_WT_DENOMINATOR = 6000; // ToDo: This must be coming from backend
class CreateEnquiry extends React.Component<any, any> {
  fromDiscoverRates = () => {
    const { location } = this.props;
    return location?.state?.from === 'discoverRates' || location?.pathname?.includes('discover');
  };

  getDefaultPort = (type, defaultPortValues) => {
    const { discoverRatesSearchFilters } = this.props;
    if (
      this.fromDiscoverRates() &&
      discoverRatesSearchFilters &&
      discoverRatesSearchFilters[type]
    ) {
      return [discoverRatesSearchFilters[type]];
    } else {
      return defaultPortValues;
    }
  };

  disableRatesSearchParams = () => {
    const { location } = this.props;
    return location?.state?.disableFields;
  };

  getMode = () => {
    const {
      form: { getFieldValue },
      discoverRatesSearchFilters
    } = this.props;
    const { mode = 'FCL' } = discoverRatesSearchFilters || {}
    return this.disableRatesSearchParams() ? mode : getFieldValue('mode');
  };

  getPortDetails = (type, key) => {
    const { discoverRatesSearchFilters } = this.props;
    
    if (
      this.fromDiscoverRates() &&
      discoverRatesSearchFilters &&
      discoverRatesSearchFilters[type] &&
      discoverRatesSearchFilters.mode === this.getMode()
    ) {
      switch (key) {
        case 'port':
          return discoverRatesSearchFilters[type].code;
        case 'name':
          return discoverRatesSearchFilters[type].name;
        case 'countryName':
          return discoverRatesSearchFilters[type].countryName;
        default:
          return discoverRatesSearchFilters[type].countryCode;
      }
    }
  };

  getDefaultDryPortState = (portType) => {
    const { discoverRatesSearchFilters } = this.props;
    return this.fromDiscoverRates()
      ? discoverRatesSearchFilters && discoverRatesSearchFilters[portType]?.type === 'DRY'
      : false;
  };

  contactRowId = 0;

  getNextContactRowId = () => {
    this.contactRowId += 1;
    return `contact-${this.contactRowId}`;
  };

  createContactRow = (contact?) => {
    const contactData: any = contact || {};

    return {
      id: contactData.id || this.getNextContactRowId(),
      name: contactData.name || '',
      email: contactData.email || '',
      phone: contactData.phone || '',
    };
  };

  normalizeContactRows = (contacts) => {
    if (!Array.isArray(contacts) || !contacts.length) {
      return [this.createContactRow()];
    }

    return contacts.map((contact) => this.createContactRow(contact));
  };

  hasFilledContactInfo = (contacts) => {
    if (!Array.isArray(contacts) || !contacts.length) {
      return false;
    }

    return contacts.some((contact) => {
      const currentContact: any = contact || {};
      return !!(currentContact.name || currentContact.email || currentContact.phone);
    });
  };

 
  state: any = {
    isOriginDryPort: this.getDefaultDryPortState('pol'),
    containerKey: 1,
    productDetailsKey: 1,
    docsKey: 1,
    containers: {
      0: {
        count: 1,
        type: 'STANDARD',
        size: "20'",
        weightUnit: 'kg'
      },
    },
    inquiryData: {},
    shipperId: undefined,
    organisationId: undefined,
    createInquiryModalVisible: false,
    sendInquiryModalVisible: false,
    creatingInquiry: false,
    serviceType: this.props.defaultInquiryMovementType || 'export',
    originPortsPre: [],
    originPorts: this.getDefaultPort('pol', undefined),
    originPortsPreSearching: false,
    destinationPortsPre: [],
    destinationPorts: this.getDefaultPort('pod', undefined),
    destinationPortsPreSearching: false,
    isDestinationDryPort: this.getDefaultDryPortState('pod'),
    originPortsSearching: false,
    destinationPortsSearching: false,
    isSearching: true,
    showProtip: false,
    prefilling: false,
    isInitialLoading: true,
    docs: {
      0: {
        uploading: false,
        file: {},
        type: 'CUSTOM INVOICE',
      },
    },
    creatingBooking: false,
    activeKey: this.fromDiscoverRates() ? undefined : '1',
    preferredCarriers: [],
    originPort: this.getPortDetails('pol', 'port'),
    originPortName: this.getPortDetails('pol', 'name'),
    originCountry: this.getPortDetails('pol', 'country'),
    originPortCountry: this.getPortDetails('pol', 'country'),
    destinationPort: this.getPortDetails('pod', 'port'),
    destinationPortName: this.getPortDetails('pod', 'name'),
    destinationCountry: this.getPortDetails('pod', 'country'),
    destinationCountryName: this.getPortDetails('pod', 'countryName'),
    destinationPortCountry: this.getPortDetails('pod', 'country'),
    pickupAndDrop: 'Port to Port',
    allowedServices: [],
    originServices: this.fromDiscoverRates() ? this.props?.discoverRatesSelectedFilters?.originServices??[] : this.props.defaultOriginDestinationServiceSelection ? [] :['Port Service'],
    destinationServices: this.props?.discoverRatesSelectedFilters?.destinationServices??[],
    stuffingAddresses: [],
    deStuffingAddresses: [],
    preferredSailingRange: [
      moment().endOf('day').add(7, 'day'),
      moment().endOf('day').add(14, 'day'),
    ],
    packagingDetailsKeys: [0],
    isSelectTeamModalVisible: false,
    accessType: undefined,
    teams: [],
    teamId: undefined,
    teamName: undefined,
    isFFSelectionModalVisible: false,
    isSendInquiryWithKYCVisible: false,
    isProductListLoading: false,
    productDetailList: [],
    productDetails: {
      0:{
        key :'',
        quantity: 0,
        unit: '',
        productCnType: '',
        productCnSize: '',
        containerAndQuantityDetails: []
      }
    },
    inquiryDataResponse: {},
    source: '',
    showAddInputIncoterm: false,
    showAddInputOrigin: false,
    showAddInputDestination: false,
    confirmedBidData: [],
    stuffingTruckingAddress: {},
    deStuffingTruckingAddress: {},
    cfsAddresses: [],
    vehicleDetails: undefined,
    containerPickup: undefined,
    trailerType: undefined,
    termsAndConditions: undefined,
    bookingAccessTeams: {},
    openNewLocationModal: false,
    packagingDetails: undefined,
    domesticDocs /* : Docs */: {
      0: {
        uploading: false,
        file: {},
        type: 'CUSTOM INVOICE',
      },
    },
    disableModeSwitch: false,
    stopLocationKeys: [],
    stopsAddressData: [],
    sentFFIds: [],
    selectedFileViewer: null,
    inchargeContactOrigin: [
      this.createContactRow()
    ],
    inchargeContactDestination: [
      this.createContactRow()
    ],
    inquiryFormFieldConfig: formFieldConfig.FCL,
    stakeholderList: [],
    stakeholder: undefined,
    stakeholderSearching: false,
    stakeholderType: 'Shipper',
    customerList: [],
    customer: undefined,
    customerSearching: false,
    prefilledStuffingAddress: undefined,
    prefilledDestuffingAddress: undefined,
    inquiryFieldLabelMap: {},
    productContainerRuleSet: null,
    containerWeightUnit: 'mt'
  };

  updateDisableModeSwitch = (disableModeSwitch: boolean = false) => {
    this.setState({
      disableModeSwitch
    });
  }

  updateDomesticDocsParent = (setdocs?: {docs: Docs}, setContainerKey?: {containerKey: number}) => {
    if (setdocs?.docs){
      this.setState({
        docs: setdocs.docs,
        docsKey: Object.keys(setdocs.docs).length
      });
    }
  };

  updateDomesticPackagingDetailsKeysParent = (childPackagingDetailsKeys) => {
    this.setState({
      packagingDetailsKeys: childPackagingDetailsKeys?.packagingDetailsKeys
    });
  }

  updateStopLocationKeys = (newStopLocationKeys) => {
    this.setState({
      stopLocationKeys: newStopLocationKeys?.stopLocationKeys
    });
  }

  searchPorts = async (searchFor, queryString, type: any) => {
    const response = await getPorts({ queryString, type });
    if (response.isSuccess) {
      this.setState({
        [`${searchFor}`]: response.data,
        [`${searchFor}Searching`]: false,
      });
      return;
    }
    message.error(response.errorMessage);
    this.setState({
      searching: false,
    });
  };

  timeout: any = null;

  handlePortSearch = (searchFor, query, type: any = 'ALL', topFive: any = undefined) => {
    this.setState({
      [`${searchFor}Searching`]: true,
    });
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.searchPorts(searchFor, query, type);
    }, 200);
  };

  handleStakeholderSearch(stakeholderType: 'SUPPLIER' | 'SHIPPER', queryString?: string){
    this.setState({
      stakeholderSearching: true,
    });
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(async () => {

      try {
          const response = await fetchAllStakeholdersPaginated({
            stakeholderType: [stakeholderType],
            searchQuery: queryString,
            resultPerPage: 25,
            currentPageNumber: 1
          })

          if (response.isSuccess){
            const stakeholderData = response.data?.data 
            this.setState({
              stakeholderList: stakeholderData
            })
            return
          }
      } catch (e) {
        message.error(e)
      } finally {
        this.setState({
          stakeholderSearching: false
        })
      }
    }, 200);
  }

  handleCustomerSearch(queryString?: string){
    this.setState({
      customerSearching: true,
    });
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(async () => {

      try {
          const response = await fetchAllStakeholdersPaginated({
            stakeholderType: ['CUSTOMER'],
            searchQuery: queryString,
            resultPerPage: 25,
            currentPageNumber: 1
          })

          if (response.isSuccess){
            const customerData = response.data?.data;
            this.setState({
              customerList: customerData
            })
            return;
          }
      } catch (e) {
        message.error(e)
      } finally {
        this.setState({
          customerSearching: false
        })
      }
    }, 200);
  }

  s3LinkRequest = async ({ file }, ind) => {
    this.setState({
      docs: {
        ...this.state.docs,
        [ind]: {
          ...this.state.docs[ind],
          uploading: true,
        },
      },
    });
    const extension = getFileExtension(file.name);
    const response = await fileUploadOnS3({
      extension,
      fileName: file.name,
      document_type: file.type,
      initialPath: 'inquiry',
    });
    if (response.isSuccess) {
      const upload = await uploadImageToS3(file, response.data.post, extension);
      if (upload.isSuccess) {
        this.setState({
          docs: {
            ...this.state.docs,
            [ind]: {
              ...this.state.docs[ind],
              file: {
                ext: extension,
                name: file.name,
                s3Link: response.data.get,
              },
              uploading: false,
            },
          },
        });
      }
    } else {
      message.error(response.errorMessage);
      this.setState({
        docs: {
          ...this.state.docs,
          [ind]: {
            ...this.state.docs[ind],
            uploading: false,
          },
        },
      });
    }
  };

  changeLocation = (key, loc) => {
    let services: any = [];
    if (loc === 'Dock/CFS/Customs Warehouse') {
      if (this.getMode() !== AIRCARGO) {
        services = [...this.state[key], 'CFS/Customs Warehouse Service'];
      }
      services = services.filter((item, pos, self) => {
        return self.indexOf(item) === pos;
      });
    } else {
      services = [...this.state[key]];
      services = services.filter((item) => {
        return item !== 'CFS/Customs Warehouse Service';
      });
    }
    this.setState({
      [key]: services,
    });
  };

  changeStuffingLocation = (loc) => {
    this.changeLocation('originServices', loc);
  };

  changeDeStuffingLocation = (loc) => {
    this.changeLocation('destinationServices', loc);
  };

  handleServiceTypeChange = (e) => {
    const {
      incotermToServices,
      defaultOriginDestinationServiceSelection,
      form: { getFieldValue, setFieldsValue },
    } = this.props;
    const incoterm = getFieldValue('incoterm');
    const serviceType = e.target.value;
    const mode = this.getMode();

    this.setState({
      serviceType: e.target.value,
      originServices:
        incotermToServices?.[serviceType?.toUpperCase()]?.[incoterm]?.[mode]?.['ORIGIN'] || 
        (defaultOriginDestinationServiceSelection ? [] : serviceType === 'export' ? ['Port Service'] : []),
      destinationServices:
        incotermToServices?.[serviceType?.toUpperCase()]?.[incoterm]?.[mode]?.['DESTINATION'] ||
        (defaultOriginDestinationServiceSelection ? [] : serviceType === 'import' ? ['Port Service'] : []),
      stakeholderType: serviceType === 'import' ? 'Supplier': 'Shipper',
      stakeholderList: [],
      stakeholder: undefined,
      customerList: [],
      customer: undefined
    });

    setFieldsValue({
      stakeholderId: undefined,
      customerId: undefined
    })

  };

  setStuffingTruckingAddress = (item) => {
    this.setState({ stuffingTruckingAddress: item });
  };
  
  setDeStuffingTruckingAddress = (item) => {
    this.setState({ deStuffingTruckingAddress: item });
  };

 parseInchargeDetails = (inchargeDetailsString) => {
  if (!inchargeDetailsString) {
    return [this.createContactRow()];
  }
  
  // Updated regex to split on single semicolon, comma, or newline
  // Also handles the original double separators and double newlines
  const contactStrings = inchargeDetailsString.split(/[;,]{2,}|[;\n,]|\n\n/).filter(str => str.trim());
  
  if (contactStrings.length === 0) {
    return [this.createContactRow()];
  }
  
  return contactStrings.map(contactString => {
    const parts = contactString.trim().split(/\s+/).filter(part => part.length > 0);
    
    if (parts.length === 0) {
      return this.createContactRow();
    }
    
    let email = '';
    let phone = '';
    
    // Find email (has an '@' character)
    const emailIndex = parts.findIndex(part => part.includes('@'));
    if (emailIndex !== -1) {
      email = parts[emailIndex];
    }
    
    // Find phone: any part that is only digits and common phone formatting characters
    const isValidPhone = (part) => {
      const digitsOnly = part.replace(/[\s\-\+\(\)\.]/g, '');
      const isNumeric = /^\d+$/.test(digitsOnly);
      const hasValidChars = /^[\d\s\-\+\(\)\.]+$/.test(part);
      return isNumeric && digitsOnly.length > 0 && hasValidChars;
    };
    
    const phoneIndex = parts.findIndex(part => isValidPhone(part));
    if (phoneIndex !== -1) {
      phone = parts[phoneIndex];
    }
    
    // Everything else is name (excluding email and phone parts)
    const name = parts
      .filter((part, index) => {
        if (index === emailIndex || index === phoneIndex) {
          return false;
        }

        const digitsOnly = part.replace(/\D/g, '');
        const hasDigits = digitsOnly.length > 0;
        const hasLetters = /[a-zA-Z]/.test(part);

        if (hasDigits && !hasLetters && digitsOnly.length < 7) {
          return false;
        }

        return true;
      })
      .join(' ');
    
    return this.createContactRow({ name, phone, email });
  });
};

  syncContactFormFields = (contactType, contacts) => {
    const { form } = this.props;

    if (!Array.isArray(contacts) || !form) {
      return;
    }

    const prefix = `${contactType}Contact`;
    const currentValues = form.getFieldsValue();
    const fieldsToUpdate = {};

    Object.keys(currentValues || {}).forEach((fieldName) => {
      if (typeof fieldName === 'string' && fieldName.startsWith(prefix)) {
        fieldsToUpdate[fieldName] = undefined;
      }
    });

    contacts.forEach((contact = {}) => {
      const contactId = contact?.id;

      if (!contactId) {
        return;
      }

      fieldsToUpdate[`${contactType}ContactName_${contactId}`] = contact.name || '';
      fieldsToUpdate[`${contactType}ContactPhone_${contactId}`] = contact.phone || '';
      fieldsToUpdate[`${contactType}ContactEmail_${contactId}`] = contact.email || '';
    });

    if (Object.keys(fieldsToUpdate).length) {
      form.setFieldsValue(fieldsToUpdate);
    }
  };

  resetContactInfo = (contactType) => {
    const stateField = contactType === 'origin' ? 'inchargeContactOrigin' : 'inchargeContactDestination';
    const emptyContacts = [this.createContactRow()];

    this.setState({ [stateField]: emptyContacts }, () => {
      this.syncContactFormFields(contactType, emptyContacts);
    });
  };

  setContactFromOption = (contactType, optionProps) => {
    if (!optionProps) {
      return;
    }
    const { inquiryFormPrefill } = this.props

    //Dont update contact info on option change if inquiry_form_prefill is enabled
    if (inquiryFormPrefill){
      return;
    }

    const resolvedName = optionProps?.inchargeContactName || optionProps?.inchargeContactDetails?.name || '';
    const resolvedEmail = optionProps?.inchargeContactEmail || optionProps?.inchargeContactDetails?.email || '';
    const resolvedPhone = optionProps?.inchargeContactPhone || optionProps?.inchargeContactDetails?.phone || '';

    const stateField = contactType === 'origin' ? 'inchargeContactOrigin' : 'inchargeContactDestination';
    const contacts = [this.createContactRow({
      name: resolvedName,
      email: resolvedEmail,
      phone: resolvedPhone,
    })];

    this.setState({ [stateField]: contacts }, () => {
      this.syncContactFormFields(contactType, contacts);
    });
  };

  /**
   * When booking from contract rates, prefill incharge from create-booking-data response
   * (stakeholderPicDetails = origin incharge, customerPicDetails = destination incharge).
   */
  applyBookingDataPicDetails = () => {
    const bookingData = this.props.bookingData;
    const { form } = this.props;
    if (!this.props.booking || !bookingData) return;
    const nextState: any = {};
    if (bookingData.stakeholderPicDetails) {
      nextState.inchargeContactOrigin = [this.createContactRow({
        name: bookingData.stakeholderPicDetails.name ?? '',
        email: bookingData.stakeholderPicDetails.email ?? '',
        phone: bookingData.stakeholderPicDetails.phone ?? '',
      })];
    }
    if (bookingData.customerPicDetails) {
      nextState.inchargeContactDestination = [this.createContactRow({
        name: bookingData.customerPicDetails.name ?? '',
        email: bookingData.customerPicDetails.email ?? '',
        phone: bookingData.customerPicDetails.phone ?? '',
      })];
    }
    if (bookingData.internalReferenceNumber) {
      form.setFieldsValue({ internalReferenceNumber: bookingData.internalReferenceNumber });
    }
    if (bookingData.requiredOriginFreeDays) {
      form.setFieldsValue({ requiredOriginFreeDays: bookingData.requiredOriginFreeDays });
    }
    if (bookingData.requiredDestinationFreeDays) {
      form.setFieldsValue({ requiredDestinationFreeDays: bookingData.requiredDestinationFreeDays });
    }
    if (Object.keys(nextState).length) {
      this.setState(nextState, () => {
        if (nextState.inchargeContactOrigin) {
          this.syncContactFormFields('origin', nextState.inchargeContactOrigin);
        }
        if (nextState.inchargeContactDestination) {
          this.syncContactFormFields('destination', nextState.inchargeContactDestination);
        }
      });
    }
  };

  prefillDataInForm = (data) => {
    if (!data || !Object.keys(data).length) return;
    const { docs, confirmedBidData } = this.state;
    const { form, match, booking, masterData, orgCurrency, inquiryDefaultFormConfig, bidData } = this.props;
    const { activeKey } = this.state;
    const normalizedMode = data.mode;
    let containers: any = {};
    let productDetails: any = {};
    let containerKey = 0;
    let productKey = 0
    if (this.props.booking) {
      this.props.getSelectedBidId(data.confirmedBidId);
    }
    if (data.otherDetails?.allowVendorToSpecifyOrigin && bidData?.origin) {
      const updatedOrigin = { ...bidData.origin, port: bidData.origin.code };
      data.originPortDetails = {...updatedOrigin, ...data?.originPortDetails};
      data.origin = {...updatedOrigin, ...data.origin};
    }
    if (data.otherDetails?.allowVendorToSpecifyDestination && bidData?.destination) {
      const updatedDestination = { ...bidData.destination, port: bidData.destination.code };
      data.destinationPortDetails = {...updatedDestination, ...data?.destinationPortDetails};
      data.destination = {...updatedDestination, ...data.destination};
    }
    data?.productList?.map((item, index) => {
      productDetails = {
        ...productDetails,
        [productKey]: {
          key: item.id,
          quantity: item.count,
          unit: item.unit,
          referenceNumber: item.referenceNumber,
          // Add the product name/label for display
          name: item.internalName,
          hsCode: item.hsCode,
          remark: item.remark,
          productCnType: item?.productCnType,
          productCnSize: item?.productCnSize,
          containerAndQuantityDetails: item?.containerAndQuantityDetails || [],
          grossWeight: item?.grossWeight,
          grossWeightUnit: item?.grossWeightUnit,
        },
      };
      productKey = productKey + 1;
    });
    // Fallback: populate productDetails from single productId for old DOMESTIC/RPTL inquiries
    if ((data.mode === DOMESTIC || data.mode === RPTL) && !Object.keys(productDetails).length && data.productId && data.product) {
      productDetails = {
        0: {
          key: data.productId,
          name: data.product.internalName,
          quantity: data.product.count || 1,
          unit: data.product.unit || 'kg',
          referenceNumber: data.product.referenceNumber,
          hsCode: data.product.hsCode,
          remark: data.product.remark,
        },
      };
      productKey = 1;
    }
    data.containerDetails.map((item, index) => {
      const weightKey = item.hasOwnProperty('weight') ? 'weight' : 'totalWeight';
      containers = {
        ...containers,
        [containerKey]: {
          type: item.type,
          count: item.count,
          size: item.size,
          temperature: item.temperature,
          unit: item[weightKey] ? item[weightKey].unit : 'mt',
          value: item[weightKey] ? item[weightKey].value : undefined,
        },
      };
      containerKey = containerKey + 1;
    });
    const containerDetails: any = {};
    const products: any = {};
    const inquiryStakeholder: any = {}
    if (data.stakeholder){
      inquiryStakeholder.org2Id = data.stakeholder.id
      inquiryStakeholder.name = data.stakeholder.name
      inquiryStakeholder.code = data.stakeholder.code
    }
    Object.keys(productDetails).map((item) => {
      products[`productQuantity${item}`] = productDetails[item].quantity;
      products[`productUnit${item}`] = productDetails[item].unit;
      products[`productKey${item}`] = productDetails[item].key ? {
        key: productDetails[item].key,
        label: `${productDetails[item].name || ''} ${productDetails[item].hsCode ? `(${productDetails[item].hsCode} - ${productDetails[item].remark || ''})` : ''} [${productDetails[item].referenceNumber || ''}]`,
        value: productDetails[item].name,
        referenceNumber: productDetails[item].referenceNumber,
      } : undefined;
      products[`productCnType${item}`] = productDetails[item].productCnType;
      products[`productCnSize${item}`] = productDetails[item].productCnSize;
    });
    Object.keys(containers).map((item) => {
      containerDetails[`type${item}`] = containers[item].type;
      containerDetails[`count${item}`] = containers[item].count;
      containerDetails[`size${item}`] = containers[item].size;
      containerDetails[`weightUnit${item}`] = containers[item].unit;
      containerDetails[`temperature${item}`] = containers[item].temperature;
      containerDetails[`weight${item}`] = containers[item].value;
      containerDetails[`carriageTemperature${item}`] = containers[item].carriageTemperature;
    });

    let initialProductContainerRuleSet: ProductContainerRuleSet | null = null

    if (data?.mode === InquiryModes.FCL || data?.mode === InquiryModes.DOMESTIC){
      const validProductEntry: any = Object.values(productDetails).find(
        (product: any) => product?.productCnType && product?.productCnSize
      );

      if (validProductEntry && data?.cargoType){
        initialProductContainerRuleSet = {
          cargoType: data.cargoType,
          productCnType: validProductEntry?.productCnType,
          cargoProductType: data?.productType
        }
      }
    }

    let documents: any = {};
    data.documentUrls.map((item, ind) => {
      documents = {
        ...documents,
        [ind]: {
          uploading: false,
          file: {
            ext: getFileExtension(item.name),
            name: item.name,
            s3Link: item.url,
          },
          type: item.type,
        },
      };
    });
    const prefilledDocs = isEmpty(documents) ? docs : documents;
    const originInchargeDetails = this.parseInchargeDetails(data.origin?.inchargeDetails);
    const destinationInchargeDetails = this.parseInchargeDetails(data.destination?.inchargeDetails);
    const primaryOriginIncharge = originInchargeDetails?.[0] || {};
    const primaryDestinationIncharge = destinationInchargeDetails?.[0] || {};
    this.setState(
      {
        originPorts: data.originPortDetails ? [data.originPortDetails] : [],
        originPortsPre: this.prefillPreferredPort(
          confirmedBidData?.portOfLoading,
          data.preferredOriginPortDetails
        ),
        destinationPortsPre: this.prefillPreferredPort(
          confirmedBidData?.portOfDischarge,
          data.preferredDestinationPortDetails
        ),
        destinationPorts: data.destinationPortDetails ? [data.destinationPortDetails] : [],
        shipperId: data.shipperId,
        inquiryFormFieldConfig: inquiryDefaultFormConfig?.[normalizedMode] || formFieldConfig?.[normalizedMode]
      },
      () => {
        this.setState({
          originPort: data.origin?.port,
          destinationPort: data.destination?.port,
          originPortName: data.originPortDetails?.name,
          destinationPortName: data.destinationPortDetails?.name,
          inquiryFieldLabelMap: buildInquiryFieldLabelMap(this.state.inquiryFormFieldConfig)
        });
      }
    );
    this.setState({
      ...(Object.keys(containers)?.length && { containers }),
      ...(Object.keys(products)?.length && { productDetails }),
      productContainerRuleSet: initialProductContainerRuleSet, 
      productDetailsKey: productKey,
      containerKey,
      docs: prefilledDocs,
      docsKey: Object.keys(prefilledDocs).length,
      originPortCountry: data.origin?.countryCode,
      shipperId: data.shipperId,
      isOriginDryPort: data.origin?.portType === 'DRY',
      isDestinationDryPort: data.destination?.portType === 'DRY',
      destinationPortCountry: data.destination?.countryCode,
      preferredCarriers: data.preferredCarriers || undefined,
      serviceType: data.type.toLowerCase(),
      stakeholderType: data.type === InquiryType.IMPORT ? 'Supplier' : 'Shipper',
      pickupAndDrop: data.pickupAndDrop || 'Port to Port',
      originServices: data.origin?.services,
      destinationServices: data.destination?.services,
      cargoReadyDate:
        (this.props.booking || match.path.includes('edit')) &&
          data?.cargoReadyDate
          ? moment(data.cargoReadyDate)
          : undefined,
      preferredSailingRange:
        (this.props.booking || match.path.includes('edit')) &&
          data?.preferredSailingRange
          ? [
            data?.preferredSailingRange?.[0]
              ? moment(data.preferredSailingRange[0])
              : undefined,
            data?.preferredSailingRange?.[1]
              ? moment(data.preferredSailingRange[1])
              : undefined,
          ]
          : undefined,
      accessType: data.accessorType,
      inchargeContactOrigin: originInchargeDetails,
      inchargeContactDestination: destinationInchargeDetails,
      teamId: data.accessorId,
      teamName: data.teamName,
      bookingAccessTeams: data.accessorType === 'TEAM' ? { [data.accessorId]: data.teamName } : {},
      source: data.source,
      activeKey:
        data.source === BookingSource.DIRECT_BOOKING || data.source === BookingSource.SPOT_BOOKING
          ? undefined
          : activeKey,
      ...(data.cargoType === CargoType.HAZ &&
        isEmpty(documents) && {
        docs: {
          0: {
            uploading: false,
            file: {},
            type: 'MSDS',
          },
          1: {
            uploading: false,
            file: {},
            type: 'IIP/UN CERTIFICATE',
          },
        },
        docsKey: 2
      }),
      ...(data.containerDetails?.length && { vehicleDetails: data.containerDetails?.map((item) => ({
        count: item.count,
        size: item.size,
        type: item.type,
        weight: {
          unit: item.weight?.unit,
          value: item.weight?.value,
        },
      }))}),
      ...(data.mode === TRAILER && {
        stuffingTruckingAddress:
          data.type === InquiryType.EXPORT
            ? data.originLocationDetails
            : data.destinationLocationDetails,
        }),
        ...((data.mode === TRAILER || data.mode === DOMESTIC || data.mode === RPTL) && {
        selectedCountryId: getCountryId([
          data.destinationPortDetails,
          data.emptyContainerLocationPortDetails,
          data.destinationLocationDetails,
          data.originLocationDetails,
        ]),
      }),
      ...(data.mode === TRAILER &&
        data.type === InquiryType.IMPORT && {
        containerPickup: data.originLocationDetails ?? undefined,
      }),
      termsAndConditions: data.termsAndConditions,
      stopsAddressData: data.otherDetails?.stops,
      stopLocationKeys: data.otherDetails?.stops?.length ? data.otherDetails.stops.map((el, i) => i) : [],
      stakeholder: data.stakeholder ? inquiryStakeholder : undefined,
      stakeholderList: data.stakeholder ? [inquiryStakeholder, ...this.state.stakeholderList] : this.state.stakeholderList,
      customer: data?.customer ? {
        org2Id: data?.customer?.id,
        name: data?.customer?.name,
        ...data?.customer
      } : undefined,
      customerList: data?.customer ? [{
        org2Id: data?.customer?.id,
        name: data?.customer?.name,
        ...data?.customer
      }, ...this.state.customerList] : this.state.customerList,
      prefilledStuffingAddress: (data.mode === TRAILER && data.type === InquiryType.EXPORT) || (data.mode === DOMESTIC) || (data.mode === RPTL)
                ? (data.originLocationDetails?.id 
                  ? {
                    key: data.originLocationDetails?.id,
                    label: `${data.originLocationDetails.name}, ${data.originLocationDetails.pincode ?? ''} (${data.originLocationDetails.referenceNumber})`,
                  } 
                  : undefined)
                : {
                  key: data.origin?.stuffingDestuffingAddressId,
                  label: data.origin?.stuffingDestuffingAddress
                },
      prefilledDestuffingAddress: (data.mode === TRAILER && data.type === InquiryType.IMPORT) || (data.mode === DOMESTIC) || (data.mode === RPTL)
                ? (data.destinationLocationDetails?.id 
                  ? {
                    key: data.destinationLocationDetails?.id,
                    label: `${data.destinationLocationDetails.name}, ${data.destinationLocationDetails.pincode ?? ''} (${data.destinationLocationDetails.referenceNumber})`,
                  } 
                  : undefined)
                : {
                  key: data.destination?.stuffingDestuffingAddressId,
                  label: data.destination?.stuffingDestuffingAddress
                },
    }, () => {
      form.setFieldsValue(
        {
          ...containerDetails,
          ...products,
          internalReferenceNumber: data.internalReferenceNumber,
          serviceType: data.type.toLowerCase(),
          originPreferredWetPort:
            data.origin?.portType === 'DRY'
              ? booking
                ? confirmedBidData?.portOfLoading?.code
                : data.preferredOriginPortDetails?.code
              : undefined,
          originAddress: data.origin?.address,
          originDetails: data.origin?.additionalDetails,
          destinationPreferredWetPort:
            data.destination?.portType === 'DRY'
              ? booking
                ? confirmedBidData?.portOfDischarge?.code
                : data.preferredDestinationPortDetails?.code
              : undefined,
          destinationAddress: data.destination?.address,
          destinationDetails: data.destination?.additionalDetails,
          inquiryClosing: ['edit', 'createInquiry'].some(pathSegment => match.path.includes(pathSegment))
            ? (data.deadline ? (() => {
                // Convert UTC deadline to shipper timezone for display in date picker
               
                return this.props.timezone
                  ? momentTimezone(data.deadline).tz(this.props.timezone)
                  : moment(data.deadline);
              })() : undefined)
            : this.props.booking
              ? undefined
              : (masterData?.defaultDeadlineInHours ?
              moment().add(masterData?.defaultDeadlineInHours, 'hours') :
              moment().endOf('day').add(2, 'day')),
          stuffingLocation: data.origin?.location,
          deStuffingLocation: data.destination?.location,
          incoterm: data.incoterm || undefined,
          incotermDetails: data.incotermDetails || undefined,
          product: data.productType || undefined,
          cargoType: data.cargoType || undefined,
          terms: data.termsAndConditions,
          ["referenceRate['basis']"]: data.referenceRate ? data.referenceRate.basis : 'FREIGHT',
          ["referenceRate['amount']"]: data.referenceRate ? data.referenceRate.amount : undefined,
          ["referenceRate['currency']"]: data.referenceRate ? data.referenceRate.currency : orgCurrency,
          cargoReadyDate:
            (this.props.booking || match.path.includes('edit')) &&
              data?.cargoReadyDate
              ? moment(data.cargoReadyDate)
              : undefined,
          preferredSailingRange:
            (this.props.booking || match.path.includes('edit')) &&
              data?.preferredSailingRange
              ? [
                data?.preferredSailingRange?.[0]
                  ? moment(data.preferredSailingRange[0])
                  : undefined,
                data.preferredSailingRange?.[1]
                  ? moment(data.preferredSailingRange[1])
                  : undefined,
              ]
              : undefined,
          mode: normalizedMode,
          requiredDestinationFreeDays: data.requiredDestinationFreeDays,
          shipperId: data.shipperId,
          requiredOriginFreeDays: data.requiredOriginFreeDays,
          accessType:
            data.teamName && !this.props.booking ? (
              <>
                <Icon type="team"></Icon> {data.teamName}
              </>
            ) : (
              data.accessorType
            ),
          originHaulage: data.origin?.haulage || 'MERCHANT',
          destinationHaulage: data.destination?.haulage || 'MERCHANT',
          originMovement: data.origin?.movementType || 'MERCHANT',
          destinationMovement: data.destination?.movementType || 'MERCHANT',
          stakeholderId: inquiryStakeholder.org2Id,
          customerId: data.customer?.id,
          dispatchMode: data.dispatchMode
        },
        () => {
          this.syncContactFormFields('origin', originInchargeDetails);
          this.syncContactFormFields('destination', destinationInchargeDetails);
          form.setFieldsValue({
            stuffingAddress: this.state.prefilledStuffingAddress,
            deStuffingAddress: this.state.prefilledDestuffingAddress,
            productAdditionalDetails: {
              shippingName: data.product?.internalName,
            },
            ...(( data.mode === TRAILER || data.mode === DOMESTIC || data.mode === RPTL ) && {
              ...(data.type === InquiryType.EXPORT && {
                pickupPort: data.emptyContainerLocationPortDetails?.code ? {
                  key: JSON.stringify(data.emptyContainerLocationPortDetails || '{}'),
                  label: `${data.emptyContainerLocationPortDetails?.name} [${data.emptyContainerLocationPortDetails?.code}]`,
                } : undefined,
                dropOffPort: data.destinationPortDetails?.code ? {
                  key: JSON.stringify(data.destinationPortDetails || '{}'),
                  label: `${data.destinationPortDetails?.name} [${data.destinationPortDetails?.code}]`,
                } : undefined,
              }),
              ...(data.type === InquiryType.IMPORT && {
                cfsLocation: data.originLocationDetails?.id ? {
                  key: data.originLocationDetails?.id,
                  label: `${data.originLocationDetails?.name} (${data.originLocationDetails?.referenceNumber})`,
                } : undefined,
                dropOffPort: data.emptyContainerLocationPortDetails?.code ? {
                  key: JSON.stringify(data.emptyContainerLocationPortDetails || '{}'),
                  label: `${data.emptyContainerLocationPortDetails?.name} [${data.emptyContainerLocationPortDetails?.code}]`,
                } : undefined,
              }),
              cargoDate:
                (this.props.booking || match.path.includes('edit')) &&
                  !isNullOrUndefined(data.cargoReadyDate)
                  ? moment(data.cargoReadyDate)
                  : undefined,
              closingTime: match.path.includes('edit')
                ? data.deadline ? moment(data.deadline) : undefined
                : this.props.booking
                  ? undefined
                  : (masterData?.defaultDeadlineInHours ?
                    moment().add(masterData?.defaultDeadlineInHours, 'hours') :
                    moment().endOf('day').add(2, 'day')),
              internalReference: data.internalReferenceNumber,
              destinationFreeDays: data.requiredDestinationFreeDays,
              originFreeDays: data.requiredOriginFreeDays,
              trailerBusinessType: (data.mode === TRAILER && data?.otherDetails?.businessType) 
              ? data.otherDetails.businessType 
              : undefined,
              carrierFreeDays: data.carrierFreeDays,
              product: data.productType,
              referenceRate: {
                amount: data.referenceRate?.amount,
                currency: data.referenceRate?.currency,
              },
            }),
            temperatureControlled: data.temperatureControlled,
            shipmentName: data?.otherDetails?.shipmentName ?? undefined,
            requestor: data?.otherDetails?.requestor ?? undefined,
            serviceLevel: data?.otherDetails?.serviceLevel ?? undefined,
            typeOfContainer: data?.otherDetails?.typeOfContainer ?? undefined,
            typeOfMovement: data?.otherDetails?.typeOfMovement ?? undefined,
            isDraft: data?.otherDetails?.isDraft ?? false,
            remarks: data?.otherDetails?.remarks ?? undefined,
            isDraftIncomplete: data?.otherDetails?.isDraftIncomplete ?? false,
            isTiltable: data?.otherDetails?.isTiltable === null ? null : data?.otherDetails?.isTiltable ?? false,
            totalDistance: (normalizedMode === DOMESTIC || normalizedMode === RPTL) ? data?.otherDetails?.distance : undefined,
            businessType: ((normalizedMode === DOMESTIC || normalizedMode === RPTL || normalizedMode === FCL || normalizedMode === LCL) && data?.otherDetails?.businessType) 
              ? data.otherDetails.businessType 
              : undefined,
            extraDetails: ((normalizedMode === DOMESTIC || normalizedMode === RPTL || normalizedMode === FCL || normalizedMode === LCL) && data?.otherDetails?.extraDetails) 
              ? data.otherDetails.extraDetails 
              : undefined,
            ...((normalizedMode === DOMESTIC || normalizedMode === RPTL) && {
              originInchargeName: primaryOriginIncharge?.name || undefined,
              originInchargePhone: primaryOriginIncharge?.phone || undefined,
              originInchargeEmail: primaryOriginIncharge?.email || undefined,
              destinationInchargeName: primaryDestinationIncharge?.name || undefined,
              destinationInchargePhone: primaryDestinationIncharge?.phone || undefined,
              destinationInchargeEmail: primaryDestinationIncharge?.email || undefined,
            }),
            ...((normalizedMode === DOMESTIC || normalizedMode === RPTL) && {isHighValueInsuranceRequired: data?.otherDetails?.isHighValueInsuranceRequired,
            cargoValue: data?.otherDetails?.cargoValue}),
            ...(data.mode === TRAILER && {isGensetRequired: data?.otherDetails?.isGensetRequired,
              overWeight: data?.otherDetails?.overWeight})
          });
  
          // Handle product for DOMESTIC and RPTL modes
          if ((normalizedMode === DOMESTIC || normalizedMode === RPTL) && data.productId && data.product) {
            // Populate the product dropdown options
            this.setState({
              productDetailList: [{
                key: data.productId,
                label: `${data.product.internalName} (${data.product.hsCode || ''} - ${data.product.remark || ''}) [${data.product.referenceNumber || ''}]`,
                value: data.product.internalName,
                referenceNumber: data.product.referenceNumber,
                disabled: false
              }],
            });
  
            // Then set the form value for productObj
            form.setFieldsValue({
              productObj: {
                key: data.productId,
                label: `${data.product.internalName} (${data.product.hsCode || ''} - ${data.product.remark || ''}) [${data.product.referenceNumber || ''}]`,
                value: data.product.internalName,
                referenceNumber: data.product.referenceNumber,
              }
            });
  
            // Also trigger a search to ensure we have all products available
            this.getProducts(data.product.internalName);
          }
  
          const config = CreateEnquiryFormConfig[normalizedMode] || {};
          let values: any = null;
          if (config.stackableVisible) {
            values = values || {};
            values.stackable = data.stackable;
          }
          if ((this.getMode() === DOMESTIC || this.getMode() === RPTL) && data?.otherDetails?.stops?.length) {
            let stopsFieldValues = form.getFieldValue('stops')
            data.otherDetails.stops?.forEach((stops, index) => {
                stopsFieldValues[index].address = {
                  key: stops?.address?.id,
                  label: `${stops?.address?.name} [${stops?.address?.referenceNumber}]`,
                },
                stopsFieldValues[index].type = stops?.type
            });
            form.setFieldsValue({stops: stopsFieldValues});
          }
          if (data.containerDetails?.some((item) => item.type === 'OPEN_TOP')) {
            let packagingDetails = {};
            data.containerDetails?.forEach((item, ind) => {
              if (!isEmpty(item?.packageDimension)) {
                form.setFieldsValue({ [`gauageCheckbox${ind + 1}`]: true });
                packagingDetails[`packagingDetails[${ind + 1}].packageDimension.length`] =
                  item?.packageDimension?.length;
                packagingDetails[`packagingDetails[${ind + 1}].packageDimension.breadth`] =
                  item?.packageDimension?.breadth;
                packagingDetails[`packagingDetails[${ind + 1}].packageDimension.height`] =
                  item?.packageDimension?.height;
                packagingDetails[`packagingDetails[${ind + 1}].packageDimension.unit`] =
                  item?.packageDimension?.unit;
              }
            });
            form.setFieldsValue(packagingDetails);
          }
          if (config.packagingDetailsVisible && data.containerDetails) {
            values = values || {};
            values.packagingDetails = (this.getMode() === DOMESTIC || this.getMode() === RPTL) ? [...data.containerDetails] : [...data.containerDetails];
          }
          if (values && values.packagingDetails?.length) {
            this.setState(
              {
                packagingDetailsKeys: values.packagingDetails.map((el, i) => i),
              },
              () => {
                data.containerDetails?.forEach((item, ind) => {
                  if (!isEmpty(item?.packageDimension)) {
                    form.setFieldsValue({ [`gauageCheckbox${ind}`]: true });
                  }
                });
                form.setFieldsValue(values);
              }
            );
          } else if (values) {
            form.setFieldsValue(values);
          }
        }
      );
      form.setFieldsValue({
        businessEntity: data?.otherDetails?.businessEntity,
      })
      this.prefillServicesAndMovementType(
        data?.incoterm,
        data?.pickupAndDrop,
        data?.origin?.services,
        data?.destination?.services,
        data?.origin?.location,
        data?.destination?.location
      );

      const originAddressId =
        ((data.mode === TRAILER && data.type === InquiryType.EXPORT) || normalizedMode === DOMESTIC || normalizedMode === RPTL)
          ? data.originLocationDetails?.id
          : data.origin?.stuffingDestuffingAddressId;
      const destAddressId =
        ((data.mode === TRAILER && data.type === InquiryType.IMPORT) || normalizedMode === DOMESTIC || normalizedMode === RPTL)
          ? data.destinationLocationDetails?.id
          : data.destination?.stuffingDestuffingAddressId;
      // REPLACE the address-based contact update logic with this:
      const originAddress = this.state.stuffingAddresses.find((addr) => addr.id === originAddressId);
      const destinationAddress = this.state.deStuffingAddresses.find((addr) => addr.id === destAddressId);

      if (originAddress && (
        originAddress.inchargeContactName ||
        originAddress.inchargeContactEmail ||
        originAddress.inchargeContactPhone ||
        originAddress.inchargeContactDetails?.name ||
        originAddress.inchargeContactDetails?.email ||
        originAddress.inchargeContactDetails?.phone
      )) {
        // Only update if address has actual contact info AND we don't already have parsed contact info
        if (!originInchargeDetails || !originInchargeDetails[0] ||
          (!originInchargeDetails[0].name && !originInchargeDetails[0].email && !originInchargeDetails[0].phone)) {

          this.setContactFromOption('origin', {
            inchargeContactName: originAddress.inchargeContactName,
            inchargeContactEmail: originAddress.inchargeContactEmail,
            inchargeContactPhone: originAddress.inchargeContactPhone,
            inchargeContactDetails: originAddress.inchargeContactDetails,
          });
        }
      }

      if (destinationAddress && (
        destinationAddress.inchargeContactName ||
        destinationAddress.inchargeContactEmail ||
        destinationAddress.inchargeContactPhone ||
        destinationAddress.inchargeContactDetails?.name ||
        destinationAddress.inchargeContactDetails?.email ||
        destinationAddress.inchargeContactDetails?.phone
      )) {
        // Only update if address has actual contact info AND we don't already have parsed contact info
        if (!destinationInchargeDetails || !destinationInchargeDetails[0] ||
          (!destinationInchargeDetails[0].name && !destinationInchargeDetails[0].email && !destinationInchargeDetails[0].phone)) {

          this.setContactFromOption('destination', {
            inchargeContactName: destinationAddress.inchargeContactName,
            inchargeContactEmail: destinationAddress.inchargeContactEmail,
            inchargeContactPhone: destinationAddress.inchargeContactPhone,
            inchargeContactDetails: destinationAddress.inchargeContactDetails,
          });
        }
      }
    });
  };

  prefillPreferredPort = (bidPortDetails, inquiryPortDetails) => {
    const { booking } = this.props;
    if (booking) {
      return bidPortDetails ? [bidPortDetails] : [];
    }
    return inquiryPortDetails ? [inquiryPortDetails] : [];
  };

  getInquiryActionLabel = () => {
    const { match, booking } = this.props;
    if (booking) {
      return 'Create Booking';
    }
    return this.isEditInquiry()
      ? 'Edit Inquiry'
      : match?.params?.inquiryId
        ? 'Duplicate Inquiry'
        : 'Create Inquiry';
  };

  getInquiryGACategory = () => {
    const { booking, fromDiscoverRates } = this.props;
    if (booking) {
      return !fromDiscoverRates
        ? EventCategories.INQUIRY_BOOKING_SHIPPER
        : EventCategories.DISCOVER_RATES_BOOKING_SHIPPER;
    }
    return this.fromDiscoverRates()
      ? EventCategories.DISCOVER_RATES_NEGOTIATE_SHIPPER
      : EventCategories.INQUIRY_CREATION;
  };

  async componentDidMount() {
    const { match, history, booking, modeList, userData, isDefaultInquiryTeamMapping, allInquiriesData, inquiryDefaultFormConfig, discoverRatesSearchFilters, defaultInquiryMovementType  } = this.props;
    let inquiryId;
    this.setState({ organisationId: this.props.userData?.organisation_id }); 
    const mode = 'FCL';
    const backendConfig =
      this.props?.masterData?.inquiryFormFieldConfig?.[mode] ||
      this.props?.masterData?.inquiryDefaults?.formFieldConfig?.[mode] ||
      this.props?.masterData?.inquiryDefaults?.defaultFormFieldConfig?.[mode];
    const usedConfig = backendConfig || inquiryDefaultFormConfig?.[mode] || formFieldConfig?.[mode];
    this.setState({
      inquiryFormFieldConfig: usedConfig,
      inquiryFieldLabelMap: buildInquiryFieldLabelMap(usedConfig)
    });

    const { getFieldValue } = this.props.form 
    const isDraft = getFieldValue('isDraft')
    const showDefaultMappedUserTeam = isDefaultInquiryTeamMapping && userData.role !== 'ADMIN'

    const serviceType =
    this.fromDiscoverRates() && discoverRatesSearchFilters?.movementType?.toLowerCase()
      ? discoverRatesSearchFilters.movementType.toLowerCase()
      : defaultInquiryMovementType
      ? defaultInquiryMovementType
      : 'export';

    this.setState({
      serviceType,
      stakeholderType: serviceType === 'import' ? 'Supplier' : 'Shipper',
      customerList: [],
      customer: undefined,
    })


    await this.loadAddresses();
    await this.fetchTeams(showDefaultMappedUserTeam);
    if (this.props.booking || this.props.inqiryId) {
      inquiryId = this.props.inquiryId;
    } else if (match && match.params && match.params.inquiryId) {
      inquiryId = match.params.inquiryId;
    }
    if (this.isEditInquiry()) {
      sendEvent(this.getInquiryGACategory(), `${this.getInquiryActionLabel()} Page`);
    }
    if (inquiryId) {
      this.setState({
        prefilling: true,
      });
      const response = await fetchInquiryDetailsForShipper({
        inquiryId,
      });
      if (response.isSuccess) {
        if (
          booking &&
          (response.data?.destination?.portType === 'DRY' ||
            response.data?.origin?.portType === 'DRY')
        ) {
          const bidDataResponse = await viewBreakDownForShipper({
            bidId: response.data?.confirmedBidId || this.props?.bidData?.id,
          });
          if (bidDataResponse.isSuccess) {
            this.setState({
              confirmedBidData: bidDataResponse.data,
            });
          } else {
            message.error(bidDataResponse.errorMessage);
          }
        }

        if (this.isEditInquiry()){
          const currentInquiry = allInquiriesData.find((inquiry) => inquiry.id === response.data.id)
          if (currentInquiry){
            this.setState({
              sentFFIds: currentInquiry.sentFfIds
            })
          }
        }
        this.setState({
          trailerType: response.data?.type,
          packagingDetails: response.data?.containerDetails,
        });
        this.prefillDataInForm(response.data);
        if (this.props.booking) {
          this.props.setInquiryData(response.data);
          this.applyBookingDataPicDetails();
        }
      } else {
        message.error(response.errorMessage);
        history.push(getInquiryShipperRoute(isValidArray(modeList) ? `modeList=${modeList}` : ''));
      }
      this.setState({
        prefilling: false,
      });
    }
    this.setAllowedServices();
    
    // Mark initial loading as complete after addresses are loaded
    this.setState({ isInitialLoading: false });
  }

  handleStakeholderChange = (stakeholderData: any) => {
    const { form, containerList, cargoTypes, masterData, exportBehaviorEnabled, inquiryFormPrefill} = this.props
    const { originPorts, containers } = this.state
    const nextState: any = {};

    const stakeholder = stakeholderData;

    const preservePrefilledOriginContacts =
      this.state.prefilling &&
      (this.isEditOrBookingInquiry() || this.isDuplicateInquiry()) &&
      this.hasFilledContactInfo(this.state.inchargeContactOrigin);

    const serviceType = form.getFieldValue('serviceType');

    const stakeholderAddress = stakeholder?.defaultLocation
    const stakeholderPort = stakeholder?.defaultPol
    const stakeholderProducts = stakeholder?.productDetails
    const stakeholderContainerType = stakeholder?.defaultContainerType
    const stakeholderContainerSize = stakeholder?.defaultContainerSize
    const stakeholderTnC = stakeholder?.defaultTnc
    const stakeholderIncoterm = stakeholder?.defaultIncoterm
    const stakeholderDispatchMode = stakeholder?.defaultDispatchMode
    const stakeholderDefaultOriginFreeDays = stakeholder?.defaultDestinationFreeDays
    const stakeholderPicDetails = stakeholder?.picDetails

    if (stakeholderAddress){
        const formLabel = `${stakeholderAddress.name ?? ''}, ${stakeholderAddress.pincode ?? ''} (${stakeholderAddress.referenceNumber ?? ''})`
        const stuffingAddressValue = {
          key: String(stakeholderAddress.id),
          label: formLabel,
          ...stakeholderAddress
        }
        // Persist the prefilled address in state so it is available as the field's
        // initialValue when prefillServicesAndMovementType later sets stuffingLocation
        // and mounts the field. A bare setFieldsValue here is dropped if the field
        // is not yet registered (the "one selection behind" bug).
        nextState.prefilledStuffingAddress = stuffingAddressValue
        form.setFieldsValue({
          stuffingAddress: stuffingAddressValue
        })

    } else {
      nextState.prefilledStuffingAddress = undefined
      form.setFieldsValue({ stuffingAddress: undefined });
    }

    if (preservePrefilledOriginContacts) {
      // Keep inquiry-level contact details while edit/duplicate data is being loaded.
    } else if (stakeholderPicDetails){
      const stateField = 'inchargeContactOrigin';
      const contacts = [this.createContactRow({
        name: stakeholderPicDetails?.name,
        email: stakeholderPicDetails?.email,
        phone: stakeholderPicDetails?.phone,
      })];

      this.setState({ [stateField]: contacts }, () => {
        this.syncContactFormFields('origin', contacts);
      });
    } else {
        this.resetContactInfo('origin');
    }

    if (stakeholderPort){
      const portAlreadyInList = (originPorts || []).find((p: any) => p.code === stakeholderPort.code);

      if (portAlreadyInList){
        nextState.originPorts = [stakeholderPort, ...originPorts];
      }

      nextState.originPort = stakeholderPort.code;
      nextState.originCountry = stakeholderPort.countryCode;
      nextState.originPortCountry = stakeholderPort.countryCode;
      nextState.originPortName = stakeholderPort.name;
      nextState.isOriginDryPort = stakeholderPort.type === 'DRY';
      this.setState({
        ...(portAlreadyInList ? {} : { originPorts: [stakeholderPort, ...(originPorts || [])] }),
        originPort: stakeholderPort.code,
        originCountry: stakeholderPort.countryCode,
        originPortCountry: stakeholderPort.countryCode,
        originPortName: stakeholderPort.name,
        isOriginDryPort: stakeholderPort.type === 'DRY',
      })

    } else {
      nextState.originPorts = originPorts || []
      nextState.originPort = this.getPortDetails('pol', 'port');
      nextState.originCountry = this.getPortDetails('pol', 'country')
      nextState.originPortCountry = this.getPortDetails('pol', 'country');
      nextState.originPortName = this.getPortDetails('pol', 'name');
      nextState.isOriginDryPort = this.getDefaultDryPortState('pol');
    }

    if (stakeholderDefaultOriginFreeDays){
      form.setFieldsValue({
        requiredOriginFreeDays: stakeholderDefaultOriginFreeDays
      });
    } else {
      form.setFieldsValue({
        requiredOriginFreeDays: undefined
      });
    }

    if (inquiryFormPrefill){
      // Prefill from the stakeholder's default — or CLEAR it when the newly selected
      // stakeholder has none, so a previous party's mode can't linger and drive the
      // wrong container quantities / be submitted (ISS-288612 §5).
      form.setFieldsValue({
        dispatchMode: stakeholderDispatchMode || undefined
      });
      this.refreshProductContainerDetailsForDispatchMode();
    }

    const shouldUseStakeholderForProducts = serviceType === 'import' || !exportBehaviorEnabled;
    if (shouldUseStakeholderForProducts && stakeholderProducts && stakeholderProducts.length > 0){
      const productDetailList = stakeholderProducts.map((product: any) => ({
        key: product.id,
        label: `${product.internalName} (${product.hsCode || ''} - ${product.remark || ''}) [${product.referenceNumber || ''}]`,
        value: product.internalName,
        referenceNumber: product.referenceNumber,
        disabled: product.status === 'INACTIVE',
        organisationId: product.organisationId,
      }))
      this.setState({
        productDetailList
      })
    } else if (shouldUseStakeholderForProducts) {
      nextState.productDetailList = [];
    }

    const shouldUseStakeholderForContainer = serviceType === 'import' || !exportBehaviorEnabled;
    if (shouldUseStakeholderForContainer && stakeholderContainerType && stakeholderContainerSize){
      const defaultContainerCount = 1
      let totalContainerWeight
      let totalContainerWeightUnit

      const cargoType = cargoTypes.find((cargo) => cargo.key === 'GENERAL')
      form.setFieldsValue({
        cargoType: cargoType?.key
      })
      if (stakeholderProducts && stakeholderProducts.length > 0){
        totalContainerWeight = stakeholderProducts[0]?.totalQuantity
        totalContainerWeightUnit = stakeholderProducts[0]?.totalQuantityUnit || 'kg'
      }

      const containerTypeValue = containerList.find((container) => {
        return container.key.type === stakeholderContainerType
         && container.key.size === stakeholderContainerSize
         && container.cargoList.includes(cargoType?.key)
      })?.key.type

      Object.keys(containers).forEach((key) => {
        form.setFieldsValue({
          [`count${key}`] : defaultContainerCount,
          [`type${key}`] : containerTypeValue,
          [`size${key}`] : stakeholderContainerSize,
          [`weight${key}`] : totalContainerWeight,
          [`weightUnit${key}`] : totalContainerWeightUnit,
        })


        nextState.containers = {
          ...containers,
          [key]: {
            ...(containers?.[key] || []),
            count: defaultContainerCount,
            type: containerTypeValue,
            size: stakeholderContainerSize,
            weight: totalContainerWeight,
            weightUnit: totalContainerWeightUnit
          }
        }
      })
    } else if (shouldUseStakeholderForContainer) {
       Object.keys(containers).forEach((key) => {
        form.setFieldsValue({
          [`count${key}`] : undefined,
          [`type${key}`] : undefined,
          [`size${key}`] : undefined,
          [`weight${key}`] : undefined,
          [`weightUnit${key}`] : undefined,
      })

        nextState.containers = {
          ...containers,
          [key]: {
            ...(containers?.[key] || []),
            count: undefined,
            type: undefined,
            size: undefined,
            weight: undefined,
            weightUnit: undefined
          }
        }
      })
    }

    const shouldUseStakeholderForTerms = serviceType === 'import' || !exportBehaviorEnabled;
    if (shouldUseStakeholderForTerms){
      if (stakeholderTnC){
        form.setFieldsValue({
          terms: stakeholderTnC
        })
      } else {
        form.setFieldsValue({
          terms: masterData?.termsAndConditions || undefined
        })
      }
    }

    const shouldUseStakeholderForIncoterm = serviceType === 'import' || !exportBehaviorEnabled;
    if (shouldUseStakeholderForIncoterm){
      if (stakeholderIncoterm){
        form.setFieldsValue({
          incoterm: stakeholderIncoterm
        })
        this.prefillServicesAndMovementType(stakeholderIncoterm);
      } else {
        form.setFieldsValue({
          incoterm: undefined
        })
      }
    }

    this.setState(nextState)
  }

  handleCustomerChange = (customerData: any) => {
    const { form, containerList, cargoTypes, masterData, exportBehaviorEnabled, inquiryFormPrefill} = this.props
    const { destinationPorts, containers } = this.state
    const nextState: any = {};

    const customer = customerData;

    const preservePrefilledDestinationContacts =
      this.state.prefilling &&
      (this.isEditOrBookingInquiry() || this.isDuplicateInquiry()) &&
      this.hasFilledContactInfo(this.state.inchargeContactDestination);

    const serviceType = form.getFieldValue('serviceType');

    let portDetails = {
      destinationPort: undefined,
      destinationCountry: undefined,
      destinationPortCountry: undefined,
      destinationPortName: undefined,
      isDestinationDryPort: false,
      destinationPorts: destinationPorts
    };
    const customerAddress = customer?.defaultLocation;
    const customerPort = customer?.defaultPol;
    const customerDestinationFreeDays = customer?.defaultDestinationFreeDays;
    const customerProducts = customer?.productDetails;
    const customerContainerType = customer?.defaultContainerType;
    const customerContainerSize = customer?.defaultContainerSize;
    const customerTnC = customer?.defaultTnc;
    const customerIncoterm = customer?.defaultIncoterm;
    const customerDispatchMode = customer?.defaultDispatchMode;
    const customerPicDetails = customer?.picDetails;

    if (customerAddress){
      const formLabel = `${customerAddress.name ?? ''}, ${customerAddress.pincode ?? ''} (${customerAddress.referenceNumber ?? ''})`;
      const deStuffingAddressValue = {
        key: String(customerAddress.id),
        label: formLabel,
        ...customerAddress
      };
      // Persist the prefilled address in state so it is available as the field's
      // initialValue when prefillServicesAndMovementType later sets deStuffingLocation
      // and mounts the field. A bare setFieldsValue here is dropped if the field
      // is not yet registered (the "one selection behind" bug).
      nextState.prefilledDestuffingAddress = deStuffingAddressValue;
      form.setFieldsValue({
        deStuffingAddress: deStuffingAddressValue
      });
    } else {
      nextState.prefilledDestuffingAddress = undefined;
      form.setFieldsValue({ deStuffingAddress: undefined });
    }

    if (preservePrefilledDestinationContacts) {
      // Keep inquiry-level contact details while edit/duplicate data is being loaded.
    } else if (customerPicDetails){
      const stateField = 'inchargeContactDestination';
      const contacts = [this.createContactRow({
        name: customerPicDetails?.name,
        email: customerPicDetails?.email,
        phone: customerPicDetails?.phone,
      })];

      this.setState({ [stateField]: contacts }, () => {
        this.syncContactFormFields('destination', contacts);
      });
    } else {
      this.resetContactInfo('destination');
    }

    if (!customer) {
      this.setState({
        destinationPort: undefined,
        destinationCountry: undefined,
        destinationPortCountry: undefined,
      });
    }
    if (customerPort) {
      const portAlreadyInList = (destinationPorts || []).find(p => p.code === customerPort.code);
      portDetails = {
        destinationPort: customerPort.code,
        destinationCountry: customerPort.countryCode,
        destinationPortCountry: customerPort.countryCode,
        destinationPortName: customerPort.name,
        isDestinationDryPort: customerPort.type === 'DRY',
        destinationPorts: portDetails.destinationPorts

      };
      if (!portAlreadyInList) {
        portDetails.destinationPorts = [customerPort, ...(destinationPorts || [])];
      }
      this.setState(portDetails);
    } else if (!this.state.prefilling){
      this.setState(portDetails);
    }


    if (customerDestinationFreeDays){
      form.setFieldsValue({
        requiredDestinationFreeDays: customerDestinationFreeDays
      });
    } else {
      form.setFieldsValue({
        requiredDestinationFreeDays: undefined
      });
    }

    if (inquiryFormPrefill){
      // Prefill from the customer's default — or CLEAR it when the newly selected
      // customer has none, so a previous party's mode can't linger and drive the
      // wrong container quantities / be submitted (ISS-288612 §5).
      form.setFieldsValue({
        dispatchMode: customerDispatchMode || undefined
      });
      this.refreshProductContainerDetailsForDispatchMode();
    }

    if (serviceType === 'export' && exportBehaviorEnabled && !this.state.prefilling){
      this.resetProductAndContainerDetailFields();
      if (customerProducts && customerProducts.length > 0){
        const productDetailList = customerProducts.map((product: any) => ({
          key: product.id,
          label: `${product.internalName} (${product.hsCode || ''} - ${product.remark || ''}) [${product.referenceNumber || ''}]`,
          value: product.internalName,
          referenceNumber: product.referenceNumber,
          disabled: product.status === 'INACTIVE',
          organisationId: product.organisationId,
          cargoType: product.cargoType || '',
          cargoProductType: product.cargoProductType || '' ,
          containerAndQuantityDetails: product?.containerAndQuantityDetails || [],
          grossWeight: product.grossWeight,
          grossWeightUnit: product.grossWeightUnit,
          netWeight: product.netWeight,
          netWeightUnit: product.netWeightUnit
        }))
        this.setState({
          productDetailList
        })
      } else {
        this.setState({
          productDetailList: []
        })
      }

      if (customerContainerType && customerContainerSize){
        const defaultContainerCount = 1
        let totalContainerWeightUnit

        const cargoType = cargoTypes.find((cargo) => cargo.key === 'GENERAL')
        form.setFieldsValue({
          cargoType: cargoType?.key
        })
        if (customerProducts && customerProducts.length > 0){
          totalContainerWeightUnit = customerProducts[0]?.totalQuantityUnit || 'kg'
        }

        const containerTypeValue = containerList.find((container) => {
          return container.key.type === customerContainerType
           && container.key.size === customerContainerSize
           && container.cargoList.includes(cargoType?.key)
        })?.key.type

        // Store customer defaults to prevent override during product selection
        nextState.customerDefaultContainerType = customerContainerType
        nextState.customerDefaultContainerSize = customerContainerSize

        Object.keys(containers).forEach((key) => {
          form.setFieldsValue({
            [`count${key}`] : defaultContainerCount,
            [`type${key}`] : containerTypeValue,
            [`size${key}`] : customerContainerSize,
            [`weightUnit${key}`] : totalContainerWeightUnit,
          })

          nextState.containers = {
            ...containers,
            [key]: {
              ...(containers?.[key] || []),
              count: defaultContainerCount,
              type: containerTypeValue,
              size: customerContainerSize,
              weightUnit: totalContainerWeightUnit
            }
          }
        })
      } else {
        // Clear customer defaults if not present
        nextState.customerDefaultContainerType = undefined
        nextState.customerDefaultContainerSize = undefined

         Object.keys(containers).forEach((key) => {
          form.setFieldsValue({
            [`count${key}`] : undefined,
            [`type${key}`] : undefined,
            [`size${key}`] : undefined,
            [`weight${key}`] : undefined,
            [`weightUnit${key}`] : undefined,
        })

          nextState.containers = {
            ...containers,
            [key]: {
              ...(containers?.[key] || []),
              count: undefined,
              type: undefined,
              size: undefined,
              weight: undefined,
              weightUnit: undefined
            }
          }
        })
      }

      this.setState(nextState)

      if (customerTnC){
        form.setFieldsValue({
          terms: customerTnC
        })
      } else {
        form.setFieldsValue({
          terms: masterData?.termsAndConditions || undefined
        })
      }

      if (customerIncoterm){
        form.setFieldsValue({
          incoterm: customerIncoterm
        })
        this.prefillServicesAndMovementType(customerIncoterm);
      } else {
        form.setFieldsValue({
          incoterm: undefined
        })
      }
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
    const currentMode = this.getMode();
    const prevMode = prevProps.form?.getFieldValue('mode');

    if ((currentMode === RPTL || currentMode === LCL) && currentMode !== prevMode) {
      this.getProducts('');
    }
  }

  componentWillUnmount(): void {
    this.debouncedApplyCalculatedContainerCounts.cancel()
  }


  fetchTeams = async (showDefaultMappedUserTeam: boolean) => {
    if (showDefaultMappedUserTeam){
      /**
       * Fetch user teams and set default team here
       */
      const response = await fetchUserTeams()

      if (response.isSuccess) {
        response.data && response.data.length
          ? this.setState({
            teams: response.data,
            // avoid initial values for parent orgs since teams have not been filtered on the basis of shipper IDs
            ...(!this.props.isParentOrg && {
              accessType: response.data && response.data.length > 0 ? 'TEAM' : undefined,
              teamId: response.data ? response.data[0].id : undefined,
              teamName:
                response.data ? `${response.data[0].name} (${response.data[0].reference_number})`: undefined,
            })
          })
          : this.setState({ accessType: 'PRIVATE' });
      } else {
        message.error(response.errorMessage);
      }
    } else {
      /**
       * Fetch all teams and set it here 
       */
      const response = await fetchAllTeams({ adminTeamRestriction: false, getAllTeams: false });
      if (response.isSuccess) {
        response.data && response.data.length
          ? this.setState({
            teams: response.data,
            // avoid initial values for parent orgs since teams have not been filtered on the basis of shipper IDs
            ...(!this.props.isParentOrg && {
              accessType: response.data && response.data.length > 1 ? undefined : 'TEAM',
              teamId: response.data && response.data.length === 1 ? response.data[0].id : undefined,
              teamName:
                response.data && response.data.length === 1 ? response.data[0].name : undefined,
            })
          })
          : this.setState({ accessType: 'PUBLIC' });
      } else {
        message.error(response.errorMessage);
      }
    }
  };

  calculateContainerDetails() {
    const { productDetails, containers, productDetailList, serviceType } = this.state;
    const { exportBehaviorEnabled, masterData } = this.props;
    const weightConversionMap = masterData?.weightConversionMap || {};
    const weightsUnits = masterData?.weightsUnits || [];

    // First pass: Check if any product for each container has invalid gross weight
    const containerHasInvalidGrossWeight = {};
    Object.keys(productDetails).forEach((key) => {
      const productDetail = productDetails[key];
      if (!productDetail?.key) return;
      
      const productUnit = productDetail?.unit || '';
      const isCasesUnit = productUnit.toLowerCase() === 'cases';
      // Use grossWeight stored in productDetail (not from productDetailList which gets reset on search)
      const grossWeight = productDetail?.grossWeight;
      const hasInvalidGrossWeight = isCasesUnit && (grossWeight === null || grossWeight === undefined || grossWeight === 0);
      
      if (hasInvalidGrossWeight) {
        const mapKey = `${productDetail?.productCnType?.trim()}_${productDetail?.productCnSize?.trim()}`;
        containerHasInvalidGrossWeight[mapKey] = true;
      }
    });

    const containerTotalsMapFromProducts = Object.keys(productDetails).reduce((acc, key) => {
      const productDetail = productDetails[key];
      if (!productDetail || !productDetail.key) {
        return acc
      }

      const fullProductData = productDetailList.find(p => p.key === productDetail?.key);
      const containerAndQuantityDetails = selectContainerDetailsByDispatchMode(
        fullProductData?.containerAndQuantityDetails || productDetail?.containerAndQuantityDetails || [],
        this.props.form.getFieldValue('dispatchMode')
      );

      if (Array.isArray(containerAndQuantityDetails) && containerAndQuantityDetails.length === 0){
        return acc
      }

      const givenProductQuantity = Number(productDetail?.quantity) || 0
      const productUnit = productDetail?.unit || '';
      const totalQuantityForProductInCnSize = containerAndQuantityDetails.find(
        (detail) =>
          detail.containerType === productDetail?.productCnType &&
          detail.containerSize === productDetail?.productCnSize
      )?.totalQuantity;

      const mapKey = `${productDetail?.productCnType?.trim()}_${productDetail?.productCnSize?.trim()}`

      if (!acc[mapKey]){
        acc[mapKey] = {
          totalContainerCount: 0,
          totalContainerWeight: 0,
          hasNullWeight: containerHasInvalidGrossWeight[mapKey] || false
        }
      }

      // Calculate weight in kg
      let weightInKg = 0;

      const isExportMovement = serviceType === 'export' && exportBehaviorEnabled
      const isCasesUnit = productUnit.toLowerCase() === 'cases';
      const grossWeight = productDetail?.grossWeight;
      
      if (isExportMovement && givenProductQuantity > 0) {
        // If this container type/size has any product with invalid gross weight, skip weight calculation
        if (containerHasInvalidGrossWeight[mapKey]) {
          acc[mapKey].totalContainerWeight = null;
        } else {
          // Only calculate if no products for this container have invalid gross weight
          const isWeightUnit = weightsUnits.some(unit => unit.toLowerCase() === productUnit.toLowerCase());

          if (isWeightUnit) {
            // Direct weight unit - convert to kg
            const conversionFactor = weightConversionMap[productUnit]?.['kg'] || 1;
            weightInKg = givenProductQuantity * conversionFactor;
          } else if (isCasesUnit && grossWeight) {
            // Cases unit - multiply by grossWeight and convert to kg
            const grossWeightUnit = productDetail?.grossWeightUnit || 'kg';
            const conversionFactor = weightConversionMap[grossWeightUnit]?.['kg'] || 1;
            weightInKg = givenProductQuantity * grossWeight * conversionFactor;
          } else {
            // Unknown unit - treat quantity as kg directly
            weightInKg = givenProductQuantity;
          }

          acc[mapKey].totalContainerWeight = (acc[mapKey].totalContainerWeight || 0) + weightInKg;
        }
      } else {
        // For non-export or when feature is disabled, use the old logic
        if (givenProductQuantity > 0){
          acc[mapKey].totalContainerWeight = (acc[mapKey]?.totalContainerWeight || 0) + givenProductQuantity
        }
      }

      // Container count calculation
      if (totalQuantityForProductInCnSize > 0) {
        let effectiveQuantity = givenProductQuantity;
        
        // For export with weight units, convert weight to cases using grossWeight
        // bcz we store the totalQuanitityForProductInCnSize as cases
        // so we need to convert the weight to cases to correctly calculate the container count
        if (isExportMovement) {
          const isWeightUnit = weightsUnits.some(unit => unit.toLowerCase() === productUnit.toLowerCase());
          if (isWeightUnit && grossWeight > 0) {
            const conversionFactor = weightConversionMap[productUnit]?.['kg'] || 1;
            effectiveQuantity = (givenProductQuantity * conversionFactor) / grossWeight;
          }
        }
        
        acc[mapKey].totalContainerCount = (acc[mapKey].totalContainerCount || 0) + (effectiveQuantity / totalQuantityForProductInCnSize);
      }
      return acc
    }, {} as Record<string, { totalContainerWeight: number | null; totalContainerCount: number; hasNullWeight?: boolean }>);

    return containerTotalsMapFromProducts
  }

  debouncedApplyCalculatedContainerCounts = debounce(() => {
    this.applyCalculatedContainerDetails()
  }, 300)

  /**
   * ISS-288612 §5: loose vs pallet variants of the same product have different
   * per-container quantities. When the dispatch mode changes, recompute the
   * container counts so the resolved quantities reflect the newly selected mode.
   * Reuses the debounced recompute, which runs after the Ant form store commits
   * the new dispatchMode value (read via getFieldValue in the calc).
   */
  refreshProductContainerDetailsForDispatchMode = () => {
    this.debouncedApplyCalculatedContainerCounts()
  }

  applyCalculatedContainerDetails(val?: any){
    const { inquiryFormPrefill, form, exportBehaviorEnabled } = this.props
    const { containers, serviceType } = this.state;

    if (!inquiryFormPrefill || val){
      return
    }

    const containerTotalsMap = this.calculateContainerDetails();
    const updates = {};

    Object.keys(containers).forEach((key) => {
      const containerTypeValue = form.getFieldValue(`type${key}`);
      const containerSizeValue = form.getFieldValue(`size${key}`);

      if (!containerTypeValue || !containerSizeValue){
        return
      }

      const containerTotalsMapKey = `${containerTypeValue?.trim()}_${containerSizeValue?.trim()}`;
      const fieldNames = {
            count: `count${key}`,
            weight: `weight${key}`,
      } 
      const currentCountVal = form.getFieldValue(fieldNames.count);
      const currentWeightVal = form.getFieldValue(fieldNames.weight);

      if (!containerTotalsMap[containerTotalsMapKey]){
        form.setFieldsValue({
          [`weight${key}`]: undefined,
          [`count${key}`]: 1
        })
        return 
      }

      const newCountValue = containerTotalsMap[containerTotalsMapKey].totalContainerCount
      const newWeightValue = containerTotalsMap[containerTotalsMapKey].totalContainerWeight
      const hasNullWeight = containerTotalsMap[containerTotalsMapKey].hasNullWeight

      const newCountValueRounded = Math.max(1, Math.ceil(newCountValue));
      // Round weight to 2 decimal places
      const newWeightValueRounded = newWeightValue !== null ? Number(newWeightValue) : null;
      
      if (currentCountVal !== newCountValueRounded) {
        updates[fieldNames.count] = newCountValueRounded;
      }
      
      // Handle weight updates based on whether it's export with enhanced behavior
      if (serviceType === 'export' && exportBehaviorEnabled) {
        // If weight is null (due to missing grossWeight), set to undefined to allow manual entry
        if (hasNullWeight || newWeightValueRounded === null) {
          if (currentWeightVal !== undefined) {
            updates[fieldNames.weight] = undefined;
          }
        } else {
          // Set calculated weight value
          if (currentWeightVal !== newWeightValueRounded) {
            updates[fieldNames.weight] = newWeightValueRounded;
          }
        }
      } else {
        // For non-export or disabled feature, use old behavior
        if (currentWeightVal !== newWeightValueRounded) {
          updates[fieldNames.weight] = newWeightValueRounded;
        }
      }
    });

    if (Object.keys(updates).length > 0) {
      form.setFieldsValue(updates);
    }

    // Re-validate all product container type & size fields when containers change
    const productKeys = Object.keys(this.state.productDetails || {});
    if (productKeys.length > 0) {
      const productCnFields = productKeys.flatMap(key => [`productCnType${key}`, `productCnSize${key}`]);
      form.validateFields(productCnFields, { force: true });
    }
  
  }

  loadAddresses = async () => {
    const inquiryId = this.props.match.params.inquiryId || this.props.bidData?.inquiryId;
    const inquiry = this.props.allInquiriesData.find((inq) => inq.id === inquiryId?.toString());
    const shipperId = this.isEditOrBookingInquiry() ?  inquiry?.shipperId : this.props.userData?.organisation_id;
    if (inquiry) this.setState({ shipperId: inquiry.shipperId });
    const stuffing = await fetchAddresses({ addressType: 'STUFFING', shipperId });
    if (stuffing.isSuccess) {
      this.setState({
        stuffingAddresses: stuffing.data?.filter((item) => !!item.address),
      });
    }
    const deStuffing = await fetchAddresses({ addressType: 'DESTUFFING', shipperId });
    if (stuffing.isSuccess) {
      this.setState({
        deStuffingAddresses: deStuffing.data?.filter((item) => !!item.address),
      });
    }
    const cfsAddresses = await fetchAddresses({
      addressType: 'DESTUFFING',
      locationList: [LocationPreferences.CFS],
      shipperId
    });
    this.setState({
      cfsAddresses: cfsAddresses.data?.filter((item) => !!item.address),
    });
  };

  setDisabledServices = (service: {[key: string]: string}, serviceSet: Set<string>) => {
    let disabledService;
    if (serviceSet.has(service.value)){
      disabledService = Object.assign({disabled: true}, service);
    }
    return disabledService ? disabledService : service
  }

  setAllowedServices = (value = undefined) => {
    const { masterData } = this.props;
    const allowedServices: any = [];
    const allowedServicesKey = CreateEnquiryFormConfig[value || this.getMode()]?.allowedServices;
    const originAllowedServices: Set<string> = new Set(this.props?.discoverRatesSelectedFilters?.originServices??[])
    const destinationAllowedServices: Set<string> = new Set(this.props?.discoverRatesSelectedFilters?.destinationServices??[])
    if (masterData[allowedServicesKey]) {
      Object.keys(masterData[allowedServicesKey]).map((item) => {
        const service = {
          value: masterData[allowedServicesKey][item],
          label: masterData[allowedServicesKey][item],
        }
        allowedServices.push(service);
      });
      this.setState({
        allowedServices,
        originAllowedServices: allowedServices.map(service => this.setDisabledServices(service, originAllowedServices)),
        destinationAllowedServices: allowedServices.map(service => this.setDisabledServices(service, destinationAllowedServices)),
      });
    }
  };

  isBookingFromSpot = () => {
    const { source } = this.state;
    return source === BookingSource.DIRECT_BOOKING || source === BookingSource.SPOT_BOOKING;
  };

  shouldContainerDisplay = (container) => {
    return container.size !== '' && container.type !== '' && container.count > 0;
  };

  disablePastDate = (current: any) => {
    return current && current < moment().endOf('day');
  };

  disableInquiryClosingDate = (current: any) => {
    let condition = disableInquiryClosingDateUtil(current);
    return (
      condition ||
      (this.state.preferredSailingRange?.[1] &&
        current &&
        current > this.state.preferredSailingRange[1].clone().endOf('day'))
    );
  };

  isEditInquiry = () => {
    return this.props.match.path.includes('edit');
  };

  isDuplicateInquiry = () => {
    return this.props.match.path.includes('createInquiry') && !!this.props.match.params?.inquiryId;
  };

  isEditOrBookingInquiry = () => {
    return this.props.match.path.includes('edit') || this.props.booking;
  };

  renderConfirmModal = () => {
    sendEvent(this.getInquiryGACategory(), `${this.getInquiryActionLabel()} - Submit`);
    return (
      <Modal
        title="Inquiry Confirmation"
        onOk={this.handleFormSubmit}
        closable={true}
        onCancel={this.closeConfirmModal}
        okText="Yes"
        cancelText="No"
        visible={this.state.createInquiryModalVisible}
      >
        <div style={{ marginTop: '10px', marginBottom: '10px' }}>
          {this.props.match.path.includes('edit')
            ? 'Do you want to edit this Inquiry ? '
            : 'Do you want to create this Inquiry ?'}
        </div>
      </Modal>
    );
  };

  closeConfirmModal = () => {
    this.setState({
      createInquiryModalVisible: false,
    });
    sendEvent(this.getInquiryGACategory(), 'Do you want to create this inquiry - no');
  };

  onCreateInquiryLoaderClose = () => {
    this.setState({
      creatingInquiry: false,
    });
  };

  throwGrossWeightError = (formData, key) => {
    const grossWeight = formData.packagingDetails[key].weight;
    const totalGrossWeight = formData.packagingDetails[key].totalWeight;

    if (!grossWeight && !totalGrossWeight) {
      return true;
    }

    if (
      (grossWeight && (grossWeight.value || grossWeight.value === 0)) ||
      (totalGrossWeight && (totalGrossWeight.value || totalGrossWeight.value === 0))
    ) {
      return false;
    }
    return true;
  };

  createDomesticApiObject = async (formData) => {
    const apiCallObject: any = {};
    const productDetails: any = [];
    const containerDetails: any = [];
    const originInchargeDetails = this.formatInchargeDetails([
      {
        name: formData?.originInchargeName,
        phone: formData?.originInchargePhone,
        email: formData?.originInchargeEmail,
      },
    ]);
    const destinationInchargeDetails = this.formatInchargeDetails([
      {
        name: formData?.destinationInchargeName,
        phone: formData?.destinationInchargePhone,
        email: formData?.destinationInchargeEmail,
      },
    ]);
    
    // Process productDetails for RPTL and DOMESTIC modes
    if (formData.mode === RPTL || formData.mode === DOMESTIC) {
      // Get all product detail keys from both state and form data to ensure we don't miss any
      const productDetailKeys = new Set([
        ...Object.keys(this.state.productDetails || {}),
        ...Object.keys(formData).filter(key => key.startsWith('productKey')).map(key => key.replace('productKey', ''))
      ]);

      productDetailKeys.forEach((item) => {
        const productDetail = this.state.productDetails?.[item];
        const productKeyField = formData[`productKey${item}`];

        // Handle both object (when labelInValue is true) and primitive values
        const productKeyId = productKeyField?.key || productKeyField;

        // Only add products that have a valid key selected (form value takes precedence)
        if (productKeyId) {
          // Find the full product details from productDetailList
          const fullProductDetails = this.state.productDetailList?.find(
            (prod) => prod.key === productKeyId || prod.key?.toString() === productKeyId?.toString()
          );

          productDetails.push({
            key: productKeyId, // This is the product ID
            quantity: formData[`productQuantity${item}`] || productDetail?.quantity,
            unit: formData[`productUnit${item}`] || productDetail?.unit,
            referenceNumber: productKeyField?.referenceNumber || fullProductDetails?.referenceNumber || productDetail?.referenceNumber,
            name: productKeyField?.value || fullProductDetails?.value || productDetail?.name,
            hsCode: fullProductDetails?.hsCode || productDetail?.hsCode,
            productCnType: formData[`productCnType${item}`] || productDetail?.productCnType,
            productCnSize: formData[`productCnSize${item}`] || productDetail?.productCnSize,
          });
        }
      });
      
      // Process packagingDetails for RPTL mode
      if (formData.packagingDetails && Array.isArray(formData.packagingDetails)) {
        formData.packagingDetails.forEach((packagingDetail) => {
          if (packagingDetail.count) {
            containerDetails.push(packagingDetail);
          }
        });
      }
      
      // Process containerDetails for RPTL mode if they exist
      if (formData.containerDetails && Array.isArray(formData.containerDetails)) {
        formData.containerDetails.forEach((containerDetail) => {
          if (containerDetail.count) {
            containerDetails.push(containerDetail);
          }
        });
      }
    }
    
    apiCallObject.mode = formData.mode === RPTL ? 'RPTL' : formData.mode; //FCL, LCL, AIRCARGO, DOMESTIC, RPTL

    const serviceType = formData.serviceType?.toUpperCase();
    if ((formData.mode === DOMESTIC || formData.mode === RPTL) && serviceType && ['EXPORT', 'IMPORT', 'TRADE'].includes(serviceType)) {
      apiCallObject.type = serviceType;
    } else {
      apiCallObject.type = formData.mode === RPTL ? DOMESTIC : formData.mode; //IMPORT, EXPORT, DOMESTIC
    }
    apiCallObject.shipperId = this.state.shipperId;
    apiCallObject.accessType = this.state.accessType;
    apiCallObject.teamId = this.state.teamId;
    apiCallObject.productId = formData.productObj?.key;

    const stuffingAddressId = typeof formData.stuffingAddress === 'object'
                              ? formData.stuffingAddress.key
                              : formData.stuffingAddress

    const deStuffingAddressId = typeof formData.deStuffingAddress === 'object'
                              ? formData.deStuffingAddress.key
                              : formData.deStuffingAddress
    
    apiCallObject.originLocationId = stuffingAddressId;
    apiCallObject.destinationLocationId = deStuffingAddressId;
    apiCallObject.origin = {
      inchargeDetails: originInchargeDetails,
    };
    apiCallObject.destination = {
      inchargeDetails: destinationInchargeDetails,
    };
    
    // For RPTL, use containerDetails from packagingDetails/containerDetails, otherwise use vehicleDetails
    if (formData.mode === RPTL && containerDetails.length > 0) {
      apiCallObject.containerDetails = containerDetails;
    } else {
      apiCallObject.containerDetails = formData.vehicleDetails?.filter(item => item.count);
    }
    apiCallObject.cargoType = formData.cargoType;
    apiCallObject.deadline = formData?.closingTime ? {
        dateString: moment(formData.closingTime).format('YYYY-MM-DD'),
        time: moment(formData.closingTime).format('HH:mm'),
      } : undefined;
    apiCallObject.preferredSailingRange = formData.preferredSailingRange[0] &&
    formData.preferredSailingRange[1] && [
      {
        dateString: moment(formData.preferredSailingRange[0]).format('YYYY-MM-DD'),
        time: moment(formData.preferredSailingRange[0]).format('23:59'),
      },
      {
        dateString: moment(formData.preferredSailingRange[1]).format('YYYY-MM-DD'),
        time: moment(formData.preferredSailingRange[1]).format('23:59'),
      },
    ];

    apiCallObject.termsAndConditions =
      formData.terms && !formData.terms.includes('\r\n')
        ? formData.terms.split('\n').join('\r\n')
        : formData.terms;

    apiCallObject.internalReferenceNumber = formData.internalReference;

    apiCallObject.referenceRate = { ...formData.referenceRate, basis: 'TOTAL' };

    apiCallObject.distance = isValidNumber(formData?.totalDistance?.value) ? formData.totalDistance : null;
    
    apiCallObject.businessType = formData?.businessType;

    apiCallObject.businessEntity = formData?.businessEntity;
    
    apiCallObject.extraDetails = formData?.extraDetails && !formData.extraDetails.includes('\r\n')
      ? formData.extraDetails.split('\n').join('\r\n')
      : formData.extraDetails;

    apiCallObject.productType = formData.product;
    apiCallObject.cargoReadyDate = formData?.cargoDate
      ? {
        dateString: moment(formData.cargoDate).format('YYYY-MM-DD'),
        time: moment(formData.cargoDate).format('23:59'),
      }
      : undefined;
    
    const docUrls: any = [];
    Object.keys(this.state.docs).map((item) => {
      if (this.state.docs[item].file.s3Link) {
        docUrls.push({
          name: this.state.docs[item].file.name,
          url: this.state.docs[item].file.s3Link,
          type: this.state.docs[item].type,
        });
      }
    });
    apiCallObject.temperatureControlled = formData.temperatureControlled;
    apiCallObject.documentUrls = docUrls;
    apiCallObject.stops = formData.stops?.map((stop) => ({address: stop?.address?.key, type: stop?.type}));
    apiCallObject.isHighValueInsuranceRequired = formData.isHighValueInsuranceRequired;
    apiCallObject.cargoValue = formData?.cargoValue?.amount !== undefined ? formData.cargoValue : undefined;
    apiCallObject.shipmentName = formData?.shipmentName;
    apiCallObject.requestor = formData?.requestor;
    apiCallObject.serviceLevel = formData?.serviceLevel;
    apiCallObject.typeOfContainer = formData?.typeOfContainer;
    apiCallObject.typeOfMovement = formData?.typeOfMovement;
    apiCallObject.isTiltable = formData?.isTiltable;
    apiCallObject.isDraft = formData?.isDraft;
    apiCallObject.isDraftIncomplete = formData?.isDraftIncomplete;
    apiCallObject.remarks = formData?.remarks;
    apiCallObject.stakeholderId = formData?.stakeholderId;
    apiCallObject.customerId = formData?.customerId;
    apiCallObject.dispatchMode = formData?.dispatchMode;

    // Add productList for RPTL and DOMESTIC modes
    if (formData.mode === RPTL || formData.mode === DOMESTIC) {
      apiCallObject.productList = productDetails;
    }
    if (formData.mode === RPTL) {
      // Add stackable if it exists
      if (CreateEnquiryFormConfig[RPTL].stackableVisible) {
        apiCallObject.stackable = formData.stackable;
      }
    }
    await this.handleApiCall(apiCallObject);
  };

  createTruckingApiObject = async (formData) => {
    const apiCallObject: any = {};
    apiCallObject.mode = formData.mode;
    apiCallObject.shipperId = this.state.shipperId;
    apiCallObject.origin = null;
    if ( formData.cargoDate && formData.closingTime && moment(formData.closingTime).diff(formData.cargoDate, 'seconds') > 0){
      message.error('Inquiry Closing Time cannot be later than Cargo Ready Date');
      return;
    }

    if (formData.trailerType === InquiryType.EXPORT) {
      const destination = JSON.parse(formData.dropOffPort?.key || '[]');
      apiCallObject.emptyContainerLocationId = JSON.parse(formData.pickupPort?.key || '[]')?.id;
      const stuffingAddressId = typeof formData.stuffingAddress === 'object'
                                ? formData.stuffingAddress?.key
                                : formData.stuffingAddress
  
      apiCallObject.originLocationId = stuffingAddressId;
      apiCallObject.destination = destination?.code ? {
        countryCode: destination?.countryCode,
        countryName: destination?.countryName,
        port: destination?.code,
      } : undefined;
    } else {
      const cfsLocationId = typeof formData.cfsLocation === 'object'
                            ? formData.cfsLocation?.key
                            : formData.cfsLocation
      
      const deStuffingAddressId = typeof formData.deStuffingAddress === 'object'
                                  ? formData.deStuffingAddress?.key
                                  : formData.deStuffingAddress
      
      apiCallObject.originLocationId = cfsLocationId;
      apiCallObject.destinationLocationId = deStuffingAddressId;
      apiCallObject.emptyContainerLocationId = JSON.parse(formData.dropOffPort?.key || '[]')?.id;
    }
    apiCallObject.type = formData.trailerType;
    apiCallObject.containerDetails = formData.vehicleDetails?.filter(item => item.count)?.map((item) => ({
      ...item,
      temperature:
        formData.cargoType.toUpperCase() === CargoType.REEFER ? formData.product : undefined,
    }));
    apiCallObject.cargoType = formData.cargoType ? formData.cargoType.toUpperCase() : undefined;
    apiCallObject.productType = formData.product;
    apiCallObject.cargoReadyDate = formData?.cargoDate
      ? {
        dateString: moment(formData.cargoDate).format('YYYY-MM-DD'),
        time: moment(formData.cargoDate).format('23:59'),
      }
      : null;
    apiCallObject.deadline = formData?.closingTime
      ? {
        dateString: moment(formData.closingTime).format('YYYY-MM-DD'),
        time: moment(formData.closingTime).format('HH:mm'),
      }
      : null;
    apiCallObject.preferredSailingRange = formData.preferredSailingRange[0] &&
      formData.preferredSailingRange[1] && [
        {
          dateString: moment(formData.preferredSailingRange[0]).format('YYYY-MM-DD'),
          time: moment(formData.preferredSailingRange[0]).format('23:59'),
        },
        {
          dateString: moment(formData.preferredSailingRange[1]).format('YYYY-MM-DD'),
          time: moment(formData.preferredSailingRange[1]).format('23:59'),
        },
      ];
    apiCallObject.carrierFreeDays = formData.carrierFreeDays;
    apiCallObject.referenceRate = isValidNumber(formData.referenceRate?.amount)
      ? {
        ...formData.referenceRate,
        basis: 'FREIGHT',
      }
      : null;
    apiCallObject.internalReferenceNumber = formData.internalReference;
    apiCallObject.termsAndConditions =
      formData.terms && !formData.terms.includes('\r\n')
        ? formData.terms.split('\n').join('\r\n')
        : formData.terms;
    apiCallObject.accessType = this.state.accessType;
    apiCallObject.teamId = this.state.teamId;
    apiCallObject.temperatureControlled = formData.temperatureControlled;
    apiCallObject.businessEntity = formData?.businessEntity;
    apiCallObject.businessType = formData?.trailerBusinessType;    
    apiCallObject.requiredDestinationFreeDays = formData.destinationFreeDays;
    apiCallObject.requiredOriginFreeDays = formData.originFreeDays;
    apiCallObject.isGensetRequired = formData?.isGensetRequired;
    apiCallObject.overWeight = formData?.overWeight;
    apiCallObject.shipmentName = formData?.shipmentName;
    apiCallObject.requestor = formData?.requestor;
    apiCallObject.serviceLevel = formData?.serviceLevel;
    apiCallObject.typeOfContainer = formData?.typeOfContainer;
    apiCallObject.typeOfMovement = formData?.typeOfMovement;
    apiCallObject.isTiltable = formData?.isTiltable;
    apiCallObject.isDraft = formData?.isDraft;
    apiCallObject.isDraftIncomplete = formData?.isDraftIncomplete;
    apiCallObject.remarks = formData?.remarks;
    await this.handleApiCall(apiCallObject);
  };

formatInchargeDetails = (inchargeDataArray) => {
  if (!Array.isArray(inchargeDataArray) || inchargeDataArray.length === 0) {
    return undefined;
  }
  
  const formattedContacts = inchargeDataArray
    .map(inchargeData => {
      const { name, phone, email } = inchargeData;
      if (name || phone || email) {
        return `${name || ''} ${phone || ''} ${email || ''}`.trim();
      }
      return null;
    })
    .filter(contact => contact !== null);
  
  return formattedContacts.length > 0 ? formattedContacts.join('; ') : undefined;
};

  createApiCallObject = async (formData) => {
    const { booking, masterData : { containerTypeSizeTempRange }, mandatoryFieldsInDraft } = this.props;
    const draftMandatoryFields = mandatoryFieldsInDraft?.[this.getMode()] || [];
    const isDraft = formData.isDraft;
    const countyList = this.props.masterData.countriesList;
    const apiCallObject: any = {};
    apiCallObject.mode = this.getMode();
    apiCallObject.type = formData.serviceType.toUpperCase();
    const containerDetails: any = [];
    const productDetails: any = [];
    const { pickupAndDrop, docs } = this.state;
    const searchUUID = localStorage.getItem('searchUUID');
    Object.keys(this.state.productDetails).map((item) => {
      const productDetail = this.state.productDetails[item];
      const productKey = formData[`productKey${item}`];
      
      // Only add products that have a valid key selected
      if (productDetail && productKey && productKey.key) {
        const mode = this.getMode();
        const includeContainerFields = ![InquiryModes.LCL, InquiryModes.AIRCARGO].includes(mode);
        productDetails.push({
          key: productKey.key, // This is the product ID
          quantity: formData[`productQuantity${item}`] || productDetail.quantity,
          unit: formData[`productUnit${item}`] || productDetail.unit,
          referenceNumber: productKey.referenceNumber || productDetail.referenceNumber,
          // Include other fields if needed by the API
          name: productKey.value || productDetail.name,
          hsCode: productDetail.hsCode,
          ...(includeContainerFields && {
            productCnType: formData[`productCnType${item}`] || productDetail.productCnType,
            productCnSize: formData[`productCnSize${item}`] || productDetail.productCnSize,
          }),
        });
      }
    });
    if (
      (pickupAndDrop === 'Door to Port' || pickupAndDrop === 'Door to Door') &&
      !formData.stuffingAddress
    ) {
      sendEvent(
        this.getInquiryGACategory(),
        `${this.getInquiryActionLabel()} - Failed (Data Validation)`
      );
      message.error('Please select origin address');
      return;
    }
    if (
      (pickupAndDrop === 'Port to Door' || pickupAndDrop === 'Door to Door') &&
      !formData.deStuffingAddress
    ) {
      sendEvent(
        this.getInquiryGACategory(),
        `${this.getInquiryActionLabel()} - Failed (Data Validation)`
      );
      message.error('Please select destination address');
      return;
    }
    if (
      !booking &&
      (!isDraft || (isDraft && formData.inquiryClosing)) &&
      moment(formData.inquiryClosing).diff(formData.preferredSailingRange[1], 'seconds') > 0
    ) {
      sendEvent(
        this.getInquiryGACategory(),
        `${this.getInquiryActionLabel()} - Failed (Data Validation)`
      );
      message.error('Inquiry closing date cannot be greater than sailing end date');
      return;
    }
    if (
      booking &&
      formData.preferredSailingRange[1] &&
      moment().endOf('day').diff(formData.preferredSailingRange[1], 'seconds') > 0
    ) {
      message.error('Booking can not be done after sailing end date');
      return;
    }
    const { packagingDetailsVisible, packageDimensions } = CreateEnquiryFormConfig[this.getMode()];
    if ( packagingDetailsVisible && !packageDimensions) {
      formData.packagingDetails.forEach(({ packageDimension }, index) => {
        if (!packageDimension.length && !packageDimension.breadth && !packageDimension.height) {
          delete formData.packagingDetails[index].packageDimension;
        }
      });
      for (const key in formData.packagingDetails) {
        if (CreateEnquiryFormConfig[this.getMode()].isAir) {
          if ((!isDraft || (isDraft && draftMandatoryFields?.includes('packagingDetails'))) && this.throwGrossWeightError(formData, key)) {
            sendEvent(
              this.getInquiryGACategory(),
              `${this.getInquiryActionLabel()} - Failed (Data Validation)`
            );
            message.error('Gross weight / Total Gross weight is required');
            return;
          }
          if (
            formData.packagingDetails[key].weight &&
            typeof formData.packagingDetails[key].weight.value === 'undefined'
          ) {
            delete formData.packagingDetails[key].weight;
          }
          if (formData.packagingDetails[key].hasOwnProperty('weight')) {
            delete formData.packagingDetails[key].totalWeight;
          }
          formData.packagingDetails[key].volume = {
            value: this.getMinVolume(key),
            unit: 'cbm',
          };
          formData.packagingDetails[key].volumetricWeight = {
            value: +(
              this.getTotalVolumetricWeight(key) / formData.packagingDetails[key].count
            ).toFixed(2),
            unit: 'kg',
          };
        }
        if (!isDraft || (isDraft && formData.packagingDetails[key].count)) {
          containerDetails.push(formData.packagingDetails[key]);
        }
      }
    } else {
      Object.keys(this.state.containers).map((item) => {
        if (formData[`count${item}`]) {
          containerDetails.push({
            type: formData[`type${item}`],
            count: formData[`count${item}`],
            size: formData[`size${item}`],
            temperature:
              formData[`type${item}`] === 'REFRIGERATED' &&
                formData.cargoType.toUpperCase() === CargoType.REEFER
                ? formData.product
                : undefined,
            weight: formData[`weight${item}`]
              ? {
                value: formData[`weight${item}`] ? formData[`weight${item}`] : undefined,
                unit: formData[`weightUnit${item}`] ? formData[`weightUnit${item}`] : undefined,
              }
              : undefined,
            ...(containerTypeSizeTempRange?.[`${formData[`type${item}`]} ${formData[`size${item}`]}`] &&
              { carriageTemperature: formData[`carriageTemperature${item}`] }
            ),
            ...(formData[`type${item}`] === 'OPEN_TOP' &&
              formData[`gauageCheckbox${item}`] && {
              packageDimension: {
                ...formData.packagingDetails[item]?.packageDimension,
              },
              volume: {
                value: this.getMinVolume(item),
                unit: 'cbm',
              },
            }),
          });
        }
      });
    }
    let originCountry;
    let destinationCountry;
    countyList.map((item) => {
      if (item.countryCode === this.state.originPortCountry) {
        originCountry = item.countryName;
      }
      if (item.countryCode === this.state.destinationPortCountry) {
        destinationCountry = item.countryName;
      }
    });
    const originAddress = this.state.stuffingAddresses.find(item => item.id === formData.stuffingAddress);
    if (originAddress){
      originAddress.displayAddress = `${originAddress.displayAddress} (${originAddress.referenceNumber})`;
    }
    const destinationAddress = this.state.deStuffingAddresses.find(item => item.id === formData.deStuffingAddress);
    if (destinationAddress){
      destinationAddress.displayAddress = `${destinationAddress.displayAddress} (${destinationAddress.referenceNumber})`;
    }
    apiCallObject.origin = {
      port: this.state.originPort,
      countryCode: this.state.originPortCountry,
      countryName: originCountry,
      address: originAddress?.displayAddress??'',
      location: formData.stuffingLocation,
      services: this.state.originServices,
      preferredWetPort: formData.originPreferredWetPort,
      stuffingDestuffingAddressId: formData.stuffingAddress?.key || formData.originStuffingAddress,
      stuffingDestuffingAddress: formData.stuffingAddress?.label,
      additionalDetails: formData.originDetails,
      haulage: formData.originHaulage,
      movementType: formData.originMovement,
      inchargeDetails: this.formatInchargeDetails(this.state.inchargeContactOrigin)

      };
    apiCallObject.destination = {
      port: this.state.destinationPort,
      countryCode: this.state.destinationPortCountry,
      countryName: destinationCountry,
      address: destinationAddress?.displayAddress??'',
      location: formData.deStuffingLocation,
      services: this.state.destinationServices,
      preferredWetPort: formData.destinationPreferredWetPort,
      stuffingDestuffingAddressId: formData.deStuffingAddress?.key || formData.destinationDeStuffingAddress,
      stuffingDestuffingAddress: formData.deStuffingAddress?.label,
      haulage: formData.destinationHaulage,
      movementType: formData.destinationMovement,
      additionalDetails: formData.destinationDetails,
       inchargeDetails: this.formatInchargeDetails(this.state.inchargeContactDestination)
  };
    apiCallObject.containerDetails = containerDetails;

    if ((!isDraft || (isDraft && draftMandatoryFields?.includes('cargoType'))) && !formData.cargoType) {
      message.error('Please select cargo Type !');
      return;
    }
    apiCallObject.cargoType = formData.cargoType?.toUpperCase();
    apiCallObject.cargoReadyDate = !isNullOrUndefined(formData.cargoReadyDate)
      ? {
        dateString: moment(formData.cargoReadyDate).format('YYYY-MM-DD'),
        time: moment(formData.cargoReadyDate).format('23:59'),
      }
      : null;
    apiCallObject.productType = formData.product;
    apiCallObject.incoterm = formData.incoterm;
    apiCallObject.incotermDetails = formData.incotermDetails;
    apiCallObject.businessEntity = formData.businessEntity;
    apiCallObject.deadline = booking
      ? undefined
      : !isDraft || (isDraft && formData.inquiryClosing) ? {
        dateString: moment(formData.inquiryClosing).format('YYYY-MM-DD'),
        time: moment(formData.inquiryClosing).format('HH:mm'),
      } : undefined;
    apiCallObject.pickupAndDrop = this.state.pickupAndDrop;
    apiCallObject.preferredSailingRange = formData.preferredSailingRange[0] &&
      formData.preferredSailingRange[1] && [
        {
          dateString: moment(formData.preferredSailingRange[0]).format('YYYY-MM-DD'),
          time: moment(formData.preferredSailingRange[0]).format('23:59'),
        },
        {
          dateString: moment(formData.preferredSailingRange[1]).format('YYYY-MM-DD'),
          time: moment(formData.preferredSailingRange[1]).format('23:59'),
        },
      ];
      
      if (this.getMode() === 'FCL' || this.getMode() === 'LCL') {
        apiCallObject.businessType = formData?.businessType;    
        apiCallObject.extraDetails = formData?.extraDetails && !formData.extraDetails.includes('\r\n')
          ? formData.extraDetails.split('\n').join('\r\n')
          : formData.extraDetails;
      }
    
    apiCallObject.termsAndConditions =
      formData.terms && typeof formData.terms === 'string' && !formData.terms.includes('\r\n')
        ? formData.terms.split('\n').join('\r\n')
        : formData.terms;
    apiCallObject.inquiryNumber = formData.referenceNumber;
    const docUrls: any = [];
    Object.keys(this.state.docs).map((item) => {
      if (this.state.docs[item].file.s3Link) {
        docUrls.push({
          name: this.state.docs[item].file.name,
          url: this.state.docs[item].file.s3Link,
          type: this.state.docs[item].type,
        });
      }
    });
    apiCallObject.documentUrls = docUrls;
    apiCallObject.preferredCarriers = this.state.preferredCarriers;
    formData.internalReferenceNumber
      ? (apiCallObject.internalReferenceNumber = formData.internalReferenceNumber)
      : null;
    if (CreateEnquiryFormConfig[this.getMode()].stackableVisible) {
      apiCallObject.stackable = formData.stackable;
    }
    apiCallObject.referenceRate = isValidNumber(formData.referenceRate?.amount)
      ? formData.referenceRate
      : null;
    apiCallObject.accessType = this.state.accessType;
    apiCallObject.teamId = this.state.teamId;
    apiCallObject.requiredDestinationFreeDays = formData.requiredDestinationFreeDays;
    apiCallObject.requiredOriginFreeDays = formData.requiredOriginFreeDays;
    apiCallObject.productList = productDetails;
    apiCallObject.searchUUID = this.fromDiscoverRates() ? searchUUID : undefined;
    apiCallObject.temperatureControlled = formData.temperatureControlled;
    apiCallObject.shipmentName = formData?.shipmentName;
    apiCallObject.requestor = formData?.requestor;
    apiCallObject.serviceLevel = formData?.serviceLevel;
    apiCallObject.typeOfMovement = formData?.typeOfMovement;
    apiCallObject.typeOfContainer = formData?.typeOfContainer;
    apiCallObject.isTiltable = formData?.isTiltable;
    apiCallObject.isDraft = formData?.isDraft;
    apiCallObject.isDraftIncomplete = formData?.isDraftIncomplete;
    apiCallObject.remarks = formData?.remarks;
    apiCallObject.shipperId = this.state.shipperId;
    apiCallObject.stakeholderId = formData?.stakeholderId;
    apiCallObject.customerId = formData?.customerId;
    apiCallObject.dispatchMode = formData?.dispatchMode;

    if (booking) {
      const cargoType = formData.cargoType.toUpperCase();
      if (
        (cargoType === CargoType.REEFER || cargoType === CargoType.HAZ) &&
        formData.mode === FCL
      ) {
        apiCallObject.productAdditionalDetails = {
          ...formData.productAdditionalDetails,
          ...(cargoType === CargoType.REEFER && {
            temperatureControlled:
              formData.productAdditionalDetails?.temperatureControlled ||
              formData.temperatureControlled,
          }),
        };
      }
      const bookingTeamsIds = Object.keys(this.state.bookingAccessTeams);
      if (bookingTeamsIds.length) {
        apiCallObject.teamIds = bookingTeamsIds;
      }
    }
    await this.handleApiCall(apiCallObject);
  };

  onProtipClose = async (send) => {
    if (send) {
      this.setState({
        showProtip: false,
        sendInquiryModalVisible: true,
      });
    } else {
      this.handleFormCancel();
    }
  };

  handleApiCall = async (apiCallObject) => {
    if (this.props.booking) {
      this.setState({ creatingBooking: true });
      await this.props.getBidRankingData(apiCallObject);
      this.setState({ creatingBooking: false });
      return;
    }
    const { match } = this.props;
    if (match.path.includes('edit')) {
      apiCallObject.inquiryId = match.params.inquiryId;
      const response: any = await updateInquiry(apiCallObject);
      if (response.isSuccess) {
        const inquiryData = {
          data: response.data,
          type: 'created',
        };
        if (inquiryData.data?.origin && inquiryData.data?.origin['originPortName']) {
          inquiryData.data.origin.originPortName = this.state.originPortName;
        }
        if (inquiryData.data?.destination && inquiryData.data?.destination['destinationPortName']) {
          inquiryData.data.destination.destinationPortName = this.state.destinationPortName;
        }
        this.setState({
          inquiryData,
          showProtip: true,
        });
      } else {
        message.error(response.errorMessage);
      }
    } else {
      if (!this.state.accessType) {
        sendEvent(
          this.getInquiryGACategory(),
          `${this.getInquiryActionLabel()} - Failed (Data Validation)`
        );
        message.error('Please Select Inquiry Access');
        return;
      }
      if (this.disableRatesSearchParams()) {
        this.props.setCreateInquiryData({ createInquiryData: apiCallObject });
        this.setState({ isFFSelectionModalVisible: true });
      } else {
        const response: any = await createInquiry(apiCallObject);
        if (response.isSuccess) {
          const inquiryData = {
            data: response.data,
            type: 'created',
          };
          if (inquiryData.data?.origin && inquiryData.data?.origin['originPortName']) {
            inquiryData.data.origin.originPortName = this.state.originPortName;
          }
          if (
            inquiryData.data?.destination &&
            inquiryData.data?.destination['destinationPortName']
          ) {
            inquiryData.data.destination.destinationPortName = this.state.destinationPortName;
          }
          this.setState({
            inquiryData,
            showProtip: true,
          });
        } else {
          sendEvent(this.getInquiryGACategory(), `${this.getInquiryActionLabel()} - Failed`);
          message.error(response.errorMessage);
        }
      }
    }
  };

  handleFormCancel = (showDiscoverScreen = true) => {
    const { modeList } = this.props;
    if (this.props.booking) {
      this.props.handleCancel();
      return;
    }
    const { location, history, match } = this.props;
    if (location?.state === 'detail') {
      history.push(getInquiryDetailRoute('shipper', match.params.inquiryId));
    } else if (this.fromDiscoverRates() && showDiscoverScreen) {
      history.push(getDiscoverRatesRoute('buy'));
    } else {
      history.push(getInquiryShipperRoute(isValidArray(modeList) ? `modeList=${modeList}` : ''));
    }
  };

  checkForErrors = () => {
    const form = this.props.form;
    const { isHazCargoDocumentsRequired, booking, mandatoryFieldsInDraft, customFieldsForInquiry } = this.props;
    const { containers, cargoReadyDate, preferredSailingRange, docs, productDetails } = this.state;
    const draftMandatoryFields = mandatoryFieldsInDraft?.[this.getMode()] || [];
    const isDraft = form.getFieldValue('isDraft')
    const stackable = form.getFieldValue('stackable')
    const isTiltable = form.getFieldValue('isTiltable')
    const newContainers = {};
    let totalContainerCount = 0;
    if (Object.keys(productDetails).length > 0) {
      for (const key in productDetails) {
        const product = productDetails[key];
        const productKey = form.getFieldValue(`productKey${key}`);
        const quantity = form.getFieldValue(`productQuantity${key}`);
        const unit = form.getFieldValue(`productUnit${key}`);
        
        // If any field is filled, all must be filled
        if (productKey?.key || quantity || unit) {
          if (!productKey?.key || !quantity || !unit) {
            message.error('Please fill all product details (name, count, and unit) for each product');
            return;
          }
        }
      }
    }
    const mode = this.getMode();
    const inquiryCustomFields = customFieldsForInquiry?.[mode] || {};
    const roadBased = [TRAILER, DOMESTIC, RPTL].includes(mode);
    const draftOriginReq = (isDraft && draftMandatoryFields?.includes('origin'));
    const draftDestinationReq = (isDraft && draftMandatoryFields?.includes('destination'));
    const allowVendorToSpecifyOrigin = this.props.inquiryConfig?.allowVendorToSpecifyOrigin;
    const originAddress = this.state.originAddress || form.getFieldValue('stuffingAddress');
    const originCountry = this.state.originCountry || this.state.originPortCountry;
    const allowVendorToSpecifyDestination = this.props.inquiryConfig?.allowVendorToSpecifyDestination;
    const destinationAddress = this.state.destinationAddress || form.getFieldValue('deStuffingAddress');
    const destinationCountry = this.state.destinationCountry || this.state.destinationPortCountry;

    if (!roadBased){
      if (!this.state.originPort && (!isDraft || draftOriginReq) && !allowVendorToSpecifyOrigin) {
        message.error("Origin Port can't be null");
        return;
      }
      if (allowVendorToSpecifyOrigin && !this.state.originPort && !(originAddress && originCountry)) {
        message.error("Either origin port or origin address are required");
        return;
      }
      if (!this.state.destinationPort && (!isDraft || draftDestinationReq) && !allowVendorToSpecifyDestination) {
        message.error("Destination Port can't be null");
        return;
      }
      if (allowVendorToSpecifyDestination && !this.state.destinationPort && !(destinationAddress && destinationCountry)) {
        message.error("Either destination port or destination address are required");
        return;
      }
      if (isDraft) {
        if (draftMandatoryFields?.includes('originPortCountry') && !this.state.originPortCountry) {
          message.error("Origin Country is required");
          return;
        }
        if (draftMandatoryFields?.includes('destinationPortCountry') && !this.state.destinationPortCountry) {
          message.error("Destination Country is required");
          return;
        }
      }
    }

    if (!isDraft){
      if (stackable === undefined && (mode === LCL || mode === AIRCARGO) ){
        message.error("Stackable is required");
        return
      }
      if (inquiryCustomFields?.isTiltable?.isMandatory &&  isTiltable === undefined && (mode === AIRCARGO)){
        message.error("Tiltable is required");
        return
      }
    }
    form.validateFieldsAndScroll(
      {
        force: true,
        scroll: {
          alignWithTop: true,
          offsetTop: 50,
          onlyScrollIfNeeded: false,
          allowHorizontalScroll: false,
        },
      },
      (err, val) => {
        if (err && Object.keys(err).length) {
          message.error('Please fill all required field');
          return;
        }
        if (val.cargoType === CargoType.HAZ && val.mode === 'FCL') {
          const hazRequiredDocuments = ['MSDS', 'IIP/UN CERTIFICATE'];
          const uploadedDocuments = Object.keys(docs)
            .filter((key) => !isEmpty(docs[key]?.file))
            .map((item) => docs[item]?.type);

          const missingDocuments = hazRequiredDocuments.filter(
            (item) => !uploadedDocuments.includes(item)
          );
          if (missingDocuments.length && ((!booking && isHazCargoDocumentsRequired) || booking)) {
            message.error(
              `${missingDocuments.join(', ')} ${missingDocuments.length > 1 ? 'are' : 'is'
              } required`
            );
            return;
          }
        }
        if (booking) {
          if (containers) {
            for (const key in containers) {
              totalContainerCount += containers[key].count;
            }
            if (totalContainerCount === 0) {
              message.error('Atleast one container count should be greater than 0');
              return;
            }
          }
          this.handleFormSubmit();
          return;
        }
        if (this.disableRatesSearchParams()) {
          this.handleFormSubmit();
          return;
        }
        this.setState({
          createInquiryModalVisible: true,
        });
      }
    );
  };

  handleFormSubmit = async () => {
    this.setState({
      creatingInquiry: true,
      createInquiryModalVisible: false,
    });
    this.props.form.validateFields(async (err, val) => {
      if (this.getMode() === TRAILER){
        await this.createTruckingApiObject(val);
      } else if (this.getMode() === DOMESTIC || this.getMode() === RPTL){
        await this.createDomesticApiObject(val);
      } else {
        await this.createApiCallObject(val);
      }
      this.setState({
        creatingInquiry: false,
      });

      !this.props.booking &&
        !this.isEditInquiry() &&
        !this.disableRatesSearchParams() &&
        sendEvent(this.getInquiryGACategory(), 'Do you want to create this inquiry - yes');
    });
  };

  getInquiryType = () => {
    const {
      form: { getFieldValue },
    } = this.props;
    return getFieldValue('serviceType')?.toUpperCase();
  };

  getTrailerType = () => {
    const {
      form: { getFieldValue },
    } = this.props;
    return getFieldValue('trailerType');
  };

  renderStackable = () => {
    const {
      form: { getFieldDecorator, getFieldValue },
      classes,
      booking,
      mandatoryFieldsInDraft,
    } = this.props;
    if (!CreateEnquiryFormConfig[this.getMode()].stackableVisible) return null;
    const isDraft = getFieldValue('isDraft');

    const isNullAllowed = !isDraft && getFieldValue('stackable') === null
    const isRequired = (isDraft && mandatoryFieldsInDraft?.[this.getMode()]?.includes('stackable')) || !isDraft || isNullAllowed;

    return (
      <div
        className={classes.rowDiv}
        style={{
          height: '30px',
          marginBottom: '8px',
        }}
      >
        <span className={classNames(classes.formTitles, classes.gridLabelWidth)} style={{ whiteSpace: 'nowrap'}}>
        {resolveFieldLabel('grid#stackable', 'Stackable', this.state.inquiryFieldLabelMap)}{isRequired ? <Asterisk /> : null}
        </span>
        <FormItem  style={{ marginBottom: '0px' }}>
          {getFieldDecorator('stackable', {
            initialValue: isRequired ? true : undefined,
          })(
            <RadioGroup>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
              <Radio value={null}>No Info</Radio>
            </RadioGroup>
          )}
        </FormItem>
      </div>
    );
  };

  handleDimensionChange = (
    key,
    l: any = undefined,
    b: any = undefined,
    h: any = undefined,
    unit: any = undefined
  ) => {
    if (this.getMode() !== LCL && this.getMode() !== AIRCARGO) {
      return;
    }
    const {
      form: { getFieldValue, setFieldsValue },
      masterData: { volumeConverterMap },
    } = this.props;
    const length = l || getFieldValue(`packagingDetails[${key}].packageDimension.length`);
    const breadth = b || getFieldValue(`packagingDetails[${key}].packageDimension.breadth`);
    const height = h || getFieldValue(`packagingDetails[${key}].packageDimension.height`);
    const lengthUnit = unit || getFieldValue(`packagingDetails[${key}].packageDimension.unit`);
    const volUnit = getFieldValue(`packagingDetails[${key}].volume.unit`);
    const conversionFactor =
      volumeConverterMap[lengthUnit] &&
      volumeConverterMap[lengthUnit][volUnit] &&
      volumeConverterMap[lengthUnit][volUnit];
    const newVol =
      length && length > 0 && breadth && breadth > 0 && height && height > 0 && conversionFactor
        ? length * breadth * height * conversionFactor
        : undefined;

    const type = getFieldValue(`packagingDetails[${key}].type`);
    const isDrumOrRoll = type === 'DRUM' || type === 'ROLL';
    isDrumOrRoll
      ? setFieldsValue({
        [`packagingDetails[${key}].packageDimension.breadth`]: length,
        [`packagingDetails[${key}].volume.value`]: newVol ? +newVol : undefined,
      })
      : setFieldsValue({
        [`packagingDetails[${key}].volume.value`]: newVol ? +newVol : undefined,
      });
  };

  handleVolumeChange = (key, unit: any = undefined, val: any = undefined) => {
    const {
      form: { getFieldValue, setFieldsValue },
      masterData: { volumeConverterMap },
    } = this.props;
    if (unit) {
      const length = getFieldValue(`packagingDetails[${key}].packageDimension.length`);
      const breadth = getFieldValue(`packagingDetails[${key}].packageDimension.breadth`);
      const height = getFieldValue(`packagingDetails[${key}].packageDimension.height`);
      const lengthUnit = getFieldValue(`packagingDetails[${key}].packageDimension.unit`);
      const conversionFactor =
        volumeConverterMap[lengthUnit] && volumeConverterMap[lengthUnit][unit];
      const newVol =
        length && length > 0 && breadth && breadth > 0 && height && height > 0 && conversionFactor
          ? length * breadth * height * conversionFactor
          : undefined;
      if (isValidNumber(newVol)) {
        setFieldsValue({
          [`packagingDetails[${key}].volume.value`]: newVol,
        });
      }
    } else if (val !== getFieldValue(`packagingDetails[${key}].volume.value`)) {
      setFieldsValue({
        [`packagingDetails[${key}].packageDimension.breadth`]: undefined,
        [`packagingDetails[${key}].packageDimension.length`]: undefined,
        [`packagingDetails[${key}].packageDimension.height`]: undefined,
      });
    }
  };

  getTotalGrossWeight = (key) => {
    const {
      form: { getFieldValue },
    } = this.props;
    const grossWeight = getFieldValue(`packagingDetails[${key}].weight.value`);
    const quantity = this.getMode() === LCL ? 1 : getFieldValue(`packagingDetails[${key}].count`);
    const unit = getFieldValue(`packagingDetails[${key}].weight.unit`);
    return grossWeight || grossWeight === 0
      ? `${grossWeight && (grossWeight * quantity).toFixed(2)} ${unit}`
      : undefined;
  };

  getTotalGrossWeightLCL = (key) => {
    const {
      form: { getFieldValue },
    } = this.props;
    const grossWeight = getFieldValue(`packagingDetails[${key}].weight.value`) || 0;
    const quantity = getFieldValue(`packagingDetails[${key}].count`) || 0;
    const unit = getFieldValue(`packagingDetails[${key}].weight.unit`);
    return `${(grossWeight * quantity).toFixed(2)} ${unit}`;
  };

  getTotalVolume = (key) => {
    const {
      form: { getFieldValue },
      masterData: { volumeConverterMap },
      discoverRatesSearchFilters
    } = this.props;
    const { totalVolume } = discoverRatesSearchFilters;
    const length = getFieldValue(`packagingDetails[${key}].packageDimension.length`);
    const breadth = getFieldValue(`packagingDetails[${key}].packageDimension.breadth`);
    const height = getFieldValue(`packagingDetails[${key}].packageDimension.height`);
    const lengthUnit = getFieldValue(`packagingDetails[${key}].packageDimension.unit`);
    const conversionFactor =
      volumeConverterMap[lengthUnit] && volumeConverterMap[lengthUnit].cbm;
    const newVol =
      length && length > 0 && breadth && breadth > 0 && height && height > 0 && conversionFactor
        ? length * breadth * height * conversionFactor
        : undefined;
    if (!newVol && totalVolume?.value && (this.isBookingFromSpot() || this.fromDiscoverRates())){
      const quantity = getFieldValue(`packagingDetails[${key}].count`) || 1;
      return totalVolume?.value/quantity;
    }      
    return newVol;
  };

  getCalculatedTotalVolume = (key) => {
    const {
      form: { getFieldValue },
    } = this.props;
    const volume = getFieldValue(`packagingDetails[${key}].volume.value`);
    const quantity = getFieldValue(`packagingDetails[${key}].count`) || 1;
    const unit = getFieldValue(`packagingDetails[${key}].volume.unit`);
    return volume ? `${(volume * quantity).toFixed(2)} ${unit}` : undefined;
  }

  getTotalVolumetricWeight = (key) => {
    const {
      form: { getFieldValue },
    } = this.props;
    const newVol = this.getTotalVolume(key);
    const quantity = getFieldValue(`packagingDetails[${key}].count`);
    const volWeight = newVol
      ? (newVol * 1000000) / VOLUMETRIC_WT_DENOMINATOR
      : undefined;
    return volWeight ? +(volWeight * quantity).toFixed(2) : 0;
  };

  getMinVolume = (key) => {
    const {
      form: { getFieldValue, setFieldsValue },
      masterData: { volumeConverterMap },
      discoverRatesSearchFilters
    } = this.props;
    const { totalVolume } = discoverRatesSearchFilters;
    const length = getFieldValue(`packagingDetails[${key}].packageDimension.length`);
    const breadth = getFieldValue(`packagingDetails[${key}].packageDimension.breadth`);
    const height = getFieldValue(`packagingDetails[${key}].packageDimension.height`);
    const lengthUnit = getFieldValue(`packagingDetails[${key}].packageDimension.unit`);
    const quantity = getFieldValue(`packagingDetails[${key}].count`) || 1;
    const conversionFactor =
      volumeConverterMap[lengthUnit] &&
      volumeConverterMap[lengthUnit].cbm &&
      volumeConverterMap[lengthUnit].cbm;
    const minVolume =
      length && length > 0 && breadth && breadth > 0 && height && height > 0 && conversionFactor
        ? length * breadth * height * conversionFactor
        : undefined;
    if (!minVolume && totalVolume?.value){
      return +(((totalVolume?.value ?? 0) / quantity)?.toFixed(2));
    }
    return minVolume ? +minVolume.toFixed(2) : 0;
  };

  renderLBHUnit = (key, showLabel = false) => {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      classes,
      booking,
      masterData: { lengthUnits, weightsUnits, volumeUnits },
      discoverRatesSearchFilters
    } = this.props;
    const { packagingDetailsKeys } = this.state;
    const formConfig = CreateEnquiryFormConfig[this.getMode()];
    const packageTypes = this.props.masterData[formConfig.packageType];

    const type = getFieldValue(`packagingDetails[${key}].type`);
    const isDrumOrRoll = type === 'DRUM' || type === 'ROLL';

    if (
      !CreateEnquiryFormConfig[this.getMode()].packagingDetailsVisible &&
      getFieldValue(`type${key}`) !== 'OPEN_TOP' &&
      !getFieldValue(`gauageCheckbox${key}`)
    )
      return null;
    const disabledFields = this.getMode() !== 'FCL' && booking;
    return (
      <React.Fragment>
        <Input.Group compact>
          <div style={{ marginBottom: '0px', width: '23%', marginRight: '3px' }}>
            {showLabel && (
              <div className={classNames(classes.formTitles, classes.containerTitle)}>Length</div>
            )}
            <FormItem className={classes.formItemSmallError}>
              {getFieldDecorator(`packagingDetails[${key}].packageDimension.length`, {
                initialValue: this.disableRatesSearchParams() && discoverRatesSearchFilters?.length || undefined,
                rules: [
                  { required: (!!formConfig.dimensionsMandatory && (!this.props.booking && !this.fromDiscoverRates)) || showLabel, message: 'Required' },
                ],
              })(
                <InputNumber
                  disabled={this.disableRatesSearchParams() || disabledFields}
                  placeholder="Length"
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  onChange={(val) => this.handleDimensionChange(key, val)}
                />
              )}
            </FormItem>
          </div>
          <div style={{ marginBottom: '0px', width: '23%', marginRight: '3px' }}>
            {showLabel && (
              <div className={classNames(classes.formTitles, classes.containerTitle)}>Breadth</div>
            )}
            <FormItem className={classes.formItemSmallError}>
              {getFieldDecorator(`packagingDetails[${key}].packageDimension.breadth`, {
                initialValue: this.disableRatesSearchParams() && discoverRatesSearchFilters?.breadth || undefined,
                rules: [
                  { required: (!!formConfig.dimensionsMandatory && (!this.props.booking && !this.fromDiscoverRates)) || showLabel, message: 'Required' },
                ],
              })(
                <InputNumber
                  disabled={isDrumOrRoll || this.disableRatesSearchParams() || disabledFields}
                  placeholder="Breadth"
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  onChange={(val) => this.handleDimensionChange(key, undefined, val)}
                />
              )}
            </FormItem>
          </div>
          <div style={{ marginBottom: '0px', width: '23%', marginRight: '3px' }}>
            {showLabel && (
              <div className={classNames(classes.formTitles, classes.containerTitle)}>Height</div>
            )}
            <FormItem className={classes.formItemSmallError}>
              {getFieldDecorator(`packagingDetails[${key}].packageDimension.height`, {
                initialValue: this.disableRatesSearchParams() && discoverRatesSearchFilters?.height || undefined,
                rules: [
                  { required: (!!formConfig.dimensionsMandatory && (!this.props.booking && !this.fromDiscoverRates)) || showLabel, message: 'Required' },
                ],
              })(
                <InputNumber
                  disabled={this.disableRatesSearchParams() || disabledFields}
                  placeholder="Height"
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  onChange={(val) => this.handleDimensionChange(key, undefined, undefined, val)}
                />
              )}
            </FormItem>
          </div>
          <div style={{ marginBottom: '0px', width: '23%', marginRight: '10px' }}>
            {showLabel && (
              <div className={classNames(classes.formTitles, classes.containerTitle)}>Unit</div>
            )}
            <FormItem className={classes.formItemSmallError}>
              {getFieldDecorator(`packagingDetails[${key}].packageDimension.unit`, {
                initialValue: discoverRatesSearchFilters?.dimensionUnit || 'cm',
                rules: [
                  {
                    required: (!!formConfig.dimensionsMandatory && !this.fromDiscoverRates()) || !disabledFields || showLabel,
                    message: 'Required',
                  },
                ],
              })(
                <Select
                  disabled={disabledFields || this.disableRatesSearchParams()}
                  placeholder="Unit"
                  allowClear={false}
                  style={{ width: '100%' }}
                  onChange={(val) =>
                    this.handleDimensionChange(key, undefined, undefined, undefined, val)
                  }
                >
                  {lengthUnits?.map((unit) => (
                    <Select.Option key={unit} value={unit}>{unit}</Select.Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </div>
        </Input.Group>
      </React.Fragment>
    );
  };

  renderCloseIcon = (key) => {
    return key > 0 ? (
      <Icon
        type="close"
        style={{ cursor: 'pointer', color: 'red' }}
        onClick={() => {
          this.setState(({ packagingDetailsKeys }) => ({
            packagingDetailsKeys: packagingDetailsKeys.filter((k) => k !== key),
          }));
        }}
      />
    ) : null
  }

  isSpotInquiryOrBooking = () => {
    return this.disableRatesSearchParams() || this.isBookingFromSpot();
  }

  filterTeams = (teams) => {
    // if editing or booking then filter based on shipper_id 
    // (ensures parent orgs only see teams from the shipper org of the inquiry being edited/booked)
    if (this.isEditOrBookingInquiry()) {
      return teams.filter(team => team.organisation_id === this.state.shipperId);
    }
    // else only show teams from the same organisation
    return teams.filter(team => team.organisation_id === this.state.organisationId);
  }

  renderPackagingDetails = () => {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      classes,
      booking,
      masterData: { lengthUnits, weightsUnits, volumeUnits },
      discoverRatesSearchFilters,
      mandatoryFieldsInDraft
    } = this.props;
    const { packagingDetailsKeys, packagingDetails } = this.state;
    const isDraft = getFieldValue('isDraft');
    const formConfig = CreateEnquiryFormConfig[this.getMode()];
    const packageTypes = this.props.masterData[formConfig.packageType];
    if (!CreateEnquiryFormConfig[this.getMode()].packagingDetailsVisible) return null;
    const disabledFields = this.getMode() !== 'FCL' && booking;
    const isFCl = this.getMode() === 'FCL';
    const isRequired = (isDraft && mandatoryFieldsInDraft?.[this.getMode()]?.includes('packagingDetails')) || !isDraft;
    return (
      <Row
        gutter={24}
        style={{
          marginBottom: '25px',
          marginRight: '10px',
          verticalAlign: 'middle',
        }}
      >
        <Col span={3}>
          <span
            className={classes.formTitles}
            style={{
              whiteSpace: 'nowrap',
              display: 'flex',
              flexDirection: 'column',
              lineHeight: 'unset',
            }}
          >
            <span> {resolveFieldLabel('grid#packagingDetails', 'Packaging Details', this.state.inquiryFieldLabelMap)}{isRequired ? <Asterisk /> : null}</span>
            <span style={{ color: '#262626', fontSize: '9px' }}>(Dimensions are per package)</span>
          </span>
        </Col>
        <Col span={21}>
          <Row gutter={10}>
            <Col span={2} style={{ paddingLeft: '5px' }}>
              Quantity
            </Col>
            <Col span={2}>Type{isRequired ? <Asterisk /> : null}</Col>
            <Col span={7}>
              <div style={{ width: '22%', display: 'inline-block', marginRight: '3px' }}>
                Length
                {formConfig.isAir && isRequired ? <Asterisk /> : null}
              </div>
              <div style={{ width: '22%', display: 'inline-block', marginRight: '3px' }}>
                Breadth
                {formConfig.isAir && isRequired ? <Asterisk /> : null}
              </div>
              <div style={{ width: '22%', display: 'inline-block', marginRight: '3px' }}>
                Height
                {formConfig.isAir && isRequired ? <Asterisk /> : null}
              </div>
              <div style={{ width: '22%', display: 'inline-block' }}>Unit</div>
            </Col>
            {(this.getMode() === LCL || this.getMode() === RPTL) && (
              <Col span={4}>
                <div style={{ width: '57%', display: 'inline-block' }}>Min Volume{isRequired ? <Asterisk /> : null}</div>
                <div style={{ width: '35%', display: 'inline-block' }}>Unit</div>
              </Col>
            )}
            <Col span={4}>
              <div style={{ width: '57%', display: 'inline-block' }}>Gross Weight{isRequired ? <Asterisk /> : null}</div>
              <div style={{ width: '35%', display: 'inline-block' }}>Unit</div>
            </Col>
            {formConfig.isAir ? (
              <Col span={4}>
                <div style={{ width: '57%', display: 'inline-block' }}>Total Gross Wt</div>
                <div style={{ width: '35%', display: 'inline-block' }}>Unit</div>
              </Col>
            ) : (
              <Col span={3} style={{ textAlign: 'center', marginRight: '-15px' }}>
                <div style={{ display: 'inline-block', fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px` }}>
                  Total Gross Wt
                </div>
              </Col>
            )}
            {formConfig.isAir ? (
              <Col span={4} style={{ textAlign: 'center' }}>
                <div style={{ display: 'inline-block', fontStyle: 'italic', fontSize: `${tokens.fontSize.body}px` }}>
                  Total Volumetric wt{isRequired ? <Asterisk /> : null}
                </div>
              </Col>
            ) : null}
            {(this.getMode() === LCL || this.getMode() === RPTL) && (
              <Col span={2} style={{ textAlign: 'center', marginRight: '-15px' }}>
                <div style={{ display: 'inline-block', fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px` }}>
                  Total Volume
               </div>
              </Col>
            )}
          </Row>
          {packagingDetailsKeys.map((key) => {
            return (
              <React.Fragment>
              <Row key={key} gutter={10}>
                <Col span={2}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`packagingDetails[${key}].count`, {
                      initialValue: this.disableRatesSearchParams() && discoverRatesSearchFilters?.count || isRequired ? 1 : undefined,
                      rules: [{ required: isRequired && !isFCl, message: 'required' }],
                    })(
                      <InputNumber
                        placeholder="Count"
                        style={{ width: '100%' }}
                        min={1}
                        type="number"
                        precision={0}
                        disabled={
                          getFieldValue(`packagingDetails[${key}].packageDimension.length`) &&
                          (this.isBookingFromSpot() || discoverRatesSearchFilters?.count)
                        }
                        onChange={(val: any) => {
                          const grossWeight = getFieldValue(
                            `packagingDetails[${key}].weight.value`
                          );
                          if (this.getMode() === AIRCARGO && typeof grossWeight !== 'undefined' && !this.isSpotInquiryOrBooking()) {
                            setFieldsValue({
                              [`packagingDetails[${key}].totalWeight.value`]:
                                val && grossWeight ? val * grossWeight : undefined,
                            });
                          }
                          if (this.isBookingFromSpot()) {
                            setFieldsValue({
                              [`packagingDetails[${key}].weight.value`]:
                                (val && packagingDetails?.[key]?.weight) ? (packagingDetails?.[key]?.weight?.value / val): undefined,
                            });
                            setFieldsValue({
                              [`packagingDetails[${key}].volume.value`]:
                                (val && packagingDetails?.[key]?.volume) ? (packagingDetails?.[key]?.volume?.value / val): undefined,
                            });
                          }
                        }}
                      />
                    )}
                  </FormItem>
                </Col>
                <Col span={2}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`packagingDetails[${key}].type`, {
                      rules: [{ required: isRequired && !isFCl, message: 'required' }],
                    })(
                      <Select
                        placeholder="Type"
                        style={{ width: '100%' }}
                        onChange={(val) => {
                          const isDrumOrRoll = val === 'DRUM' || val === 'ROLL';
                          const len = getFieldValue(
                            `packagingDetails[${key}].packageDimension.length`
                          );
                          isDrumOrRoll &&
                            setFieldsValue({
                              [`packagingDetails[${key}].packageDimension.breadth`]: len,
                            });
                        }}
                      >
                        {packageTypes &&
                          Object.keys(packageTypes).map((key) => (
                            <Select.Option key={key} value={key}>{packageTypes[key]}</Select.Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={7}>{this.renderLBHUnit(key)}</Col>
                {(this.getMode() === LCL || this.getMode() === RPTL) && (
                  <Col span={4}>
                    <Input.Group compact>
                      <FormItem style={{ marginBottom: '0px', width: '55%', marginRight: '3px' }}>
                        {getFieldDecorator(`packagingDetails[${key}].volume.value`, {
                          initialValue: this.disableRatesSearchParams() ?
                            ((discoverRatesSearchFilters?.totalVolume?.value ?? 0 ) / (getFieldValue(`packagingDetails[${key}].count`)|| 1))
                            : undefined,
                          rules: [{ required: !formConfig.isAir && isRequired, message: 'required' }],
                        })(
                          <InputNumber
                            type="number"
                            placeholder="Min Volume"
                            style={{ width: '100%' }}
                            min={0}
                            onChange={(val) => this.handleVolumeChange(key, undefined, val)}
                            disabled={formConfig.isAir || this.isSpotInquiryOrBooking()}
                          />
                        )}
                      </FormItem>
                      <FormItem style={{ marginBottom: '0px', width: '35%' }}>
                        {getFieldDecorator(`packagingDetails[${key}].volume.unit`, {
                          initialValue: discoverRatesSearchFilters?.totalVolume?.unit || 'cbm',
                          rules: [{ required: !disabledFields && isRequired, message: 'required' }],
                        })(
                          <Select
                            placeholder="Unit"
                            allowClear={false}
                            style={{ width: '100%' }}
                            onChange={(val) => this.handleVolumeChange(key, val)}
                            disabled={this.isSpotInquiryOrBooking()}
                          >
                            {volumeUnits &&
                              volumeUnits.map((unit) => (
                                <Select.Option key={unit} value={unit}>{unit}</Select.Option>
                              ))}
                          </Select>
                        )}
                      </FormItem>
                    </Input.Group>
                  </Col>
                )}
                <Col span={4}>
                  <Input.Group compact>
                    <FormItem style={{ marginBottom: '0px', width: '55%', marginRight: '3px' }}>
                      {getFieldDecorator(`packagingDetails[${key}].weight.value`, {
                        ...((this.getMode() === LCL || this.getMode() === AIRCARGO || this.getMode() === RPTL) && {
                          initialValue: this.disableRatesSearchParams() ?
                          ((discoverRatesSearchFilters?.grossWeight?.value ?? 0 ) / (getFieldValue(`packagingDetails[${key}].count`)|| 1))
                          : undefined,
                          rules: [{ required: isRequired, message: 'required' }],
                        }),
                      })(
                        <InputNumber
                          type="number"
                          disabled={this.isSpotInquiryOrBooking()}
                          placeholder="Gross Weight"
                          style={{ width: '100%' }}
                          min={0}
                          onChange={(val: any) => {
                            if (this.getMode() === AIRCARGO) {
                              const count = getFieldValue(`packagingDetails[${key}].count`);
                              setFieldsValue({
                                [`packagingDetails[${key}].totalWeight.value`]: val
                                  ? count * val
                                  : undefined,
                              });
                            }
                          }}
                        />
                      )}
                    </FormItem>
                    <FormItem style={{ marginBottom: '0px', width: '35%' }}>
                      {getFieldDecorator(`packagingDetails[${key}].weight.unit`, {
                        initialValue: discoverRatesSearchFilters?.grossWeight?.unit || 'kg',
                        ...((this.getMode() === LCL || this.getMode() === RPTL) && {
                          rules: [{ required: !disabledFields && isRequired, message: 'required' }],
                        }),
                      })(
                        <Select
                          placeholder="Unit"
                          onChange={(val) => {
                            setFieldsValue({
                              [`packagingDetails[${key}].totalWeight.unit`]: val,
                            });
                          }}
                          disabled={this.isSpotInquiryOrBooking()}
                          allowClear={false}
                          style={{ width: '100%' }}
                        >
                          {weightsUnits &&
                            weightsUnits.map((unit) => {
                              // Skipping "cases" unit as it is required only in containerUnits
                              if (EXCLUDED_WEIGHT_UNITS.includes(unit)) {
                                return null;
                              } else {
                                return (
                                  <Select.Option key={unit} value={unit}>{unit}</Select.Option>
                                );
                              }
                            })}
                        </Select>
                      )}
                    </FormItem>
                  </Input.Group>
                </Col>
                {formConfig.isAir ? (
                  <Col span={4}>
                    <Input.Group compact>
                      <FormItem style={{ marginBottom: '0px', width: '55%', marginRight: '3px' }}>
                        {getFieldDecorator(`packagingDetails[${key}].totalWeight.value`, {
                          initialValue: this.disableRatesSearchParams() ?
                          (discoverRatesSearchFilters?.grossWeight?.value ?? 0 ) : this.getTotalGrossWeight(key),
                        })(
                          <InputNumber
                            placeholder="Total Gross Weight"
                            onChange={(val) => {
                              setFieldsValue({
                                [`packagingDetails[${key}].weight.value`]: undefined,
                              });
                            }}
                            style={{ width: '100%' }}
                            min={0}
                            type="number"
                            disabled={this.isSpotInquiryOrBooking()}
                          />
                        )}
                      </FormItem>
                      <FormItem style={{ marginBottom: '0px', width: '35%' }}>
                        {getFieldDecorator(`packagingDetails[${key}].totalWeight.unit`, {
                          initialValue: discoverRatesSearchFilters?.grossWeight?.unit || 'kg',
                        })(
                          <Select
                            placeholder="Unit"
                            allowClear={false}
                            style={{ width: '100%' }}
                            disabled={this.isSpotInquiryOrBooking()}
                          >
                            {weightsUnits &&
                              weightsUnits.map((unit) => {
                                // Skipping "cases" unit as it is required only in containerUnits
                                if (EXCLUDED_WEIGHT_UNITS.includes(unit)) {
                                  return null;
                                } else {
                                  return (
                                    <Select.Option key={unit} value={unit}>{unit}</Select.Option>
                                  );
                                }
                              })}
                          </Select>
                        )}
                      </FormItem>
                    </Input.Group>
                  </Col>
                ) : (
                  <>
                    <Col span={3} style={{ marginRight: '-15px' }}>
                      <div style={{ textAlign: 'center', marginTop: '8px' }}>
                        {this.getTotalGrossWeightLCL(key)}
                      </div>
                    </Col>
                    {(this.getMode() === LCL || this.getMode() === RPTL) && (
                      <Col span={2} style={{ marginRight: '-15px' }}>
                        <div style={{ textAlign: 'center', marginTop: '8px' }}>
                          {this.getCalculatedTotalVolume(key)}
                        </div>
                      </Col>
                    )}
                  </>
                )}
                {formConfig.isAir ? (
                  <Col span={4}>
                    <div style={{ textAlign: 'center', marginTop: '8px' }}>
                      {`${this.getTotalVolumetricWeight(key)} kg`}
                    </div>
                  </Col>
                ) : null}
                {(this.getMode() === LCL || this.getMode() === RPTL) ? <div style={{ paddingTop: '8px', position: 'absolute', right: '-14px' }}>
                  {this.renderCloseIcon(key)}
                </div> : <Col span={1} style={{ paddingTop: '8px' }}>
                  {this.renderCloseIcon(key)}
                </Col>}
              </Row>
              {getFieldValue(`packagingDetails[${key}].type`) === 'OTHER' && (
                <Row gutter={10} style={{ position: 'relative', top: '-16px'}}>
                  <Col span={7}>
                    <FormItem style={{ marginBottom: '0px' }}>
                      {getFieldDecorator(`packagingDetails[${key}].otherType`, {
                        initialValue: packagingDetails?.[key]?.otherType || '',
                      })(
                        <Input
                          placeholder="Other Type"
                          disabled={this.disableRatesSearchParams() || disabledFields}
                        />
                      )}
                    </FormItem>
                  </Col>
                </Row>
              )}
              </React.Fragment>
            );
          })}
            
          {!disabledFields && !this.disableRatesSearchParams() && <Row>
            <Col style={{ paddingTop: '10px' }}>
              <a
                type="plus-circle"
                style={{
                  cursor: 'pointer',
                  color: disabledFields ? 'grey' : tokens.colors.primary,
                }}
                onClick={() => {
                  if (disabledFields) return;
                  this.setState(({ packagingDetailsKeys }) => ({
                    packagingDetailsKeys: packagingDetailsKeys.concat(packagingDetailsKeys.length),
                  }));
                }}
              >
                + Add More
              </a>
            </Col>
          </Row>}
        </Col>
      </Row>
    );
  };

  getCargoType = () => this.props.form.getFieldValue('cargoType');

  getContainerListFromCargo = () => {
    const { form, containerList } = this.props;
    const { getFieldValue } = form;
    const cargoSelected = getFieldValue('cargoType');
    const filteredContainerList: ContainerList[] = [];
    containerList.filter((container) => {
      if (
        !filteredContainerList?.some((item) => item?.key?.type === container?.key?.type) &&
        container?.cargoList?.includes(cargoSelected)
      ) {
        if (container?.canUse) {
          filteredContainerList.push(container);
        }
      }
    });
    return filteredContainerList;
  };

  getContainerSizes = () => {
    const { containerList } = this.props;
    const filteredContainerList: ContainerList[] = [];
    containerList.filter((container) => {
      if (
        !filteredContainerList?.some((item) => item?.key?.size === container?.key?.size)
      ) {
        if (container?.canUse) {
          filteredContainerList.push(container);
        }
      }
    });
    return filteredContainerList;
  };

  getInitialContainerType = () => {
    const { form, discoverRatesSearchFilters } = this.props;
    const { getFieldValue } = form;
    const containerSearched = JSON.parse(discoverRatesSearchFilters?.container || '[]');
    const cargoSearched = JSON.parse(discoverRatesSearchFilters?.cargo || '[]');
    if (
      this.disableRatesSearchParams() ||
      getFieldValue('cargoType') === cargoSearched?.key?.cargo
    ) {
      return containerSearched?.key?.type;
    }
    if (getFieldValue('cargoType') === 'REEFER') {
      return 'REFRIGERATED';
    }
    return 'STANDARD';
  };

  getContainerCount = () => {
    const { discoverRatesSelectedFilters } = this.props;
    const { source } = this.state;
    return this.disableRatesSearchParams() || source === BookingSource.DIRECT_BOOKING
      ? discoverRatesSelectedFilters?.noOfContainers || 1
      : 1;
  };

  renderGauageCheckbox = (key) => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form.Item style={{ marginBottom: 0, marginLeft: '16px' }}>
        {getFieldDecorator(`gauageCheckbox${key}`, {
          valuePropName: 'checked',
        })(<Checkbox> Out of Gauage Cargo</Checkbox>)}
      </Form.Item>
    );
  };

  renderContainerDetails = () => {
    const { containers, prefilling, productContainerRuleSet } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const isDraft = getFieldValue('isDraft');
    const {
      classes,
      masterData,
      booking,
      discoverRatesSearchFilters,
      discoverRatesSelectedFilters,
      mandatoryFieldsInDraft,
    } = this.props;
    const visible = booking || this.state.prefilling;
    const disabledFields = booking || prefilling;
    const containerSearched = JSON.parse(discoverRatesSearchFilters?.container || '[]');
    const containerListFromCargo = this.getContainerListFromCargo();
    const containerSizes = this.getContainerSizes();
    const initialContainerSizeValue = containerSizes?.length ? containerSizes[0]?.key?.size : "20'";
    let initialContainerTypeValue = this.getInitialContainerType();
    initialContainerTypeValue = containerListFromCargo?.some((item) => item?.key?.type === initialContainerTypeValue) ? 
      initialContainerTypeValue :
      (containerListFromCargo?.length ? containerListFromCargo[0]?.key?.type : "STANDARD");
    if (!CreateEnquiryFormConfig[this.getMode()].containerDetailsVisible) return null;
    const isRequired = (isDraft && mandatoryFieldsInDraft?.[this.getMode()]?.includes('containerDetails')) || !isDraft;
    return (
      <React.Fragment>
        {Object.keys(containers).map((key, ind) => {
          return (
            <React.Fragment key={key}>
              <div
                className={classes.rowDiv}
                style={{
                  height: '65px',
                  marginBottom: '8px',
                  position: 'relative',
                }}
                key={key}
              >
                <span
                  style={{
                    width: '12%',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    marginRight: '6px',
                  }}
                  className={classes.formTitles}
                >
                  {ind === 0 ? <>{resolveFieldLabel('grid#containerDetailsField', 'Container Details', this.state.inquiryFieldLabelMap)}{isRequired ? <Asterisk /> : null}</> : ''}
                </span>
                <div style={{ width: '6%', marginRight: '6px' }}>
                  <div className={classNames(classes.formTitles, classes.containerTitle)}>
                    Count
                  </div>
                  <FormItem className={classes.formItemCountError}>
                    {getFieldDecorator(`count${key}`, {
                      rules: [
                        {
                          validator: (rule, value, cb) => {
                            if (!value) {
                              isRequired ? cb('Required') : cb();
                            } else if (value >= Math.pow(10, 10)) {
                              cb('Enter a small Number');
                            } else cb();
                          },
                          message: `Min Value: ${this.getContainerCount()}`,
                        },
                      ],
                      initialValue: this.fromDiscoverRates()
                        ? discoverRatesSelectedFilters?.noOfContainers || 1
                        : isRequired ? 1 : undefined,
                    })(
                      <InputNumber
                        type="number"
                        placeholder="Count"
                        precision={0}
                        min={this.getContainerCount()}
                        style={{ width: '95%' }}
                        onChange={(value) => {
                          this.setState({
                            containers: {
                              ...containers,
                              [key]: {
                                ...containers[key],
                                count: value,
                              },
                            },
                          });
                        }}
                      />
                    )}
                  </FormItem>
                </div>
                <div style={{ width: '12%' }}>
                  <div className={classNames(classes.formTitles, classes.containerTitle)}>Type</div>
                  <FormItem className={classes.formItemSmallError}>
                    {getFieldDecorator(`type${key}`, {
                      rules: [{ required: !visible && isRequired, message: 'Required' }],
                      initialValue: isRequired ? initialContainerTypeValue : undefined,
                    })(
                      <Select
                        placeholder="Type"
                        style={{
                          width: '95%',
                        }}
                        disabled={visible || this.disableRatesSearchParams()}
                        dropdownMatchSelectWidth={false}
                        onChange={(val) => {
                          this.handleContainerTypeChange(key, val)
                        }}
                      >
                        {containerListFromCargo.map((item) => (
                          <Option key={item?.key?.type} value={item?.key?.type} data-value={item?.label?.type}>
                            {item?.label?.type}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </div>
                <div style={{ marginLeft: '-2px', width: '8%' }}>
                  <div className={classNames(classes.formTitles, classes.containerTitle)}>Size</div>
                  <FormItem className={classes.formItemSmallError}>
                    {getFieldDecorator(`size${key}`, {
                      rules: [{ required: !visible && isRequired, message: 'Required' }],
                      initialValue: this.fromDiscoverRates() ? containerSearched?.key?.size : isRequired ? initialContainerSizeValue : undefined,
                    })(
                      <Select
                        placeholder="Size"
                        style={{ width: '95%' }}
                        disabled={visible || this.disableRatesSearchParams()}
                        onChange={(val) => {
                          this.setState({
                            containers: {
                              ...containers,
                              [key]: {
                                ...containers[key],
                                size: val,
                              },
                            },
                          }, () => {
                            this.applyCalculatedContainerDetails()
                          });
                        }}
                      >
                        {containerSizes.map((item) => (
                          <Option key={item?.key?.size} value={item?.key?.size} data-value={item?.key?.size}>
                            {item?.label?.size}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </div>

                <span
                  style={{
                    margin: '34px 0px 0px 8px',
                    borderLeft: '1px solid #666666',
                  }}
                />
                {this.renderContainerWiseWeight(key)}
                {this.renderAdditionalContainerDetails(key)}
                {getFieldValue(`type${key}`) === 'OPEN_TOP' && (
                  <React.Fragment>
                    {(getFieldValue(`gauageCheckbox${key}`) || prefilling) && (
                      <div style={{ width: '28%' }}>{this.renderLBHUnit(key, true)}</div>
                    )}
                    <div style={{ width: '17%', marginTop: '28px' }}>
                      {this.renderGauageCheckbox(key)}
                    </div>
                  </React.Fragment>
                )}
                {!visible && Object.keys(containers).length > 1 ? (
                  <Tooltip title="Delete this container">
                    <Icon
                      type="close"
                      style={{
                        cursor: 'pointer',
                        color: 'red',
                        display: 'flex',
                        alignItems: 'flex-end',
                        marginBottom: '10px',
                      }}
                      onClick={() => {
                        const newContainers = { ...containers };
                        delete newContainers[key];
                        this.setState({
                          containers: newContainers,
                        }, () => {
                          this.applyCalculatedContainerDetails()
                        });
                      }}
                    />
                  </Tooltip>
                ) : (
                  ''
                )}
              </div>
              {!this.disableRatesSearchParams() && ind === Object.keys(containers).length - 1 && (
                <div className={classes.rowDiv} style={{ position:'absolute', left: '12%', width: 'auto' }}>
                  <Icon
                    type="plus"
                    style={{
                      height: '18px',
                      width: '18px',
                      color: disabledFields ? 'grey' : tokens.colors.primary,
                      paddingTop: '2px',
                    }}
                  />
                  <a
                    type="plus-circle"
                    style={{
                      cursor: 'pointer',
                      color: disabledFields ? 'grey' : tokens.colors.primary,
                      marginLeft: '3px',
                    }}
                    onClick={() => {
                      if (disabledFields) return;
                      const newKey = this.state.containerKey;
                      const preferredCnType = this.state.productContainerRuleSet?.productCnType
                             || this.getInitialContainerType();
                      this.setState({
                        containers: {
                          ...containers,
                          [newKey]: {
                            count: 1,
                            size: "20'",
                            type: preferredCnType,
                          },
                        },
                        containerKey: newKey + 1,
                      }, () => {
                        this.props.form.setFieldsValue({ [`type${newKey}`]: preferredCnType })
                        this.applyCalculatedContainerDetails()
                      });
                    }}
                  >
                    Add More
                  </a>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  };


  renderStuffingLocation = () => {
    const {
      form: { getFieldDecorator },
      classes,
      booking,
      masterData,
      discoverRatesSelectedFilters,
      inquiryFormPrefill,
      exportBehaviorEnabled,
    } = this.props;
    const visible = booking || this.state.prefilling;
    if ((!discoverRatesSelectedFilters?.stuffingType || this.getMode() === LCL) && !CreateEnquiryFormConfig[this.getMode()].stuffingLocation) return null;

    let initialValue: string | undefined;
    if (!exportBehaviorEnabled){
      if (this.fromDiscoverRates()){
        initialValue = discoverRatesSelectedFilters?.stuffingType;
      } else if (inquiryFormPrefill){
        initialValue = VALID_LOCATION_TYPES.FACTORY;
      }
    }

    return (
      <div className={classes.rowDiv}>
        <div style={{ width: '25%', marginTop: '6px' }}>
        <span className={classes.formTitles}>{resolveFieldLabel('grid#additionalDetails.stuffing', 'Stuffing', this.state.inquiryFieldLabelMap)} </span>
        </div>
        <FormItem style={{ marginBottom: '8px', width: '70%' }}>
          {getFieldDecorator(
            'stuffingLocation',
            {initialValue: initialValue}
          )(
            <Select
              disabled={visible || (this.fromDiscoverRates() && discoverRatesSelectedFilters?.stuffingType)}
              style={{ width: '85%' }}
              placeholder="Select Stuffing Type"
              optionLabelProp={'data-value'}
              onChange={(loc) => this.changeStuffingLocation(loc)}
            >
              {masterData.stuffingAndDestuffingLocation.map((item) => {
                return (
                  <Option key={item} value={item} data-value={item}>
                    {item}
                  </Option>
                );
              })}
            </Select>
          )}
        </FormItem>
      </div>
    );
  };

 renderStuffingAddress = () => {
  const { 
    classes, 
    form, 
    booking, 
    discoverRatesSelectedFilters, 
    enableAddressMasterInMenu, 
    permissions,
    inquiryFormPrefill
  } = this.props;
  const { prefilling, serviceType, stuffingAddresses, pickupAndDrop, prefilledStuffingAddress } = this.state;
  const stuffingLocation = form.getFieldValue('stuffingLocation');
  const visible = prefilling || booking;
  const { getFieldDecorator, getFieldValue } = form;
  
  if ((!discoverRatesSelectedFilters?.stuffingLocationId || this.getMode() === LCL) && stuffingLocation !== 'Factory') return '';
  
  return (
    <>
      <div className={classes.rowDiv}>
        <div style={{ width: '25%', marginTop: '6px' }}>
        <span className={classes.formTitles}>{resolveFieldLabel('grid#stuffingLocation', 'Stuffing Location', this.state.inquiryFieldLabelMap)}</span>
        </div>
        <FormItem style={{ marginBottom: '8px', width: '70%' }}>
          {getFieldDecorator(
            'stuffingAddress',
            {initialValue: this.fromDiscoverRates() ? discoverRatesSelectedFilters?.stuffingLocationId : (prefilledStuffingAddress ?? getFieldValue('stuffingAddress'))}
          )(
            <SelectAddress
              disabled={
                visible || 
                (this.fromDiscoverRates() && discoverRatesSelectedFilters?.stuffingLocationId) ||
                (pickupAndDrop === 'Door to Port' || pickupAndDrop === 'Door to Door')}
              style={{ width: '85%' }}
              placeholder="Select Stuffing Location"
              cargoOperationType={CargoOperationType.STUFFING}
              addresses={stuffingAddresses}
              shipperId={this.isEditOrBookingInquiry() ? this.state.shipperId : this.state.organisationId}
              labelInValue = {true}
              onChange={(value, option: any) => {
                form.setFieldsValue({ stuffingAddress: value });
                // Clear the prefilled address so a manual selection is not reverted
                // to the stale prefilled value if the field unmounts and remounts.
                this.setState({ prefilledStuffingAddress: undefined });
                const optionProps = Array.isArray(option) ? option?.[0]?.props : option?.props;

                const setCountry = !this.state.originPort && this.props.inquiryConfig?.allowVendorToSpecifyOrigin;
                if (optionProps) {
                  !inquiryFormPrefill && this.resetContactInfo('origin');
                  this.setContactFromOption('origin', optionProps);
                  if (setCountry) this.setState({ originCountry: optionProps?.countryCode, originPortCountry: optionProps?.countryCode });
                }
              }}
              allowEdit={
                enableAddressMasterInMenu
                  ? hasMasterCategoryEditPermission('ADDRESS', permissions)
                  : true
              }

            />
          )}
        </FormItem>
      </div>
      {this.renderContactInfo(this.state.inchargeContactOrigin, 'origin')}
    </>
  );
};

renderDeStuffingAddress = () => {
  const { 
    classes, 
    form, 
    booking, 
    discoverRatesSelectedFilters,
    enableAddressMasterInMenu,
    permissions,
    inquiryFormPrefill
  } = this.props;
  const { prefilling, deStuffingAddresses, pickupAndDrop, prefilledDestuffingAddress } = this.state;
  const deStuffingLocation = form.getFieldValue('deStuffingLocation');
  const visible = prefilling || booking;
  const { getFieldDecorator, getFieldValue } = form;

  if ((!discoverRatesSelectedFilters?.destuffingLocationId || this.getMode() === LCL) && 
       deStuffingLocation !== 'Factory') {
    return '';
  }

  return (
    <>
      <div className={classes.rowDiv}>
        <div className={classes.gridLabelWidth} style={{ marginTop: '6px' }}>
        <span className={classes.formTitles}>{resolveFieldLabel('grid#additionalDetails.destuffingLocation', 'De-Stuffing Location', this.state.inquiryFieldLabelMap)}</span>
        </div>
        <FormItem className={classes.gridInputFieldWidth} style={{ marginBottom: '8px' }}>
          {getFieldDecorator(
            'deStuffingAddress',
            { initialValue: this.fromDiscoverRates() ?
                discoverRatesSelectedFilters?.destuffingLocationId :
                (prefilledDestuffingAddress ?? getFieldValue('deStuffingAddress'))
            }
          )(
            <SelectAddress
              disabled={
                visible || 
                (this.fromDiscoverRates() && discoverRatesSelectedFilters?.destuffingLocationId) ||
                (pickupAndDrop === 'Port to Door' || pickupAndDrop === 'Door to Door')
              }
              style={{ width: '85%' }}
              placeholder="Select De-Stuffing Location"
              shipperId={this.isEditOrBookingInquiry() ? this.state.shipperId: this.state.organisationId}
              cargoOperationType={CargoOperationType.DESTUFFING}
              addresses={deStuffingAddresses}
              allowEdit={
                enableAddressMasterInMenu
                  ? hasMasterCategoryEditPermission('ADDRESS', permissions)
                  : true
              }

              labelInValue = {true}
              onChange={(value, option: any) => {
                // Clear the prefilled address so a manual selection is not reverted
                // to the stale prefilled value if the field unmounts and remounts.
                this.setState({ prefilledDestuffingAddress: undefined });
                const optionProps = Array.isArray(option) ? option?.[0]?.props : option?.props;

                const setCountry = !this.state.destinationPort && this.props.inquiryConfig?.allowVendorToSpecifyDestination;
                if (optionProps) {
                  !inquiryFormPrefill && this.resetContactInfo('destination');
                  this.setContactFromOption('destination', optionProps);
                  if (setCountry) this.setState({ destinationCountry: optionProps?.countryCode, destinationPortCountry: optionProps?.countryCode });
                }
              }}
            />
          )}
        </FormItem>
      </div>
      {this.renderContactInfo(this.state.inchargeContactDestination, 'destination')}
    </>
  );
};

  renderDeStuffingLocation = () => {
    const {
      form: { getFieldDecorator },
      classes,
      booking,
      masterData,
      discoverRatesSelectedFilters,
      inquiryFormPrefill,
      exportBehaviorEnabled
    } = this.props;
    const visible = booking || this.state.prefilling;
    if ((!discoverRatesSelectedFilters?.destuffingType || this.getMode() === LCL) && !CreateEnquiryFormConfig[this.getMode()].stuffingLocation) return null;
    
    let initialValue: string | undefined;
    if (!exportBehaviorEnabled){
      if (this.fromDiscoverRates()){
        initialValue = discoverRatesSelectedFilters?.destuffingType;
      } else if (inquiryFormPrefill){
        initialValue = VALID_LOCATION_TYPES.FACTORY;
      }
    }
    
    return (
      <div className={classes.rowDiv}>
        <div className={classes.gridLabelWidth} style={{ marginTop: '6px' }}>
          <span className={classes.formTitles} style={{ marginRight: '19px' }}>
          {resolveFieldLabel('grid#De-stuffing', 'De-Stuffing', this.state.inquiryFieldLabelMap)}{' '}
          </span>
        </div>
        <FormItem className={classes.gridInputFieldWidth} style={{ marginBottom: '8px' }}>
          {getFieldDecorator(
            'deStuffingLocation',
            { initialValue: initialValue }
          )(
            <Select
              disabled={visible || (this.fromDiscoverRates() && discoverRatesSelectedFilters?.destuffingType)}
              style={{ width: '85%' }}
              placeholder="Select De-Stuffing Type"
              optionLabelProp={'data-value'}
              onChange={(loc) => this.changeDeStuffingLocation(loc)}
            >
              {masterData.stuffingAndDestuffingLocation.map((item) => {
                return (
                  <Option key={item} value={item} data-value={item}>
                    {item}
                  </Option>
                );
              })}
            </Select>
          )}
        </FormItem>
      </div>
    );
  };

  renderContainerWiseWeight = (key) => {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { classes, masterData, booking, mandatoryFieldsInDraft } = this.props;
    const disabledFields = this.getMode() !== 'FCL' && booking;
    const { prefilling, containerWeightUnit } = this.state;
    const isDraft = getFieldValue('isDraft');
    if (!CreateEnquiryFormConfig[this.getMode()].containerWiseWeight) return null;
    const isRequired = (isDraft && mandatoryFieldsInDraft?.[this.getMode()]?.includes('containerDetails')) || (!isDraft && this.props.isCargoWtMandatory);
    return (
      <React.Fragment>
        <div style={{ width: '9%', paddingLeft: '5px' }}>
          <div
            className={classNames(classes.formTitles, classes.containerTitle)}
            style={{ marginLeft: '8px' }}
          >
            Total Cargo Wt
          </div>

          <FormItem
            style={{ width: '95%', marginBottom: '0px', paddingLeft: '8px' }}
            className={classes.formItemSmallError}
          >
            {getFieldDecorator(`weight${key}`, {
              rules: [
                { required: isRequired, message: 'Required' },
                {
                  validator: (rule, value, cb) => {
                    if (value && isNaN(value)) {
                      cb('Please Enter a number');
                    } else if (value === null || value === undefined) {
                      cb();
                    } else if (value >= Math.pow(10, 10)) {
                      cb('Enter a small Number');
                    } else cb();
                  },
                  message: 'Please enter a small value',
                },
              ],
            })(
              <InputNumber
                type="number"
                placeholder="0.00"
                min={0}
                precision={2}
                disabled={prefilling}
                data-testid={'totalCargoWt'}
                onChange={(e) => {
                  this.setState((prevState) => ({
                            containers: {
                              ...prevState.containers,
                              [key]: {
                                ...prevState.containers[key],
                                weight: e
                              },
                            },
                  }), () => {
                    this.applyCalculatedContainerDetails(e)
                  });
                }}
                style={{ width: '100%' }}
              />
            )}
          </FormItem>
        </div>
        <div style={{ width: '7%' }}>
          <div className={classNames(classes.formTitles, classes.containerTitle)}>Unit</div>
          <FormItem style={{ width: '95%', marginBottom: '0px' }}>
            {getFieldDecorator(`weightUnit${key}`, {
              rules: [
                {
                  required: isRequired,
                  message: 'Required',
                },
              ],
              initialValue: containerWeightUnit,
            })(
              <Select
                placeholder="Unit"
                disabled={disabledFields || prefilling}
                style={{ width: '100%' }}
                optionLabelProp={'data-value'}
                onChange={(val) => {
                  this.setState((prevState) => ({
                    containers: {
                      ...prevState.containers,
                      [key]: {
                        ...prevState.containers[key],
                        weightUnit: val,
                      },
                    },
                  }));
                }}
              >
                {masterData.weightsUnits.map((unit) => (
                  <Option key={unit} value={unit} data-value={unit}>
                    {unit}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </div>
      </React.Fragment>
    );
  };

  renderReferenceRate = () => {
    const { classes, currencies, referenceRateBasis, booking, orgCurrency } = this.props;
    const { getFieldDecorator } = this.props.form;
    let unit;

    if (this.getMode() === 'FCL') {
      unit = 'container';
    } else if (this.getMode() === LCL) {
      unit = 'cbm';
    } else if (this.getMode() === AIRCARGO) {
      unit = 'kg';
    }

    const disabledFields = booking;

    return (
      <div className={classes.rowDiv} style={{ alignItems: 'center' }}>
        <div style={{ width: '14%' }}>{'Reference Rate'}</div>
        <div style={{ width: '86%', display: 'flex', alignItems: 'center' }}>
          <FormItem style={{ marginBottom: '0px', width: '16%' }}>
            {getFieldDecorator("referenceRate['basis']", {
              initialValue: 'FREIGHT',
            })(
              <Select style={{ width: '95%' }} disabled={disabledFields}>
                {Object.keys(referenceRateBasis).map((item) => (
                  <Select.Option key={item} value={item}>{referenceRateBasis[item]}</Select.Option>
                ))}
              </Select>
            )}
          </FormItem>
          <FormItem style={{ marginBottom: '0px', width: '9%', marginLeft: '1%' }}>
            {getFieldDecorator("referenceRate['currency']", {
              initialValue: orgCurrency,
            })(
              <Select style={{ width: '100%' }} disabled={disabledFields}>
                {currencies &&
                  Object.keys(currencies).map((item) => (
                    <Select.Option key={item} value={item}>{item}</Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <FormItem style={{ marginBottom: '0px', width: '13%', marginLeft: '1%' }}>
            {getFieldDecorator(
              "referenceRate['amount']",
              {}
            )(
              <InputNumber
                style={{ width: '100%' }}
                placeholder={`Price/${unit}`}
                precision={2}
                disabled={disabledFields}
              />
            )}
          </FormItem>
        </div>
      </div>
    );
  };

  renderPrefferedCarriers = () => {
    const { classes, booking } = this.props;
    const visible = booking || this.state.prefilling;
    const isAir = CreateEnquiryFormConfig[this.getMode()].isAir;
    return (
      <div className={classes.rowDiv} style={{ alignItems: 'center' }}>
        <div style={{ width: '24%' }}>
          {isAir ? 'Preferred Air Carrier' : 'Preferred Shipping Lines'}
        </div>
        <div style={{ width: '68%' }}>
          <Select
            style={{ width: '85%' }}
            mode="multiple"
            disabled={visible}
            placeholder={`Preferred ${isAir ? 'Air Carrier' : 'Shipping Lines'}`}
            value={this.state.preferredCarriers}
            onChange={(filterVals) =>
              this.setState({
                preferredCarriers: filterVals,
              })
            }
          >
            {isAir
              ? this.props.airCarriers.map((carrier) => (
                <Select.Option key={carrier.id} value={carrier.id}>{carrier.name}</Select.Option>
              ))
              : this.props.globalShippingLines.map((shippingLine) => (
                <Select.Option key={shippingLine.id} value={shippingLine.id}>{shippingLine.name}</Select.Option>
              ))}
          </Select>
        </div>
      </div>
    );
  };

  handleModeChange = (e) => {
    this.props.form.resetFields();
    const { inquiryDefaultFormConfig, discoverRatesSearchFilters, defaultInquiryMovementType } = this.props;
    {
      const mode = e.target.value;
      const resolvedServiceType =
        this.fromDiscoverRates() && discoverRatesSearchFilters?.movementType?.toLowerCase()
          ? discoverRatesSearchFilters.movementType.toLowerCase()
          : defaultInquiryMovementType || 'export';
      const configData =
      this.props?.masterData?.inquiryFormFieldConfig?.[mode] ||
      this.props?.masterData?.inquiryDefaults?.formFieldConfig?.[mode] ||
      this.props?.masterData?.inquiryDefaults?.defaultFormFieldConfig?.[mode];
      const usedConfig = configData || inquiryDefaultFormConfig?.[mode] || formFieldConfig?.[mode];
      this.setState({
      containerKey: 1,
      containers: {
        0: {
          count: 1,
          type: 'STANDARD',
          size: "20'",
        },
      },
      serviceType: resolvedServiceType,
      inquiryData: {},
      destinationPortsPre: [],
      activeKey: '1',
      preferredCarriers: [],
      preferredSailingRange: [
        moment().endOf('day').add(7, 'day'),
        moment().endOf('day').add(14, 'day'),
      ],
      packagingDetailsKeys: [0],
      isDestinationDryPort: false,
      isOriginDryPort: false,
      stakeholderType: resolvedServiceType === 'import' ? 'Supplier' : 'Shipper',
      stakeholder: undefined,
      stakeholderList: [],
      customer: undefined,
      customerList: [],
      stuffingTruckingAddress: undefined,
      deStuffingTruckingAddress: undefined,
      ...CreateEnquiryFormConfig[mode]?.defaultStateData,
      inquiryFormFieldConfig: usedConfig,
      inquiryFieldLabelMap: buildInquiryFieldLabelMap(usedConfig)
      }, () => {
        this.props.form.setFieldsValue({ serviceType: resolvedServiceType });
        this.setAllowedServices(mode);
      });
    }
  };

  handleAccessTypeChange = (val) => {
    if (val !== 'TEAM') {
      this.setState({ accessType: val, teamId: undefined, bookingAccessTeams: {} });
      return;
    }
    this.setState({ accessType: val, isSelectTeamModalVisible: true });
  };

  handleTeamSelect = (team) => {
    const { booking } = this.props;
    const newAccessData: any = {
      accessType: 'TEAM',
      teamId: team.id,
      teamName: team.name,
      reference_number: team.reference_number,
      isSelectTeamModalVisible: booking ? true : false,
    };

    if (booking) {
      const newBookingAccessTeams = { ...this.state.bookingAccessTeams };
      if (newBookingAccessTeams[team.id]) delete newBookingAccessTeams[team.id];
      else newBookingAccessTeams[team.id] = `${team.name} (${team.reference_number})`;
      if (Object.keys(newBookingAccessTeams).length)
        newAccessData.bookingAccessTeams = newBookingAccessTeams;
    }

    this.setState(newAccessData, () => {
      if (!booking) {
        this.props.form.setFieldsValue({
          accessType: (
            <>
              <Icon type="team"></Icon> {[(this.state.teamName), (" ("), (this.state.reference_number),( ")")]}
            </>
          ),
        });
      }
    });
  };

  getProductOptions = () => {
    const { productTypes } = this.props;
    const cargoTypeSelected = this.getCargoType();

    return (
      (productTypes?.[cargoTypeSelected] || [])?.map(item => (
        <Option key={item} value={item} data-value={item}>
          {item}
        </Option>
      ))
    );
  };

  renderDestinationFreeDays = () => {
    const { form, classes, booking } = this.props;
    const { prefilling, source } = this.state;
    return (
      <Row gutter={[0,24]}>
        <Col span={3} className={classNames(classes.formTitles, classes.gridLabelWidth)} style={{ lineHeight: '18px' }}>
        {resolveFieldLabel('grid#requiredDestinationFreeDays', 'Required Destination Free Days', this.state.inquiryFieldLabelMap)}
        </Col>
        <Col span={5} className={classes.gridInputFieldWidth} style={{ paddingLeft: 0 }}>
          <Form.Item style={{ marginBottom: 0 }}>
            {form.getFieldDecorator('requiredDestinationFreeDays')(
              <InputNumber
                disabled={(booking ? !this.isBookedFromSpotRates() : prefilling) ||
                    this.props.bookingData?.requiredDestinationFreeDays
                }
                placeholder="0"
                min={0}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  renderRequiredOriginFreeDays = () => {
    const { form, classes, booking } = this.props;
    const { prefilling, source } = this.state;
    return (
      <Row gutter={24}>
        <Col span={3} className={classNames(classes.formTitles, classes.gridLabelWidth)} style={{ lineHeight: '18px' }}>
        {resolveFieldLabel('grid#requiredOriginFreeDays', 'Required Origin Free Days', this.state.inquiryFieldLabelMap)}
        </Col>
        <Col span={5} className={classes.gridInputFieldWidth} style={{ paddingLeft: 0 }}>
          <Form.Item style={{ marginBottom: 0 }}>
            {form.getFieldDecorator('requiredOriginFreeDays')(
              <InputNumber
                disabled={(booking ? !this.isBookedFromSpotRates() : prefilling) ||
                  this.props.bookingData?.requiredOriginFreeDays
                }
                placeholder="0"
                min={0}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  renderBusinessType = () => {
    const {
      form, classes, booking, masterData: { businessTypeList },
    } = this.props;
    const { prefilling, source } = this.state;
    const businessTypes: string[] = businessTypeList ? Object.values(businessTypeList) : [];
    return (
      <Row gutter={24}>
        <Col span={3} className={classes.formTitles} style={{ lineHeight: '18px' }}>
        {resolveFieldLabel('grid#businessType', 'Business Type', this.state.inquiryFieldLabelMap)}
        </Col>
        <Col span={8} style={{ width: '28.6%', paddingLeft: 0 }}>
          <Form.Item style={{ marginBottom: 0 }}>
          {form.getFieldDecorator("businessType", {})(
            <Select 
              disabled={booking ? !this.isBookedFromSpotRates() : prefilling} 
              allowClear 
              placeholder={'Business Type'}>
              {businessTypes.length && businessTypes.map((value: string) => (
                <Select.Option key={value} value={value} data-value={value}>{value}</Select.Option>
              ))}
            </Select>
          )}
          </Form.Item>
        </Col>
      </Row>
    );
  }

  renderBusinessEntity = () => {
    const {
      form, classes, booking, businessEntities,
    } = this.props;
    const { prefilling, source } = this.state;

    if (!businessEntities) { 
      return null;
    }
    return (
      <Row gutter={24}>
        <Col span={3} className={classes.formTitles} style={{ lineHeight: '18px' }}>
        <span data-testid={"businessEntity"}>{resolveFieldLabel('grid#businessEntity', 'Business Entity', this.state.inquiryFieldLabelMap)}</span>
        </Col>
        <Col span={8} style={{ width: '28.6%', paddingLeft: 0 }}>
          <Form.Item style={{ marginBottom: 0 }}>
          {form.getFieldDecorator("businessEntity", {})(
            <Select 
              disabled={booking ? !this.isBookedFromSpotRates() : prefilling} 
              allowClear 
              data-testid={"businessEntityDropdown"}
              placeholder={'Business Entity'}>
              {
                businessEntities?.map((entity) => (
                  <Select.Option key={entity} value={entity} data-value={entity}>{entity}</Select.Option>
                ))
              }
            </Select>
          )}
          </Form.Item>
        </Col>
      </Row>
    );
  }

  renderOtherDetails = () => {
    const {
      form, classes, booking
    } = this.props;
    const { prefilling, source } = this.state;
    
    return (
      <Row gutter={24}>
        <Col span={3} className={classes.formTitles} style={{ marginTop: '25px', lineHeight: '18px' }}>
        {resolveFieldLabel('grid#otherDetails', 'Other Details', this.state.inquiryFieldLabelMap)}
        </Col>
        <Col span={8} style={{ width: '28.6%', marginTop: '22px', marginBottom: '22px', paddingLeft: 0 }}>
          <Form.Item style={{ marginBottom: 0 }}>
            {form.getFieldDecorator("extraDetails", {})(
              <Input.TextArea
              placeholder={'Add other details related to inquiry'}
              style={{ height: '70px' }}
              autoComplete="new-password"
              maxLength={1000}
              disabled={booking ? !this.isBookedFromSpotRates() : prefilling} 
            />
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  getUniqueOrgNames = () => {
    const { discoverRatesSelectedFilters } = this.props;
    const organisationList: OrganisationList[] = isValidArray(
      discoverRatesSelectedFilters?.organisationList
    )
      ? uniqWith(discoverRatesSelectedFilters.organisationList, (a, b) => a.orgId === b.orgId)
      : [];
    return organisationList;
  };

  handleCargoChange = (cargo) => {
    const { setFieldsValue, getFieldValue } = this.props.form;
    const { containers, docs, productContainerRuleSet } = this.state;
    const mode = this.getMode();
    Object.keys(containers).map((key, ind) => {
      if (cargo !== 'REEFER' && getFieldValue(`type${key}`) === 'REFRIGERATED') {
        setFieldsValue({
          [`type${key}`]: 'STANDARD',
        });
      } else if (cargo === 'REEFER' && getFieldValue(`type${key}`) !== 'REFRIGERATED') {
        setFieldsValue({
          [`type${key}`]: 'REFRIGERATED',
        });
      }
    });
    if (this.getCargoType() === cargo.toUpperCase()) return;
    setFieldsValue({
      cargoType: cargo.toUpperCase(),
      product: undefined,
    });
    if (cargo === CargoType.HAZ && mode === 'FCL') {
      this.setState({
        docs: {
          0: {
            uploading: false,
            file: {},
            type: 'MSDS',
          },
          1: {
            uploading: false,
            file: {},
            type: 'IIP/UN CERTIFICATE',
          },
        },
      });
    }

    if (productContainerRuleSet && cargo !== productContainerRuleSet.cargoType){
      this.resetProductAndContainerDetailFields();
      this.setState({
        productContainerRuleSet: null
      })
    }
  };

  handleCargoProductTypeChange = (val) => {
    const { productContainerRuleSet } = this.state;

    if (productContainerRuleSet && val !== productContainerRuleSet.cargoProductType){
      this.resetProductAndContainerDetailFields();
      this.setState({
        productContainerRuleSet: null
      })
    }  
  }

  handleContainerTypeChange = (key, val) => {
    const { containers } = this.state;
    this.setState({
        containers: {
          ...containers,
          [key]: {
            ...containers[key],
            type: val,
          },
        },
      }, () => {
        this.applyCalculatedContainerDetails()
    });
  }

  handleProductSearch = (query) => {
    this.setState({ isProductListLoading: true });
    this.debouncedProductQuery(query);
  };

  isProductContainerRuleMatch = (givenRuleSet: ProductContainerRuleSet) => {
    const { productContainerRuleSet } = this.state;
    if (!productContainerRuleSet) return true;
    return Object.keys(givenRuleSet).every(
      (key) => productContainerRuleSet[key] === givenRuleSet[key]
    );
  };

  handleProductChange = (key, val) => {
    const { productDetails , productDetailList, productContainerRuleSet, containers, customerDefaultContainerSize } = this.state;
    const { form, inquiryFormPrefill, booking } = this.props;
    const mode = this.getMode()

    const currentError = form.getFieldError(`productKey${key}`);

    if (val === undefined){
      const resetFieldsArray = [
        `productKey${key}`,
        `productQuantity${key}`,
        `productUnit${key}`,
        `productCnType${key}`,
        `productCnSize${key}`,
      ]
      form.resetFields(resetFieldsArray)
      
      // Clear product from state and recalculate container details
      this.setState({
        productDetails: {
          ...productDetails,
          [key]: {
            key: '',
            quantity: 0,
            unit: '',
            productCnType: '',
            productCnSize: '',
            containerAndQuantityDetails: []
          }
        }
      }, () => {
        this.applyCalculatedContainerDetails()
      })
      return
    }

    if (currentError && currentError.length){
        form.resetFields([`productKey${key}`])
    }

    /**
     * The product - cargo - container rule is only applicable for FCL mode for now
     * also the inquiryFormPrefill key must be set to true
     */

    if (mode !== 'FCL' || !inquiryFormPrefill){
      this.setState({
        productDetails: {
          ...productDetails,
          [key] : {
            ...productDetails[key],
            key: typeof val === 'string' ? val : val?.key, // Store as 'id' not 'key'
            // Also store other useful information
            name: typeof val === 'string' ? undefined : val?.value,
            referenceNumber:
              typeof val === 'string' ? undefined : val?.referenceNumber,
          },
        },
      });
      return;
    }

    const selected = productDetailList.find(item => item?.key === val?.key);
    // Store the FULL set of FCL rows (all modes) so switching LOOSE<->PALLET later can
    // still resolve the other mode's quantities. Mode filtering happens at calc/render
    // time (and below, only to pick sensible default container type/size). (ISS-288612 §5)
    const fclContainerAndQuantityDetails = getFclContainerAndQuantityDetails(selected?.containerAndQuantityDetails || []);
    const modeFilteredForDefaults = selectContainerDetailsByDispatchMode(
      fclContainerAndQuantityDetails,
      form.getFieldValue('dispatchMode')
    );
    const selectedContainerType = modeFilteredForDefaults?.[0]?.containerType || undefined;
    const selectedContainerSize = customerDefaultContainerSize || modeFilteredForDefaults?.[0]?.containerSize || undefined;
    const selectedContainerWeightUnit = modeFilteredForDefaults?.[0]?.totalQuantityUnit || undefined
    const selectedCargoType = selected?.cargoType || CargoTypes.General;
    const selectedProductType = selected?.cargoProductType || DEFAULT_PRODUCT_TYPE;


    const nextProductDetails = {
          ...productDetails,
          [key]: {
            ...productDetails[key],
            key: typeof val === 'string' ? val : val?.key, // Store as 'id' not 'key'
            // Also store other useful information
            name: typeof val === 'string' ? undefined : val?.value,
            referenceNumber:
              typeof val === 'string' ? undefined : val?.referenceNumber,
            unit: selectedContainerWeightUnit,
            productCnType: selectedContainerType,
            productCnSize: selectedContainerSize,
            containerAndQuantityDetails: fclContainerAndQuantityDetails,
            // Store gross weight for weight calculations (prevents loss when productDetailList changes)
            grossWeight: selected?.grossWeight,
            grossWeightUnit: selected?.grossWeightUnit,
          },
      }

    const selectedProducts = Object.values(nextProductDetails).filter(
      (product: any) => product?.key
    );

    const isFirstSelection = selectedProducts.length === 1;
    const firstContainerKey = Object.keys(containers)[0]

    if (!productContainerRuleSet || isFirstSelection) {
        /**
         * isFirstSelection - This logic is for the case when user is selecting the first product
         * In this case, we set the productContainerRuleSet based on the selected product
         * For subsequent products, we validate against the existing productContainerRuleSet
         * and show error if not matching
         */
      this.setState({
        productDetails: nextProductDetails,
        productContainerRuleSet: {
          cargoType: selectedCargoType,
          productCnType: selectedContainerType,
          cargoProductType: selectedProductType,
        },
        containerWeightUnit: 'kg'
      });

      const { customerDefaultContainerType, customerDefaultContainerSize, serviceType } = this.state;
      const { exportBehaviorEnabled } = this.props;
      
      // For export with customer defaults, preserve the customer's container type/size
      const preserveCustomerContainer = 
        serviceType === 'export' && 
        exportBehaviorEnabled && 
        customerDefaultContainerType && 
        customerDefaultContainerSize;

      const formValues = {
        cargoType: selectedCargoType,
        product: selectedProductType,
        [`productCnType${key}`]: selectedContainerType,
        [`productCnSize${key}`]: selectedContainerSize,
        [`productUnit${key}`]: selectedContainerWeightUnit,
        [`productQuantity${key}`]: undefined,
        ...(!booking && !preserveCustomerContainer && { [`size${firstContainerKey}`]: selectedContainerSize })
      }

       Object.keys(containers).forEach((containerKey) => {
          if (!booking && !preserveCustomerContainer) formValues[`type${containerKey}`] = selectedContainerType
          formValues[`count${containerKey}`] = undefined
          formValues[`weight${containerKey}`] = undefined
      })
    
      form.setFieldsValue(formValues);
      return
    } 

     if (!this.isProductContainerRuleMatch({
      cargoType: selectedCargoType,
      productCnType: selectedContainerType,
      cargoProductType: selectedProductType
    })){
      form.setFields({
        [`productKey${key}`]: {
          value: undefined,
          errors: [new Error('Selected product is not compatible with the current container details. Please change the container details or select a different product.')],
        },
      })
      const resetFieldsArray = [
        `productQuantity${key}`,
        `productUnit${key}`,
        `productCnType${key}`,
        `productCnSize${key}`,
      ]
      form.resetFields(resetFieldsArray);
      return;
    }

    this.setState({
      productDetails: {
        ...nextProductDetails
      }
    })

  
    const formValues = {
      cargoType: selectedCargoType,
      product: selectedProductType,
      [`productCnType${key}`]: selectedContainerType,
      [`productCnSize${key}`]: selectedContainerSize,
      [`productUnit${key}`]: selectedContainerWeightUnit,
      [`productQuantity${key}`]: undefined,
    }

   
    form.setFieldsValue(formValues);

  }

  resetProductAndContainerDetailFields = () => {
    const { form } = this.props;
    const { productDetails, containers, customerDefaultContainerType, customerDefaultContainerSize } = this.state;
    Object.keys(productDetails).forEach((key) => {
      form.setFieldsValue({
        [`productKey${key}`]: undefined,
        [`productQuantity${key}`]: undefined,
        [`productUnit${key}`]: undefined,
        [`productCnType${key}`]: undefined,
        [`productCnSize${key}`]: undefined,
      })
    })

    // If customer has defaults, restore to customer defaults; otherwise clear
    const hasCustomerDefaults = customerDefaultContainerType && customerDefaultContainerSize;
    const defaultContainerType = hasCustomerDefaults ? customerDefaultContainerType : 'STANDARD';
    const defaultContainerSize = hasCustomerDefaults ? customerDefaultContainerSize : "20'";

    Object.keys(containers).forEach((key) => {
      form.setFieldsValue({
        [`count${key}`]: hasCustomerDefaults ? 1 : undefined,
        [`type${key}`]: hasCustomerDefaults ? defaultContainerType : undefined,
        [`size${key}`]: hasCustomerDefaults ? defaultContainerSize : undefined,
        [`weight${key}`]: undefined,
        [`weightUnit${key}`]: hasCustomerDefaults ? 'kg' : undefined,
      })
    })

    this.setState({
      productDetails: {
        0: {
          key: '',
          quantity: 0,
          unit: '',
          productCnType: '',
          productCnSize: '',
          containerAndQuantityDetails: []
        }
      },
      containers: {
        0: {
          count: hasCustomerDefaults ? 1 : 1,
          type: defaultContainerType,
          size: defaultContainerSize,
          weightUnit: hasCustomerDefaults ? 'kg' : 'kg'
        }
      }

    })
  }

  debouncedProductQuery = debounce((query) => {
    this.getProducts(query);
  }, 300);

  getProducts = async (searchQuery) => {
    this.setState({ isProductListLoading: true });
    let productDetailList = [];
    try {
      const response = await searchProduct({ searchQuery });
      if (response.isSuccess) {
        productDetailList = response.data?.map((item) => ({
          disabled: item.status === 'INACTIVE',
          key: item.id,
          referenceNumber: item.referenceNumber,
          label: `${item.internalName} (${item.hsCode} - ${item.remark}) [${item.referenceNumber}]`,
          value: item.internalName,
          organisationId: item.organisationId,
          cargoType: item.cargoType,
          cargoProductType: item.cargoProductType,
          containerAndQuantityDetails: item.containerAndQuantityDetails,
          grossWeight: item.grossWeight,
          grossWeightUnit: item.grossWeightUnit,
          netWeight: item.netWeight,
          netWeightUnit: item.netWeightUnit
        }));
      }
      this.setState({
        productDetailList,
        isProductListLoading: false,
      });
      return productDetailList; 
    } catch (error) {
      this.setState({
        isProductListLoading: false,
      });
      return [];
    }
  };

  isBookedFromSpotRates = () => {
    const { source } = this.state;
    const { booking } = this.props;
    return booking && (source === BookingSource.DIRECT_BOOKING || source === 'SPOT_SEARCH');
  };

  renderProductDropdown = (menu: React.ReactNode) => {
    const { classes, enableAddressMasterInMenu, permissions } = this.props;
    const { isProductListLoading } = this.state;
    if (isProductListLoading) return <Spin style={{ marginLeft: '45%' }} />;
    const addProduct = 
      enableAddressMasterInMenu
        ? hasMasterCategoryEditPermission('PRODUCT', permissions)
        : true
    return (
      <React.Fragment>
        {menu}
        {addProduct &&
          <div
            className={classes.addProduct}
            onMouseDown={(e) => stops(e)}
            onClick={() => this.setState({ addProduct: true })}
          >
            + Add Product
          </div>
        }
      </React.Fragment>
    );
  };

  handleAddProduct() {
    this.setState({ addProduct: false });
  }

  renderProductDetailsWithCountandUnit = () => {
    const { classes, booking,  masterData, inquiryFormPrefill } = this.props;
    const { productDetails = {}, prefilling, source, productDetailList = [] } = this.state;
    const organisationId = this.props.userData.organisation_id;
     const filteredProductDetailList = productDetailList.filter(product => {
                      if (this.isEditOrBookingInquiry()) {
                        return product.organisationId === this.state.shipperId;
                      }
                      return product.organisationId === organisationId;
                    })
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const disabledFields = booking || prefilling;
    const mode = this.getMode();
    const hideProductCnFields = [InquiryModes.LCL, InquiryModes.AIRCARGO].includes(mode);
    const isRequired = this.isProductMandatory()
    const visible = prefilling || 
                    (booking && ![InquiryModes.FCL, InquiryModes.LCL, InquiryModes.AIRCARGO].includes(mode) 
                      && !this.isBookedFromSpotRates());
    const productUnits = {
      weight: masterData?.weightsUnits,
      volume: masterData?.volumeUnits,
      other: ['units', 'barrel', 'box', 'tray', 'cases']
    };
    const containerListFromCargo = this.getContainerListFromCargo();
    const containerSizes = this.getContainerSizes();
  
    return (
      <React.Fragment>
        {Object.keys(productDetails || {}).map((key, ind) => (
          <React.Fragment key={key}>
            <div
              className={classes.rowDiv}
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
                flexWrap: 'wrap',
                position: 'relative',
              }}
            >
              {/* Product Details Title */}
              <span
                style={{
                  width: '12%',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  marginRight: '6px',
                }}
                className={classes.formTitles}
              >
                {ind === 0 ? <>{resolveFieldLabel('grid#productDetails', 'Product Details', this.state.inquiryFieldLabelMap)}{isRequired ? <Asterisk /> : null}</> : ''}
              </span>
    {/* Product Dropdown Section */}
    <div style={{ width: '20%', marginRight: '6px' }}>
                <div className={classNames(classes.formTitles, classes.containerTitle)}>Product</div>
                <FormItem className={classNames(classes.formItemCountError, classes.productErrorInline)}>
                  {getFieldDecorator(`productKey${key}`, {})(
                    <Select
                      mode="default"
                      disabled={visible}
                      showArrow
                      showSearch
                      placeholder="Product Name And Details"
                      style={{ width: '100%' }}
                      optionLabelProp={'data-value'}
                      labelInValue
                      allowClear
                      filterOption={(input, option) => true}
                      onFocus={() => {
                        if (productDetailList?.length === 0) {
                          this.handleProductSearch('');
                        }
                      }}
                      onSearch={(searchQuery) => this.handleProductSearch(searchQuery)}
                      dropdownRender={(menu) => this.renderProductDropdown(menu)}
                      onChange={(val: any) => {
                        this.handleProductChange(key, val);
                      }}
                    >
                      {filteredProductDetailList?.map(
                        (item) =>
                          !item.disabled && (
                            <Select.Option
                              key={item.key}
                              value={item.key}
                              data-value={`${item.value} [${item.referenceNumber}]`}
                              disabled={item.disabled}
                            >
                              <Tooltip
                                title={item.label}
                                placement="topLeft"
                                mouseEnterDelay={0.5}
                                overlayStyle={{ fontSize: `${tokens.fontSize.small}px`, width: '100%' }}
                              >
                                {item.label}
                              </Tooltip>
                            </Select.Option>
                          )
                      )}
                    </Select>
                  )}
                </FormItem>
              </div>
              {/* Count Section */}
              <div style={{ width: '7%', marginRight: '6px' }}>
                <div className={classNames(classes.formTitles, classes.containerTitle)}>
                  Count/Wt./Vol.
                </div>
                <FormItem className={classes.formItemCountError}>
                  {getFieldDecorator(`productQuantity${key}`, {
                    rules: [
                      {
                        validator: (rule, value, cb) => {
                          if (!value) {
                            isRequired ? cb('Required') : cb();
                          } else if (value >= Math.pow(10, 10)) {
                            cb('Enter a small Number');
                          } else if (value < 1){
                            cb('Value must be greater than 1');
                          } else cb();
                        },
                      },
                      { required: isRequired, message: 'Required' },
                    ],
                    initialValue: this.fromDiscoverRates()
                      ? this.props.discoverRatesSelectedFilters?.noOfContainers || 1
                      : isRequired
                      ? 1
                      : undefined,
                  })(
                    <InputNumber
                      type="number"
                      placeholder="Count"
                      precision={2}
                      min={this.getContainerCount()}
                      style={{ width: '95%' }}
                      onChange={(value) => {
                        this.setState(
                          {
                            productDetails: {
                              ...productDetails,
                              [key]: {
                                ...productDetails[key],
                                quantity: value,
                              },
                            },
                          },
                          () => {
                            this.debouncedApplyCalculatedContainerCounts()
                          }
                        );
                      }}
                    />
                  )}
                </FormItem>
              </div>

              {/* Unit Section */}
              <div style={{ width: '6%', marginRight: '6px' }}>
                <div className={classNames(classes.formTitles, classes.containerTitle)}>Unit</div>
                <FormItem className={classes.formItemCountError}>
                  {getFieldDecorator(`productUnit${key}`, {
                    rules: [{ required: isRequired, message: 'Required' }],
                  })(
                    <Select
                      placeholder="Unit"
                      disabled={visible}
                      style={{ width: '100%' }}
                      optionLabelProp={'data-value'}
                      onChange={(val) => {
                        this.setState({
                          productDetails: {
                            ...productDetails,
                            [key]: {
                              ...productDetails[key],
                              unit: val,
                            },
                          },
                        }, () => {
                          this.applyCalculatedContainerDetails()
                        });
                        
                      }}
                    >
                      {Object.keys(productUnits).map((unitKey) => (
                        <Select.OptGroup key={unitKey} label={this.renderUnitLabel(unitKey)}>
                          {productUnits[unitKey].map((unit) => {
                            // Skipping "cases" unit for weight in productUnits dropdown as it is required only in containerUnits
                            if (unitKey === 'weight' && EXCLUDED_WEIGHT_UNITS.includes(unit)) {
                              return null;
                            } else {
                              return (
                                <Select.Option key={unit} value={unit} data-value={unit}>
                                  {unit}
                                </Select.Option>
                              );
                            }
                          })}
                        </Select.OptGroup>
                        ))}
                    </Select>
                  )}
                </FormItem>
              </div>

              {inquiryFormPrefill && !hideProductCnFields && <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '6px',
                }}
              >
                <span
                  style={{
                    height: '28px',
                    margin: '0 8px 0 8px',
                    border: '0.95px solid #666666',
                  }}
                />
              </div>}

              {/* Product CN type section - hidden for LCL and Aircargo */}
              {inquiryFormPrefill && !hideProductCnFields && <div style={{ width: '12%' }}>
                <div className={classNames(classes.formTitles, classes.containerTitle)}>
                  Container Type
                </div>
                <FormItem className={classes.formItemSmallError}>
                  {getFieldDecorator(`productCnType${key}`, {
                    rules: [
                      { required: !visible && isRequired, message: 'Required' },
                      { validator: (rule, value, callback) => {
                        if (!value) {
                          callback();
                          return;
                        }
                        // Get all container types across all containers
                        const allContainerTypes = Object.keys(this.state.containers).map(containerKey =>
                          this.props.form.getFieldValue(`type${containerKey}`)
                        ).filter(Boolean);
                        if (allContainerTypes.length === 0 || allContainerTypes.includes(value)) {
                          callback();
                        } else {
                          callback(`Product container type ${containerTypeKeyLabelMap[value] || value} is invalid. Available shipment container types: ${allContainerTypes.map(type => containerTypeKeyLabelMap[type] || type).join(', ')}`);
                        } } }
                    ] })(
                    <Select
                      placeholder="Type"
                      style={{
                        width: '95%',
                      }}
                      allowClear
                      disabled={visible || this.disableRatesSearchParams()}
                      dropdownMatchSelectWidth={false}
                      onChange={(val) => {
                        this.setState({
                          productDetails: {
                            ...productDetails,
                            [key]: {
                              ...productDetails[key],
                              productCnType: val,
                            },
                          },
                        }, () => {
                          this.applyCalculatedContainerDetails()
                        });
                      }}
                    >
                      {containerListFromCargo.map((item) => (
                        <Option
                          key={item?.key?.type}
                          value={item?.key?.type}
                          data-value={item?.label?.type}
                        >
                          {item?.label?.type}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </div>}

              {/* Product CN Size Section - hidden for LCL and Aircargo */}
              {inquiryFormPrefill && !hideProductCnFields && <div style={{ width: '8%' }}>
                <div className={classNames(classes.formTitles, classes.containerTitle)}>Size</div>
                <FormItem className={classes.formItemSmallError}>
                  {getFieldDecorator(`productCnSize${key}`, { rules: [ 
                    { required: !visible && isRequired, message: 'Required' }, 
                    { validator: (rule, value, callback) => { 
                      if (!value) { 
                        callback(); 
                        return; 
                      } 
                      // Get all container sizes across all containers
                      const allContainerSizes = Object.keys(this.state.containers).map(containerKey => 
                        this.props.form.getFieldValue(`size${containerKey}`)
                      ).filter(Boolean); 
                      if (allContainerSizes.length === 0 || allContainerSizes.includes(value)) { 
                        callback(); 
                      } else { 
                        callback(`Product container size ${value} is invalid. Available shipment container sizes: ${allContainerSizes.join(', ')}`); 
                      } 
                    } } ] })(
                    <Select
                      placeholder="Size"
                      style={{ width: '95%' }}
                      allowClear
                      disabled={visible || this.disableRatesSearchParams()}
                      onChange={(val) => {
                        this.setState({
                          productDetails: {
                            ...productDetails,
                            [key]: {
                              ...productDetails[key],
                              productCnSize: val,
                            },
                          },
                        }, () => {
                          this.applyCalculatedContainerDetails()
                        });
                      }}
                    >
                      {containerSizes.map((item) => (
                        <Option
                          key={item?.key?.size}
                          value={item?.key?.size}
                          data-value={item?.key?.size}
                        >
                          {item?.label?.size}
                        </Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </div>}
              

              {/* Delete Product Button */}
              <div>
                {!visible &&Object.keys(productDetails).length > 1? (
                  <Tooltip title="Delete this product">
                    <Icon
                      type="close"
                      style={{
                        cursor: 'pointer',
                        color: 'red',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      onClick={() => {
                        const newProductDetails = { ...productDetails };
                        delete newProductDetails[key];
                        this.setState(
                          {
                            productDetails: newProductDetails,
                          },
                          () => {
                            this.applyCalculatedContainerDetails();
                          }
                        );
                      }}
                    />
                  </Tooltip>
                ) : null}
              </div>
            </div>

            {/* Add More Button (below the row) */}
            {!this.disableRatesSearchParams() && ind === Object.keys(productDetails).length - 1 && (
              <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', left: '12%', bottom:'10px' }}>
                <Icon
                  type="plus"
                  style={{
                    height: '18px',
                    width: '18px',
                    color: disabledFields ? 'grey' : tokens.colors.primary,
                    paddingTop: '2px',
                  }}
                />
                <a
                  type="plus-circle"
                  style={{
                    cursor: 'pointer',
                    color: disabledFields ? 'grey' : tokens.colors.primary,
                    marginLeft: '3px',
                  }}
                  onClick={() => {
                    if (disabledFields) return;
                    const newKey = this.state.productDetailsKey;
                    this.setState({
                      productDetails: {
                        ...productDetails,
                        [newKey]: {
                          key: '',
                          quantity: 0,
                          unit: 'kg',
                          productCnType: '',
                          productCnSize: '',
                          containerAndQuantityDetails: [],
                        },
                      },
                      productDetailsKey: this.state.productDetailsKey + 1,
                    }, () => {
                      this.applyCalculatedContainerDetails()
                    });
                  }}
                >
                  Add More
                </a>
              </div>
            )}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  };
  
renderUnitLabel = (label) => {
  return <div
  style={{ paddingRight: 30, width: '13.5%',
    color: '#262626',
    fontSize: tokens.fontSize.small, }}
>
  {label}
</div>;
}

  renderCargoReadyDate = () => {
    const {
      classes,
      form: { getFieldDecorator },
    } = this.props;
    return (
      <div className={classes.rowDiv}>
        <span className={classes.formTitles} style={{ whiteSpace: 'nowrap', width: '23%' }}>
        {resolveFieldLabel('grid#cargoReadyDate', 'Cargo Ready Date', this.state.inquiryFieldLabelMap)}
        </span>
        <FormItem className={classes.formItemSmallError} style={{ width: '60%' }}>
          {getFieldDecorator('cargoReadyDate')(
            <DatePicker
              allowClear
              style={{ width: '80%' }}
              format="DD MMM YYYY"
              placeholder="Cargo Ready Date"
              onChange={(date) => {
                this.setState({
                  cargoReadyDate: date,
                });
              }}
            />
          )}
        </FormItem>
      </div>
    );
  };

  renderCustomTextField = (name, key, isMandatory=false, initialValue=undefined) => {
    const {
      classes,
      form: { getFieldDecorator },
      booking,
    } = this.props;
    const { prefilling, source } = this.state;

    return (
      <div className={classes.rowDiv}>
        <span className={classes.formTitles} style={{ whiteSpace: 'nowrap', width: '23%' }}>
          {name}{isMandatory ? ' *' : ''}
        </span>
        <FormItem className={classes.formItemSmallError} style={{ width: '60%' }}>
          {getFieldDecorator(`${key}`, {
            rules: [{ required: isMandatory, message: 'Required' }],
            initialValue,
          })(
            <Input
              disabled={booking ? !this.isBookedFromSpotRates() : prefilling} 
              style={{ width: '80%' }}
              placeholder={name}
            />
          )}
        </FormItem>
      </div>
    );
  };

  renderCustomDropDown = (name, key, values=[], isMandatory=false, initialValue=undefined) => {
    const {
      form, classes, booking,
    } = this.props;
    const { prefilling, source } = this.state;
    return (
      <div className={classes.rowDiv}>
        <span className={classes.formTitles} style={{ whiteSpace: 'nowrap', width: '23%' }}>
          {name}{isMandatory ? ' *' : ''}
        </span>
        <Form.Item className={classes.formItemSmallError} style={{ width: '60%' }}>
          {form.getFieldDecorator(`${key}`, {
            rules: [{ required: isMandatory, message: 'Required' }],
            initialValue,
          })(
            <Select 
              disabled={booking ? !this.isBookedFromSpotRates() : prefilling} 
              allowClear 
              style={{ width: '80%' }}
              placeholder={name}>
              {values.length && values.map((value: string) => (
                <Select.Option key={value} value={value} data-value={value}>{value}</Select.Option>
              ))}
            </Select>
          )}
          </Form.Item>
      </div>
    );
  }

  renderCustomRadio = (name, key, isMandatory=false, initialValue=false, renderNullVal = false) => {
    const {
      form: { getFieldDecorator },
      classes,
      booking,
    } = this.props;
    return (
      <div
        className={classes.rowDiv}
        style={{
          height: '30px',
          marginBottom: '8px',
        }}
      >
        <span className={classNames(classes.formTitles, classes.gridLabelWidth)} style={{ whiteSpace: 'nowrap'}}>
          {name}{isMandatory ? ' *' : ''}
        </span>
        <FormItem style={{ marginBottom: '0px' }}>
          {getFieldDecorator(`${key}`, {
            initialValue,
          })(
            <RadioGroup>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
              {renderNullVal && <Radio value={null}>No Info</Radio>}
            </RadioGroup>
          )}
        </FormItem>
      </div>
    );
  };

  handleFFSelectionSend = async (ffList, groupList, strategicFFs) => {
    const { createInquiryData, discoverRatesSelectedFilters, discoverRatesSearchFilters } = this.props;
    const { incoterm, movementType } = discoverRatesSearchFilters;
    const { originServices, destinationServices } = discoverRatesSelectedFilters;

    const body = {
      ...createInquiryData?.createInquiryData,
      strategicFFs,
      organisationListForNegotiation: [
        ...ffList,
        ...discoverRatesSelectedFilters?.organisationList,
      ],
      organisationGroupList: groupList,
      incoterm,
      movementType,
      originServices,
      destinationServices
    };
    this.setState({ isLoading: true });
    const response = await inquiryCreateNegotiation(body);
    if (!response.isSuccess) {
      message.error(response.errorMessage);
    }
    sendEvent(this.getInquiryGACategory(), 'Negotiated Inquiry Created');
    this.setState({
      isLoading: false,
      isSendInquiryWithKYCVisible: response.isSuccess,
      isFFSelectionModalVisible: false,
      inquiryDataResponse: response?.data || this.state.inquiryDataResponse,
    });
  };

  renderContainerDetailsAndWeight = (): React.ReactElement => {
    return <Row style={{ marginBottom: '30px' }}>{this.renderContainerDetails()}</Row>;
  };

  renderCompleteProductDetails = (): React.ReactElement => {
    const { classes, inquiryFormPrefill, booking, form: { getFieldDecorator } } = this.props;
    const visible = booking || this.state.prefilling;
    return (
      <React.Fragment>
        <Row style={{ marginBottom: '30px', marginTop: '10px' }}>{this.renderProductDetailsWithCountandUnit()}</Row>
        {inquiryFormPrefill && (
          <div
            className={classes.rowDiv}
            style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}
          >
            <span
              className={classes.formTitles}
              style={{ width: '12%', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', marginRight: '6px' }}
            >
              {resolveFieldLabel('grid#dispatchMode', 'Dispatch Mode', this.state.inquiryFieldLabelMap)}
            </span>
            <div style={{ width: '20%', marginRight: '6px' }}>
              <FormItem style={{ marginBottom: '0px' }}>
                {getFieldDecorator('dispatchMode', {})(
                  <Select
                    allowClear
                    disabled={visible || this.disableRatesSearchParams()}
                    placeholder="Select Dispatch Mode"
                    data-testId={'dispatchModeDropdown'}
                    onChange={() => {
                      // ISS-288612 §5: re-resolve container quantities for the
                      // newly selected dispatch mode (loose vs pallet differ).
                      this.refreshProductContainerDetailsForDispatchMode();
                    }}
                  >
                    {DISPATCH_MODE_OPTIONS.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  renderAdditionalContainerDetails = (key): React.ReactElement => {
    const mode = this.getMode();
    const { booking, form : { getFieldValue }, masterData: { containerTypeSizeTempRange } } = this.props;
    const tempRange = containerTypeSizeTempRange?.[`${getFieldValue(`type${key}`)} ${getFieldValue(`size${key}`)}`];
    return (
      <div>
        {tempRange && booking && mode === 'FCL' && this.renderContainerTemperature(key, tempRange)}
      </div>
    );
  };

  renderHaulageSelection = (key): React.ReactElement => {
    const {
      masterData: { haulage },
      classes,
      form: { getFieldDecorator },
    } = this.props;
    return getFieldDecorator(key, {
      rules: [{ required: true, message: 'Required' }],
      initialValue: 'MERCHANT',
    })(
      <RadioGroup className={classes.haulage}>
        {haulage?.map((item) => (
          <Radio value={item.key}>{item.label}</Radio>
        ))}
      </RadioGroup>
    );
  };

  renderMovementType = (): React.ReactElement => {
    const { pickupAndDrop } = this.state;
    switch (pickupAndDrop) {
      case 'Port to Door':
        return this.renderHaulage('destinationMovement', 'POD To Door Movement');
      case 'Door to Port':
        return this.renderHaulage('originMovement', 'Door To POL Movement');
      case 'Door to Door':
        return this.renderDoorToDoorMovement();
      default:
        return <div></div>;
    }
  };

  renderPortMovement = (key, label): React.ReactElement => {
    const { classes } = this.props;
    return (
      <div style={{ marginTop: '6px', fontSize: `${tokens.fontSize.small}px` }} className={classes.flexRow}>
        <div style={{ fontWeight: tokens.fontWeight.semibold, marginRight: '20px', width: '18%' }}>{label}<Asterisk /></div>
        {this.renderHaulageSelection(key)}
      </div>
    );
  };

  renderDoorToDoorMovement = (): React.ReactElement => {
    return (
      <div style={{ fontSize: `${tokens.fontSize.caption}px`, marginTop: '10px' }}>
        {this.renderPortMovement('originMovement', 'Door to POL Movement')}
        {this.renderPortMovement('destinationMovement', 'POD to Door Movement')}
      </div>
    );
  };

  showMovementType = (): boolean => {
    const { pickupAndDrop } = this.state;
    return isValidString(pickupAndDrop) && pickupAndDrop !== 'Port to Port';
  };

  renderHaulage = (key, label): React.ReactElement => {
    return (
      <div style={{ marginTop: '6px', fontSize: `${tokens.fontSize.small}px` }}>
        <span style={{ fontWeight: tokens.fontWeight.semibold, marginRight: '20px' }}>{label}<Asterisk /></span>
        {this.renderHaulageSelection(key)}
      </div>
    );
  };

  getLeftColHazFields = () => {
    return {
      undgNumber: {
        key: 'productAdditionalDetails.undgNumber',
        label: 'UNDG Number',
        min: 4,
        max: 4,
      },
      emergencyContactName: {
        key: 'productAdditionalDetails.emergencyContactName',
        label: 'Emergency Contact Name',
      },
      emergencyContactNumber: {
        key: 'productAdditionalDetails.emergencyContactNumber',
        label: 'Emergency Contact Number',
        min: 1,
        max: 512,
      },
      emsNumber: {
        key: 'productAdditionalDetails.emsNumber',
        label: 'EMS Number',
        min: 1,
        max: 6,
      },
    };
  };

  renderLeftColHazFields = () => {
    const {
      classes,
      form: { getFieldDecorator },
    } = this.props;
    const hazFields = this.getLeftColHazFields();
    return Object.keys(hazFields)?.map((key) => (
      <div className={classes.hazDetails} style={{ alignItems: 'unset' }}>
        <Col span={7} className={classes.additionalDetailsLabel} style={{ marginTop: '10px' }}>
          {hazFields[key]?.label}
        </Col>
        <Col span={16}>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator(hazFields[key]?.key, {
              rules: [
                {
                  min: hazFields[key]?.min,
                  message:
                    key === 'undgNumber'
                      ? 'Must container 4 characters'
                      : `Minimum ${hazFields[key]?.min} characters required`,
                },
                {
                  max: hazFields[key]?.max,
                  message:
                    key === 'undgNumber'
                      ? 'Must container 4 characters'
                      : `Maximum ${hazFields[key]?.max} characters allowed`,
                },
              ],
            })(<Input style={{ width: '100%' }} placeholder={hazFields[key]?.label} />)}
          </Form.Item>
        </Col>
      </div>
    ));
  };

  renderPackingGroup = () => {
    const {
      classes,
      form: { getFieldDecorator },
      masterData: { packingGroups },
    } = this.props;
    return (
      <div className={classes.hazDetails}>
        <Col span={6} className={classes.additionalDetailsLabel}>
          Packing Group
        </Col>
        <Col span={17}>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('productAdditionalDetails.packingGroup')(
              <Select allowClear style={{ width: '100%' }} placeholder="Select Packing Group">
                {packingGroups?.map((item) => (
                  <Select.Option key={item.label} value={item.label}>{item.label}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </div>
    );
  };

  renderflashPointTemp = () => {
    const {
      classes,
      form: { getFieldDecorator },
    } = this.props;
    return (
      <div className={classes.hazDetails} style={{ alignItems: 'unset' }}>
        <Col span={6} className={classes.additionalDetailsLabel} style={{ marginTop: '10px' }}>
          Flash Point Temp
        </Col>
        <Col span={17} style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Item
            style={{ marginBottom: 0, marginRight: '4px', display: 'inline-block', width: '25%' }}
          >
            {getFieldDecorator('productAdditionalDetails.flashPointTemp', {
              rules: [
                {
                  validator: (rule, value, cb) => {
                    if (value >= 1000) {
                      cb('Must be less than 1000');
                    } else cb();
                  },
                },
              ],
            })(
              <InputNumber
                type="number"
                style={{ width: '100%' }}
                precision={2}
                placeholder="0.00"
              />
            )}
          </Form.Item>
          <span>
            °<span style={{ fontWeight: 600 }}>C</span>
          </span>
        </Col>
      </div>
    );
  };

  renderShippingName = () => {
    const {
      classes,
      form: { getFieldDecorator },
    } = this.props;
    return (
      <div className={classes.hazDetails}>
        <Col span={6} className={classes.additionalDetailsLabel}>
          Shipping Name
        </Col>
        <Col span={17}>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('productAdditionalDetails.shippingName', {
              rules: [
                {
                  max: 512,
                  message: 'Maximum 512 characters allowed',
                },
              ],
            })(<Input style={{ width: '100%' }} placeholder="Shipping Name" />)}
          </Form.Item>
        </Col>
      </div>
    );
  };

  renderRightColHazFields = (): React.ReactElement => {
    return (
      <React.Fragment>
        {this.renderPackingGroup()}
        {this.renderShippingName()}
        {this.renderflashPointTemp()}
      </React.Fragment>
    );
  };

  renderAdditionalHazDetails = (): React.ReactElement => {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.additionalProductDetails}>Hazardous Product Details</div>
        <Row className={classes.additionalCargoDetails}>
          <Col span={11}>{this.renderLeftColHazFields()}</Col>
          <Col span={2}></Col>
          <Col span={11}>{this.renderRightColHazFields()}</Col>
        </Row>
      </React.Fragment>
    );
  };

  renderContainerTemperature  = (key, tempRange): React.ReactElement => {
    const { classes, form } = this.props;
    const { prefilling } = this.state;
    return (
      <div style={{ width: '50%', paddingLeft: '5px', display: 'flex' }}>
        <div>
          <div
            className={classNames(classes.formTitles, classes.containerTitle)}
            style={{ marginLeft: '8px' }}
          >
            Temperature
          </div>

          <FormItem
            style={{ width: '95%', marginBottom: '0px', paddingLeft: '8px' }}
            className={classes.formItemSmallError}
          >
            {form.getFieldDecorator(`carriageTemperature${key}`, {
              rules: [
                {
                  validator: (rule, value, cb) => {
                    if (!isValidNumber(value)) {
                      return cb('Please enter a valid number');
                    } else if (value > tempRange?.max) {
                      return cb(`Maximum ${tempRange?.max} allowed`);
                    } else if (value < tempRange?.min) {
                      return cb(`Minimum ${tempRange?.min} required`);
                    } else return cb();
                  },
                },
              ],
            })(
              <InputNumber
                type="number"
                placeholder="0.00"
                precision={2}
                disabled={prefilling}
                style={{ width: '100%' }}
              />
            )}
          </FormItem>
        </div>
        <span style={{ marginTop: '40%' }}>
          °<span style={{ fontWeight: 600 }}>C</span>
        </span>
      </div>
    );
  };

  renderTemperature = () => {
    const {
      classes,
      form: { getFieldDecorator, getFieldValue },
      masterData: { reeferProductTempRange },
      cargoList,
    } = this.props;
    let product = getFieldValue('product');
    const productObj = cargoList.find((cargo) => cargo.label.product === product);
    product = productObj?.key?.product;
   
    return (
      <Row style={{ marginBottom: '10px' }}>
        <Col span={8} className={classes.additionalDetailsLabel} style={{ marginTop: '10px' }}>
          Temperature*
        </Col>
        <Col span={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Item
            style={{ marginBottom: 0, marginRight: '4px', display: 'inline-block', width: '45%' }}
          >
            {getFieldDecorator('productAdditionalDetails.temperatureControlled', {
              rules: [
                {
                  validator: (rule, value, cb) =>
                    productTempValidation(rule, value, cb, reeferProductTempRange, product),
                },
              ],
              initialValue: reeferProductTempRange[product]?.max,
            })(
              <InputNumber
                type="number"
                style={{ width: '100%' }}
                precision={2}
                placeholder="Temperature"
              />
            )}
          </Form.Item>
          <span>
            °<span style={{ fontWeight: 600 }}>C</span>
          </span>
        </Col>
      </Row>
    );
  };

  renderRelativeHumidity = () => {
    const {
      classes,
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Row style={{ marginBottom: '10px' }}>
        <Col span={8} className={classes.additionalDetailsLabel} style={{ marginTop: '10px' }}>
          Relative Humidity*
        </Col>
        <Col span={16} style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Item
            style={{ marginBottom: 0, marginRight: '4px', display: 'inline-block', width: '45%' }}
          >
            {getFieldDecorator('productAdditionalDetails.relativeHumidity', {
              rules: [
                {
                  validator: (rule, value, cb) => {
                    if (!isValidNumber(value)) {
                      cb('Required');
                    } else if (value < 0) {
                      cb('Must be positive');
                    } else cb();
                  },
                },
              ],
            })(
              <InputNumber
                type="number"
                style={{ width: '100%' }}
                precision={2}
                placeholder="Relative Humidity"
              />
            )}
          </Form.Item>
          <span>
            <span style={{ fontWeight: 600 }}>%</span>
          </span>
        </Col>
      </Row>
    );
  };

  renderVentDetails = () => {
    const {
      classes,
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Row style={{ marginBottom: '10px' }}>
        <Col span={8} className={classes.additionalDetailsLabel} style={{ marginTop: '10px' }}>
          Vent Details*
        </Col>
        <Col span={16}>
          <Form.Item style={{ marginBottom: 0, marginRight: '4px' }}>
            {getFieldDecorator('productAdditionalDetails.ventSetting', {
              rules: [{ required: true, message: 'Required' }],
              initialValue: 'Closed',
            })(
              <RadioGroup>
                <Radio style={{ marginRight: '16px' }} value="Open">
                  Open
                </Radio>
                <Radio value="Closed">Closed</Radio>
              </RadioGroup>
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  renderAdditionalReeferDetails = (): React.ReactElement => {
    const { classes, isTemperatureControlledMandatory } = this.props;
    return (
      <React.Fragment>
        <div className={classes.additionalProductDetails}>Reefer Product Details</div>
        <div className={classes.additionalCargoDetails}>
          {!isTemperatureControlledMandatory && this.renderTemperature()}
          {this.renderRelativeHumidity()}
          {this.renderVentDetails()}
        </div>
      </React.Fragment>
    );
  };

  renderAdditionalCargoDetails = (): React.ReactElement | null => {
    const {
      form: { getFieldValue },
      skipAdditionalCargoDetailsInBooking
    } = this.props;

    if ( skipAdditionalCargoDetailsInBooking ) return null;
    
    if (getFieldValue('cargoType') === CargoType.HAZ) {
      return <Col span={19}>{this.renderAdditionalHazDetails()}</Col>;
    } else {
      return <Col span={8}>{this.renderAdditionalReeferDetails()}</Col>;
    }
  };

  renderAddDetails = (fieldType) => {
    const { classes } = this.props;
    const { showAddInputDestination, showAddInputOrigin, showAddInputIncoterm } = this.state;
    const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
    let inputFieldShown = false;
    let fieldDecorator = '';
    let inputFieldStateName = '';
    let placeholder = '';
    if (fieldType === 'destination') {
      inputFieldShown = showAddInputDestination || getFieldValue('destinationDetails');
      fieldDecorator = 'destinationDetails';
      inputFieldStateName = 'showAddInputDestination';
      placeholder = 'Write your details for Destination Services here';
    } else if (fieldType === 'origin') {
      inputFieldShown = showAddInputOrigin || getFieldValue('originDetails');
      fieldDecorator = 'originDetails';
      inputFieldStateName = 'showAddInputOrigin';
      placeholder = 'Write your details for Origin Services here';
    } else {
      inputFieldShown = showAddInputIncoterm || getFieldValue('incotermDetails');
      fieldDecorator = 'incotermDetails';
      inputFieldStateName = 'showAddInputIncoterm';
      placeholder = 'Write your details for Incoterm here';
    }
    if (fieldType === 'incoterm' && !getFieldValue('incoterm')) return null;
    if (inputFieldShown) {
      return (
        <div
          className={classes.rowDiv}
          style={fieldType === 'incoterm' ? {} : { marginTop: '8px', marginBottom: '20px' }}
        >
          <FormItem className={classes.formItemSmallError} style={{ width: '85%' }}>
            {getFieldDecorator(
              fieldDecorator,
              {}
            )(<Input.TextArea placeholder={placeholder} style={{ width: '100%' }} />)}
          </FormItem>
          <Icon
            type="close"
            className={classes.addDetailsCloseIcon}
            onClick={() => {
              this.setState({ [inputFieldStateName]: false });
              setFieldsValue({ [fieldDecorator]: undefined });
            }}
          />
        </div>
      );
    } else {
      return (
        <div
          className={classes.rowDiv}
          style={fieldType === 'incoterm' ? {} : { marginTop: '8px', marginBottom: '20px' }}
        >
          <Icon type="plus" className={classes.addDetailsPlusIcon} />
          <a
            style={{
              color: tokens.colors.primary,
              marginLeft: '8px',
              float: 'left',
            }}
            onClick={() => this.setState({ [inputFieldStateName]: true })}
          >
            Add Details
          </a>
        </div>
      );
    }
  };

  isProductMandatory = (): boolean => {
    const mode = this.getMode();
    const { booking } = this.props;
    return [InquiryModes.FCL, InquiryModes.LCL, InquiryModes.AIRCARGO].includes(mode) && booking;
  };

  prefillServicesAndMovementType = (
    incoterm,
    pickupAndDrop = undefined,
    originServices = undefined,
    destinationServices = undefined,
    savedOriginLocation = undefined,
    savedDestinationLocation = undefined
  ) => {
    const { incotermToServices, incotermToPickupAndDrop, defaultOriginDestinationServiceSelection, form } = this.props;
    const { serviceType } = this.state;
    const mode = this.getMode();
    
    // Get the services from incoterm mapping
    const newOriginServices = 
      originServices ||
      incotermToServices?.[serviceType?.toUpperCase()]?.[incoterm]?.[mode]?.['ORIGIN'] ||
      (defaultOriginDestinationServiceSelection ? [] : serviceType === 'export' ? ['Port Service'] : []);
    
    const newDestinationServices = 
      destinationServices ||
      incotermToServices?.[serviceType?.toUpperCase()]?.[incoterm]?.[mode]?.['DESTINATION'] ||
      (defaultOriginDestinationServiceSelection ? [] : serviceType === 'import' ? ['Port Service'] : []);

    // Get the pickup and drop value from config
    const newPickupAndDrop = pickupAndDrop || incotermToPickupAndDrop?.[serviceType?.toUpperCase()]?.[incoterm];

    // Prefill stuffing and destuffing locations based on pickup and drop only when we don't have
    // saved values from the inquiry (edit/duplicate/booking). When user manually selected Factory
    // despite port-to-port, we must preserve that choice for each side independently.
    // "Door" -> "Factory", "Port" -> "Dock/CFS/Customs Warehouse"
    if (newPickupAndDrop && incotermToPickupAndDrop) {
      const isValidKey = Object.values(ALLOWED_PICKUP_AND_DROP).includes(newPickupAndDrop);
      if (isValidKey) {
        const key = newPickupAndDrop as ALLOWED_PICKUP_AND_DROP;
        const { FROM, TO } = PICKUP_AND_DROP_SPLITUP[key];
        const derivedStuffingLocation = FROM === PICKUP_AND_DROP_POINT.DOOR
          ? VALID_LOCATION_TYPES.FACTORY
          : VALID_LOCATION_TYPES.DOCK_CFS_CUSTOMS_WAREHOUSE;
        const derivedDeStuffingLocation = TO === PICKUP_AND_DROP_POINT.DOOR
          ? VALID_LOCATION_TYPES.FACTORY
          : VALID_LOCATION_TYPES.DOCK_CFS_CUSTOMS_WAREHOUSE;
        const fieldsToSet: Record<string, string> = {}
        if (!savedOriginLocation) {
          fieldsToSet.stuffingLocation = derivedStuffingLocation;
        }
        if (!savedDestinationLocation) {
          fieldsToSet.deStuffingLocation = derivedDeStuffingLocation;
        }
        if (Object.keys(fieldsToSet).length) {
          form.setFieldsValue(fieldsToSet);
        }
      }
    }

    this.setState({
      ...(incotermToPickupAndDrop && {
        pickupAndDrop: newPickupAndDrop || undefined,
      }),
      originServices: newOriginServices,
      destinationServices: newDestinationServices
    });
  };

  handleSelectedServices = (options, selectedServicesList, selectedServicesListKey) => {
    const services = isValidArray(selectedServicesList) ? clone(selectedServicesList) : [];
    const isServiceSelected = selectedServicesList.some(
      (services) => services === options?.[0]?.key
    );
    if (isServiceSelected) {
      const selectedServicesList = isValidArray(services)
        ? services.filter((service) => service !== options?.[0]?.key)
        : [];
      this.setState({ [selectedServicesListKey]: selectedServicesList });
    } else {
      this.setState({
        [selectedServicesListKey]: [...services, options?.[0]?.key],
      });
    }
  };

  renderAdditionalServices = (selectedServicesList, selectedServicesListKey) => {
    const {
      masterData: { inquiryModeExtraServices },
      booking,
    } = this.props;
    const mode = this.getMode();
    const defaultServices = this.state.allowedServices?.map((item) => item.label);
    return (
      <React.Fragment>
        <Select
          mode="multiple"
          style={{ width: '85%', margin: '12px 0' }}
          showSearch
          allowClear
          showArrow
          disabled={booking}
          optionFilterProp={'data-value'}
          placeholder="Add More Services"
          value={[]}
          onChange={(filtervals, options) =>
            this.handleSelectedServices(options, selectedServicesList, selectedServicesListKey)
          }
        >
          {Object.keys(inquiryModeExtraServices?.[mode])?.map((service) => (
            <Select.Option style={{ display: 'flex' }} key={service} value={service}>
              <Checkbox
                key={service}
                checked={selectedServicesList?.some((item) => item === service)}
                style={{ marginRight: '10px' }}
              />
              <span>{inquiryModeExtraServices?.[mode]?.[service]}</span>
            </Select.Option>
          ))}
        </Select>
        {selectedServicesList?.map(
          (service) =>
            defaultServices?.indexOf(service) === -1 && (
              <div style={{ marginTop: '8px' }}>
                <span style={{ marginRight: '10px' }}>{service}</span>
                {!booking && (
                  <Icon
                    type="close"
                    style={{ color: '#FF4646', fontSize: `${tokens.fontSize.caption}px` }}
                    onClick={() =>
                      this.handleRemoveService(
                        service,
                        selectedServicesList,
                        selectedServicesListKey
                      )
                    }
                  />
                )}
              </div>
            )
        )}
      </React.Fragment>
    );
  };

  handleRemoveService = (service, selectedServicesList, selectedServicesListKey) => {
    let serviceList = isValidArray(selectedServicesList) ? clone(selectedServicesList) : [];
    serviceList = serviceList?.filter((item) => item !== service);
    this.setState({ [selectedServicesListKey]: serviceList });
  };

  handleServiceChange = (service, serviceKey, value) => {
    const { discoverRatesSelectedFilters } = this.props;
    const defaultServices = this.state.allowedServices?.map((item) => item.label);
    const addtionalServicesSelected = service?.filter(
      (item) => defaultServices.indexOf(item) === -1
    );
    const servicesSelected = uniq([...addtionalServicesSelected, ...value]);
    this.setState({ [serviceKey]: servicesSelected });
  };

  renderDocuments = () => {
    const { docs, selectedFileViewer } = this.state;
    const { classes, masterData } = this.props;
    
    return (
      <>
        <Row
          gutter={24}
          style={{
            marginBottom: '25px',
            verticalAlign: 'middle',
          }}
          id="docUpload"
        >
          <Col span={18} style={{ marginTop: '10px' }}>
            <div className={classes.rowDiv}>
              <div
                style={{ width: '16%', marginTop: '3px' }}
                className={classes.formTitles}
              >
                Documents
              </div>
              <div style={{ width: '80%', display: 'flex', flexDirection: 'column' }}>
                {Object.keys(docs).map((doc) => {
                  const document = docs[doc];
                  const hasFile = document?.file && document?.file?.s3Link;
                  
                  return (
                    <div
                      className={classes.rowDiv}
                      key={doc}
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        marginBottom: '8px',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignContent: 'center',
                          width: '52%',
                        }}
                      >
                        <Select
                          value={document.type}
                          optionLabelProp="data-value"
                          onChange={(type) => {
                            this.setState({
                              docs: {
                                ...docs,
                                [doc]: {
                                  ...docs[doc],
                                  type,
                                },
                              },
                            });
                          }}
                          style={{ width: '64%' }}
                        >
                          {masterData.allowedDocumentTypes &&
                            Object.keys(masterData.allowedDocumentTypes).map((item) => {
                              return (
                                <Option
                                  key={item}
                                  value={item}
                                  data-value={masterData.allowedDocumentTypes[item]}
                                >
                                  {masterData.allowedDocumentTypes[item]}
                                </Option>
                              );
                            })}
                        </Select>
                        <Upload
                          style={{ width: '25%' }}
                          showUploadList={false}
                          multiple={false}
                          customRequest={(file: any) => this.s3LinkRequest(file, doc)}
                        >
                          <Button style={{ marginLeft: '10px' }}>
                            <Icon type="upload" /> Upload
                          </Button>
                        </Upload>
                      </div>
                      
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: '48%',
                          marginLeft: '1%',
                        }}
                      >
                        {document.uploading && (
                          <div style={{ marginRight: '10px' }}>
                            <Spin
                              indicator={
                                <Icon
                                  type="loading"
                                  style={{
                                    fontSize: tokens.fontSize.h1,
                                  }}
                                  spin
                                />
                              }
                            />
                          </div>
                        )}
                        
                        {hasFile && !document.uploading && (
                          <>
                           <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({
                                selectedFileViewer: {
                                  url: document.file.s3Link,
                                  fileName: document.file.name,
                                  title: `${document.type} - ${document.file.name}`,
                                }
                              });
                            }}
                            style={{ 
                              flex: 1, 
                              marginRight: '10px',
                              display: 'inline-block',
                              maxWidth: '300px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              verticalAlign: 'middle'
                            }}
                            title={`${document.type} - ${document.file.name}`}
                          >
                            <Icon type="file" style={{ marginRight: '5px' }} />
                            {document.type} - {document.file.name}
                          </a>

                            
                            <Tooltip title="Download file">
                              <Button
                                type="link"
                                icon="download"
                                onClick={() => {
                                  const link = window.document.createElement('a');
                                  link.href = document?.file?.s3Link;
                                  link.download = document?.file?.name;
                                  window.document.body.appendChild(link);
                                  link.click();
                                  window.document.body.removeChild(link);
                                }}
                                style={{ padding: '4px 8px' }}
                              />
                            </Tooltip>
                            
                            <Tooltip title="Remove file">
                              <Icon
                                type="close"
                                style={{
                                  color: '#FF4646',
                                  cursor: 'pointer',
                                  fontSize: `${tokens.fontSize.body}px`,
                                }}
                                onClick={() => {
                                  const newDocs = {
                                    ...docs,
                                    [doc]: {
                                      ...docs[doc],
                                      file: {},
                                    },
                                  };
                                  this.setState({
                                    docs: newDocs,
                                  });
                                }}
                              />
                            </Tooltip>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
                
                <div className={classes.rowDiv}>
                  <Icon
                    type="plus"
                    style={{
                      height: '18px',
                      width: '18px',
                      color: tokens.colors.primary,
                      paddingTop: '2px',
                    }}
                  />
                  <a
                    onClick={() => {
                      this.setState(prevState => {
                        const newKey = prevState.docsKey;
                        return {
                          docs: {
                            ...prevState.docs,
                            [newKey]: {
                              file: {},
                              type: 'CUSTOM INVOICE', 
                              uploading: false,
                            },
                          },
                          docsKey: prevState.docsKey + 1
                        };
                      });
                    }}
                    style={{
                      color: tokens.colors.primary,
                      marginLeft: '3px',
                      float: 'left',
                    }}
                  >
                    Add more
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        
        {selectedFileViewer && (
          <FileViewer
            url={selectedFileViewer.url}
            fileName={selectedFileViewer.fileName}
            title={selectedFileViewer.title}
            onClose={() => this.setState({ selectedFileViewer: null })}
          />
        )}
      </>
    );
  };
  

  renderStuffingOrDeStuffingAddNewMenu = (menu) => {
    return (
      <div>
        {menu}
        <Divider style={{ margin: '2px 0' }} />
        <div
          className={this.props.classes.addNewSelect}
          onMouseDown={() => {
            this.setState({ openNewLocationModal: true });
          }}
        >
          <Icon
            type="plus"
            style={{
              height: '12px',
              width: '12px',
              margin: '4px 4px 0 0',
            }}
          />
          <a
            style={{
              flex: 'none',
              display: 'block',
              cursor: 'pointer',
            }}
          >
            Add New
          </a>
        </div>
      </div>
    ) 
  }

renderContactInfo = (contactInfoArray, contactType = 'origin') => {
  const { classes } = this.props;
  const { getFieldDecorator } = this.props.form;
  const stateField = contactType === 'origin' ? 'inchargeContactOrigin' : 'inchargeContactDestination';
  
  if (!Array.isArray(contactInfoArray)) {
    console.warn(`contactInfoArray for ${contactType} is not an array:`, contactInfoArray);
    contactInfoArray = this.normalizeContactRows(contactInfoArray ? [contactInfoArray] : []);
  }
  
  // Adjust width based on contact type for proper alignment
  const labelWidth = '25%' 
  const inputContainerWidth = '70%'
  const inputFieldWidth = '85%';

  const addContact = () => {
    const newContactArray = [...contactInfoArray, this.createContactRow()];
    this.setState({
      [stateField]: newContactArray
    }, () => {
      this.syncContactFormFields(contactType, newContactArray);
    });
  };

  const removeContact = (contactId) => {
    if (contactInfoArray.length > 1) {
      const newContactArray = contactInfoArray.filter((contact) => contact?.id !== contactId);
      this.setState({
        [stateField]: newContactArray
      }, () => {
        this.syncContactFormFields(contactType, newContactArray);
      });
    }
  };

  const updateContact = (contactId, field, value) => {
    const newContactArray = contactInfoArray.map((contact) => {
      if (contact?.id !== contactId) {
        return contact;
      }

      return {
        ...contact,
        [field]: value
      };
    });

    this.setState({
      [stateField]: newContactArray
    });
  };

  return (
    <div className={classes.rowDiv} style={{ marginTop: '8px', marginBottom: '12px' }}>
      <div style={{ width: labelWidth, marginTop: '6px' }}>
        <span className={classes.formTitles}> {resolveFieldLabel('grid#inchargedetails', 'Incharge Details', this.state.inquiryFieldLabelMap)}</span>
      </div>
      <div style={{ width: inputContainerWidth }}>
        {contactInfoArray.map((contact, index) => (
          <div key={contact?.id || index} style={{ width: inputFieldWidth, display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
            {/* Name Input */}
            <FormItem style={{ marginBottom: '0px', width: '30%' }}>
              {getFieldDecorator(`${contactType}ContactName_${contact?.id || index}`, {
                initialValue: contact.name || '',
              })(
                <Input
                  placeholder="Name"
                  style={{ width: '100%' }}
                  onChange={(e) => updateContact(contact?.id, 'name', e.target.value)}
                />
              )}
            </FormItem>
            {/* Phone Input */}
            <FormItem style={{ marginBottom: '0px', width: '30%' }}>
              {getFieldDecorator(`${contactType}ContactPhone_${contact?.id || index}`, {
                initialValue: contact.phone || '',
                rules: [
                  {
                    pattern: /^[\d\s\-\+\(\)]+$/,
                    message: 'Please enter a valid phone number',
                  },
                  {
                    validator: (rule, value, cb) => {
                      if (!value) {
                        cb();
                        return;
                      }

                      const numericLength = value.replace(/\D/g, '').length;

                      if (numericLength && numericLength >= 7 && numericLength <= 15) {
                        cb();
                      } else {
                        cb('Phone number must be between 7 and 15 digits');
                      }
                    },
                  },
                ],
              })(
                <Input
                  placeholder="Phone"
                  style={{ width: '100%' }}
                  onChange={(e) => updateContact(contact?.id, 'phone', e.target.value)}
                />
              )}
            </FormItem>
            {/* Email Input */}
            <FormItem style={{ marginBottom: '0px', width: '30%' }}>
              {getFieldDecorator(`${contactType}ContactEmail_${contact?.id || index}`, {
                initialValue: contact.email || '',
                rules: [
                  {
                    type: 'email',
                    message: 'Please enter a valid email address',
                  },
                ],
              })(
                <Input
                  placeholder="Email"
                  style={{ width: '100%' }}
                  onChange={(e) => updateContact(contact?.id, 'email', e.target.value)}
                />
              )}
            </FormItem>
            {/* Remove Button */}
            {contactInfoArray.length > 1 && (
              <Icon
                type="minus-circle"
                style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: `${tokens.fontSize.h3}px` }}
                onClick={() => removeContact(contact?.id)}
              />
            )}
          </div>
        ))}
        {/* Add More Button */}
        <div 
          style={{ 
            color: tokens.colors.primary, 
            cursor: 'pointer', 
            fontSize: `${tokens.fontSize.small}px`,
            marginTop: '4px'
          }}
          onClick={addContact}
        >
          + Add More
        </div>
      </div>
    </div>
  );
};



  render() {
    const {
      docs,
      isSearching,
      containers,
      originPortsSearching,
      pickupAndDrop,
      destinationPorts,
      destinationPortsSearching,
      originPorts,
      isOriginDryPort,
      isDestinationDryPort,
      allowedServices,
      originPortsPre,
      destinationPortsPre,
      originPortsPreSearching,
      destinationPortsPreSearching,
      inquiryData,
      isSelectTeamModalVisible,
      teams,
      teamName,
      accessType,
      teamId,
      isFFSelectionModalVisible,
      inquiryDataResponse,
      isLoading,
      source,
      isSendInquiryWithKYCVisible,
      addProduct,
      trailerType,
      originServices,
      destinationServices,
      bookingAccessTeams,
      prefilling, 
      serviceType, 
      stuffingAddresses,
      disableModeSwitch,
      stopsAddressData,
      sentFFIds,
      stakeholderSearching,
      stakeholderList,
      stakeholder,
      stakeholderType,
      customer,
      customerList,
      customerSearching,
      prefilledStuffingAddress,
      prefilledDestuffingAddress,
      inquiryFormFieldConfig,
      inquiryFieldLabelMap,
      isInitialLoading
    } = this.state;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
    const {
      classes,
      masterData,
      staticData,
      match,
      booking,
      permissions,
      cargoTypes,
      discoverRatesSearchFilters,
      history,
      modeList,
      masterData: { reeferProductTempRange, inquiryModeExtraServices },
      cargoList,
      isTemperatureControlledMandatory,
      location,
      isHazCargoDocumentsRequired,
      visibleAccessTypes,
      inquiryTypeToIncoterms,
      customFieldsForInquiry,
      mandatoryFieldsInDraft,
      isDefaultInquiryTeamMapping,
      userData,
      inquiryFormPrefill,
      allowDestinationCountryEditInInquiry,
      enableAddressMasterInMenu
    } = this.props;
    const { INQUIRY_SEND_ACTIONS } = permissions;
    const visible = booking || this.state.prefilling;
    const visibleBooking = booking ? !this.isBookedFromSpotRates() : this.state.prefilling;
    const isAir = this.getMode() ? CreateEnquiryFormConfig[this.getMode()]?.isAir : false;
    const disabled = this.props.match.path.includes('edit') || booking || disableModeSwitch || isInitialLoading;
    const pickupAndDropType = pickupAndDrop as ALLOWED_PICKUP_AND_DROP;
    const pickUpConditionOrigin = [ALLOWED_PICKUP_AND_DROP.PORT_TO_PORT, ALLOWED_PICKUP_AND_DROP.PORT_TO_DOOR].includes(pickupAndDropType);
    const pickUpConditionDestination = [ALLOWED_PICKUP_AND_DROP.PORT_TO_PORT, ALLOWED_PICKUP_AND_DROP.DOOR_TO_PORT].includes(pickupAndDropType);
    const considerOriginLocation = this.props.inquiryConfig?.allowVendorToSpecifyOrigin && getFieldValue('stuffingAddress');
    const considerDestinationLocation = this.props.inquiryConfig?.allowVendorToSpecifyDestination && getFieldValue('deStuffingAddress');
    const originGiven = (this.state.originPort && (pickUpConditionOrigin || !pickupAndDrop)) || considerOriginLocation;
    const destinationGiven = (this.state.destinationPort && (pickUpConditionDestination || !pickupAndDrop)) || considerDestinationLocation;
    const isOriginCountryDisabled = visible || (this.state.originPortCountry && originGiven);
    const isDestinationCountryDisabled = visible || (!allowDestinationCountryEditInInquiry && this.state.destinationPortCountry &&  destinationGiven);
    const cargoSearched = JSON.parse(discoverRatesSearchFilters?.cargo || '[]');
    const mode = this.getMode();
    let product = getFieldValue('product');
  const productObj = cargoList.find((cargo) => cargo.label.product === product);
    product = productObj?.key?.product;
    const inquiryCustomFields = customFieldsForInquiry?.[mode] || {};
    const draftMandatoryFields = mandatoryFieldsInDraft?.[mode] || [];
    const showProductTempField =
      isTemperatureControlledMandatory && getFieldValue('cargoType') === CargoType.REEFER;
    // Stackable ,Packaging type, Unit and Internal reference number will be
    // disabled while creating booking
    const disabledFields = this.getMode() !== 'FCL' && booking;
    const stuffingLocation = getFieldValue('stuffingLocation');
    const deStuffingLocation = getFieldValue('deStuffingLocation');
    const showOriginContactInfoInRender =
      (!discoverRatesSearchFilters?.stuffingLocationId || this.getMode() === LCL) &&
      stuffingLocation !== 'Factory';
    const showDestinationContactInfoInRender =
      (!discoverRatesSearchFilters?.destuffingLocationId || this.getMode() === LCL) &&
      deStuffingLocation !== 'Factory';
    const accessIcons = {
      PUBLIC: <Icon type="global" />,
      PRIVATE: <Icon type="user" />,
      TEAM: <Icon type="team" />,
    };
    const isDraft = getFieldValue('isDraft');
    const isOriginPortRequired = (isDraft && draftMandatoryFields?.includes('origin')) || !this.props.inquiryConfig?.allowVendorToSpecifyOrigin;
    const isDestinationPortRequired = (isDraft && draftMandatoryFields?.includes('destination')) || !this.props.inquiryConfig?.allowVendorToSpecifyDestination;
    

    const typeOfMovement = getFieldValue('serviceType'); // 'import' or 'export'
    const stakeholderLabel =
      typeOfMovement === 'import' ? 'Supplier' : 'Customer';

    const hasOriginAndDestinationServicesInGridConfig = inquiryFormFieldConfig?.some((field) => {
      return field?.id === 'grid.additionalDetails.originDetailsAndServices' 
      || field?.id === 'grid.additionalDetails.destinationDetailsAndServices'
    })
    
    const teamLabel = (
      <>
        <Icon type="team"></Icon> {this.state.teamName}
      </>
    );
    const bookingAccessTeamsIds = Object.keys(bookingAccessTeams);
    return (
      <div
        style={{
          minWidth: visible ? '100%' : MIN_WIDTH,
          backgroundColor: tokens.colors.bgWhite,
          height: '100%',
        }}
      >
        <Form>
         
          {!visible && (
            <Navbar
              pageTitle={`${match.path.includes('edit') ? 'Edit' : 'Create'} Inquiry`}
              alwaysShowBack={this.fromDiscoverRates()}
            />
          )}
          {this.state.prefilling && (
            <div
              style={{
                height: '100%',
                width: '100%',
                textAlign: 'center',
                top: '30%',
                zIndex: 1000,
                position: 'absolute',
              }}
            >
              <Spin size="large" />
            </div>
          )}
          <div
            className={classes.formBody}
            style={{
              height: '100%',
              paddingTop: visible ? '0px' : '24px',
            }}
          >
            <Row
              gutter={24}
              style={{
                marginBottom: '25px',
                marginRight: '30px',
                verticalAlign: 'middle',
              }}
            >
              {this.disableRatesSearchParams() ? (
                <Col span={4}>
                  <strong>
                    {' '}
                    {this.getMode()} |{' '}
                    {this.state.prefilling ? <Spin size="small" /> : (prettifyString((getFieldValue('serviceType'))))}
                  </strong>{' '}
                </Col>
              ) : (
                <>
                  {draftMandatoryFields?.length > 0 ? (<Col
                    span={15}
                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '5px' }}
                  >
                    <span
                      className={classes.formTitles}
                      style={{ fontWeight: tokens.fontWeight.semibold, fontSize: `${tokens.fontSize.body}px` }}
                    >
                      {' '}
                      Draft{' '}
                    </span>
                    <FormItem style={{ marginLeft: '20px', marginBottom: '0px' }}>
                      {getFieldDecorator('isDraft', {
                        rules: [{ required: true }],
                        initialValue: true,
                      })(
                        <RadioGroup>
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </RadioGroup>
                      )}
                    </FormItem>
                  </Col>) : ''}
                  <Col
                    span={15}
                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                  >
                    <span
                      className={classes.formTitles}
                      style={{ fontWeight: tokens.fontWeight.semibold, fontSize: `${tokens.fontSize.body}px` }}
                    >
                      {' '}
                      Mode{' '}
                    </span>
                    <FormItem style={{ marginBottom: '0px', marginLeft: '20px' }}>
                      {getFieldDecorator('mode', {
                        initialValue: this.getMode() || 'FCL',
                      })(
                        <RadioGroup
                          onChange={this.handleModeChange}
                          disabled={disabled}
                          className={disabled ? classes.currentMode : undefined}
                        >
                          <Radio.Button style={{ padding: '0px 24px' }} value="FCL">
                            FCL
                          </Radio.Button>
                          <Radio.Button style={{ padding: '0px 24px' }} value="LCL">
                            LCL
                          </Radio.Button>
                          <Radio.Button style={{ padding: '0px 24px' }} value="AIRCARGO">
                            Air Cargo
                          </Radio.Button>
                          <Radio.Button style={{ padding: '0px 24px' }} value="TRAILER">
                            Trailer
                          </Radio.Button>
                          <Radio.Button style={{ padding: '0px 24px' }} value="DOMESTIC">
                            {this.props.showRoadInsteadOfDomestic ? 'Road' : 'Domestic'}
                          </Radio.Button>
                          <Radio.Button style={{ padding: '0px 24px' }} value="RPTL">
                            RPTL
                          </Radio.Button>
                        </RadioGroup>
                      )}
                    </FormItem>
                  </Col>
                  {this.getMode() === TRAILER && (
                    <Col
                      span={8}
                      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                    >
                      <span
                        className={classes.formTitles}
                        style={{ fontWeight: tokens.fontWeight.semibold, fontSize: `${tokens.fontSize.body}px` }}
                      >
                        {' '}
                        Type{' '}
                      </span>
                      <FormItem style={{ marginBottom: '0px', marginLeft: '20px' }}>
                        {getFieldDecorator('trailerType', {
                          initialValue: this.state.trailerType || trailerType || (isDraft ? InquiryType.IMPORT : InquiryType.EXPORT),
                        })(
                          <RadioGroup
                            className={classes.currentMode}
                            disabled={this.props.booking || this.isEditInquiry()}
                          >
                            <Radio.Button
                              style={{ padding: '0px 24px' }}
                              value={InquiryType.EXPORT}
                            >
                              Export
                            </Radio.Button>
                            <Radio.Button
                              style={{ padding: '0px 24px' }}
                              value={InquiryType.IMPORT}
                            >
                              Import
                            </Radio.Button>
                          </RadioGroup>
                        )}
                      </FormItem>
                    </Col>
                  )}
                </>
              )}
            </Row>
            {this.getMode() === TRAILER ? (
              <CreateTruckingInquiry
                parentClasses={classes}
                trailerType={this.getTrailerType()}
                form={this.props.form}
                stuffingAddressObj={this.state.stuffingTruckingAddress}
                prefilledCfsLocation={this.state.containerPickup}
                setStuffingTruckingAddress={this.setStuffingTruckingAddress}
                loadAddresses={this.loadAddresses}
                cfsAddresses={this.state.cfsAddresses}
                disableInquiryClosingDate={this.disableInquiryClosingDate}
                prefilling={this.state.prefilling}
                prefilledVehicleDetails={this.state.vehicleDetails}
                isBooking={this.props.booking}
                isEdit={this.isEditInquiry()}
                inquiryId={this.props.match?.params?.inquiryId}
                shipperId={this.state.shipperId}
                deStuffingAddressesList={this.state.deStuffingAddresses}
                stuffingAddressesList={this.state.stuffingAddresses}
                selectedCountryId={this.state.selectedCountryId}
                prefilledTermsAndConditions={this.state.termsAndConditions}
                updateDisableModeSwitch={this.updateDisableModeSwitch}
              />
            ) : this.getMode() === DOMESTIC || this.getMode() === RPTL ? (
              <CreateDomesticInquiry
                parentClasses={classes}
                trailerType={this.getTrailerType()}
                form={this.props.form}
                stuffingAddressObj={this.state.stuffingTruckingAddress}
                setStuffingTruckingAddress={this.setStuffingTruckingAddress}
                deStuffingAddressObj={this.state.deStuffingTruckingAddress}
                setDeStuffingTruckingAddress={this.setDeStuffingTruckingAddress}
                prefilledCfsLocation={this.state.containerPickup}
                loadAddresses={this.loadAddresses}
                cfsAddresses={this.state.cfsAddresses}
                disableInquiryClosingDate={this.disableInquiryClosingDate}
                prefilling={this.state.prefilling}
                prefilledVehicleDetails={this.state.vehicleDetails}
                isBooking={this.props.booking}
                isEdit={this.isEditInquiry()}
                inquiryId={this.props.match?.params?.inquiryId}
                shipperId={this.state.shipperId}
                deStuffingAddressesList={this.state.deStuffingAddresses}
                stuffingAddressesList={this.state.stuffingAddresses}
                selectedCountryId={this.state.selectedCountryId}
                prefilledTermsAndConditions={this.state.termsAndConditions}
                updateDomesticDocsParent={this.updateDomesticDocsParent}
                docs={this.state.docs}
                docsKey={this.state.docsKey}
                containerKey={this.state.containerKey}
                packagingDetailsKeys={this.state.packagingDetailsKeys}
                updateDomesticPackagingDetailsKeysParent={this.updateDomesticPackagingDetailsKeysParent}
                stopLocationKeys={this.state.stopLocationKeys}
                updateStopLocationKeys={this.updateStopLocationKeys}
                stopsAddressData={stopsAddressData}
                isRPTL={this.getMode() === RPTL}
                productDetails={this.state.productDetails}
                productDetailsKey={this.state.productDetailsKey}
                productDetailList={this.state.productDetailList}
                productTypes={this.props.productTypes}
                productVehicleRuleSet={this.state.productContainerRuleSet}
                exportBehaviorEnabled={this.props.exportBehaviorEnabled}
                prefilledStakeholder={this.state.stakeholder}
                prefilledStakeholderList={this.state.stakeholderList}
                prefilledCustomer={this.state.customer}
                prefilledCustomerList={this.state.customerList}
                prefilledOriginIncharge={this.state.inchargeContactOrigin?.[0]}
                prefilledDestinationIncharge={this.state.inchargeContactDestination?.[0]}
                defaultInquiryMovementType={this.props.defaultInquiryMovementType}
              />
            ) : (
              <>
                <FormGridContainer 
                  formFields={inquiryFormFieldConfig}
                  gridRows={INQUIRY_FORM_GRID_ROWS}
                  gridCols={INQUIRY_FORM_GRID_COLS}
                  labelMap={this.state.inquiryFieldLabelMap}
                >
                {inquiryFormPrefill && <Row gutter={[0,24]}
                  style={{
                    marginRight: '30px',
                    padding: 0,
                    verticalAlign: 'middle',
                  }}
                >
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                    id='grid#stakeholder'
                  >
                  {/* For Shipper, we are fetching stakeholders from Shipper Master */}
                    <div className={classes.rowDiv}>
                      <div style={{ width: '25%' }}>
                        <span className={classes.formTitles} style={{ display: 'flex', flexDirection: 'column' }}> {stakeholderType} </span>{' '}
                      </div>
                      <div style={{ width: '70%' }}>
                        <FormItem style={{ marginTop: '0px', marginBottom: '8px', maxWidth: '70%' }}> 
                          {getFieldDecorator('stakeholderId', {})(
                            <Select
                              disabled={visible || this.disableRatesSearchParams()}
                              allowClear
                              showSearch
                              filterOption={(inputValue, option) => true}
                              optionLabelProp={'data-value'}
                              data-testId={'stakeholderDropdown'}
                              onSearch={(query) =>
                                this.handleStakeholderSearch(
                                  stakeholderType.toUpperCase(),
                                  query
                                )
                              }
                              onFocus={() => {
                                if (!stakeholder){
                                  this.handleStakeholderSearch(
                                    stakeholderType.toUpperCase(),
                                    ''
                                  )
                                }
                              }}
                              notFoundContent={
                                stakeholderSearching ? <Spin style={{ marginLeft: '45%' }} /> : 'No results found'
                              }
                              placeholder={`Select ${stakeholderType}`}
                              value={this.state.stakeholder?.org2Id}
                              onChange={(stakeholderId: any, option: any) => {
                                const stakeholderData = stakeholderList?.find((s) => s.org2Id === stakeholderId);
                                this.setState({
                                  stakeholder: stakeholderData
                                }, () => {
                                  this.handleStakeholderChange(stakeholderData);
                                });
                              }}
                            >
                              {
                                stakeholderList?.map((stakeholder) => (
                                  <Option
                                    key={stakeholder.org2Id}
                                    // {...stakeholder}
                                    value={stakeholder.org2Id}
                                    data-value={`${stakeholder.name} (${stakeholder.code})`}
                                  >
                                    <div>
                                        <span style={{ marginRight: '5px' }}>
                                          {`${stakeholder.name} (${stakeholder.code})`}
                                        </span>
                                      </div>

                                  </Option>
                                ))
                              }

                            </Select>
                          )}
                        </FormItem>
                      </div>
                    </div>
                  </Col>

                  <Col style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  id='grid#customer'
                    >
                    <div className={classes.rowDiv}>
                      <div style={{ width: '25%', margin: '4px 0px 15px 0px' }}>
                        <span className={classes.formTitles}> {resolveFieldLabel('grid#customer', 'Customer', this.state.inquiryFieldLabelMap)}</span>{' '}
                      </div>
                      <div style={{ width: '70%'}}>
                        <FormItem style={{ maxWidth: '70%'}}>
                          {getFieldDecorator('customerId', {})(
                            <Select
                              disabled={visible || this.disableRatesSearchParams()}
                              allowClear
                              showSearch
                              filterOption={(inputValue, option) => true}
                              optionLabelProp={'data-value'}
                              data-testId={'customerDropdown'}
                              onSearch={(query) =>
                                this.handleCustomerSearch(query)
                              }
                              onFocus={() => {
                                if (!customer){
                                  this.handleCustomerSearch('')
                                }
                              }}
                              notFoundContent={
                                customerSearching ? <Spin style={{ marginLeft: '45%' }} /> : 'No results found'
                              }
                              placeholder="Select Customer"
                              value={this.state.customer?.org2Id}
                              onChange={(customerId: any, option: any) => {
                                const customerData = customerList?.find((c) => c.org2Id === customerId);
                                this.setState({
                                  customer: customerData
                                }, () => {
                                  this.handleCustomerChange(customerData);
                                });
                              }}
                            >
                              {
                                customerList?.map((customer) => (
                                  <Option
                                    key={customer.org2Id}
                                    value={customer.org2Id}
                                    data-value={`${customer.name} (${customer.code})`}
                                  >
                                    <div>
                                        <span style={{ marginRight: '5px' }}>
                                          {`${customer.name} (${customer.code})`}
                                        </span>
                                      </div>

                                  </Option>
                                ))
                              }

                            </Select>
                          )}
                        </FormItem>
                      </div>
                    </div>
                  </Col>
                </Row>
              }
                
                <Row
                  gutter={[0,24]}
                  style={{
                    marginBottom: '0px',
                    marginRight: '30px',
                    padding: 0,
                    verticalAlign: 'middle',
                  }}
                >
                  <Col id='grid#originPort'  className={classes.rowDiv}>
                    <Col style={{ marginTop: '6px', width: '25%' }}>
                      <span className={classes.formTitles}> {resolveFieldLabel('grid#originPort', 'Origin', this.state.inquiryFieldLabelMap)}{(isDraft && draftMandatoryFields?.includes('origin')) || isOriginPortRequired ? <Asterisk /> : null} </span>{' '}                  
                    </Col>
                    <Col
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginBottom: '24px',
                        width: '75%',
                        padding: 0,
                      }}
                    >
                      <div style={{ display: 'flex' }}>
                        <FormItem
                          style={{
                            width: isOriginDryPort ? '44%' : '84%',
                            marginLeft: isOriginDryPort && '3px' ,
                            marginBottom: 0,
                          }}
                        >
                          <Select
                            disabled={visible || this.disableRatesSearchParams()}
                            allowClear
                            showSearch
                            filterOption={(inputValue, option) => true}
                            optionLabelProp={'data-value'}
                            data-testId={'originPortDropdown'}
                            onSearch={(query) =>
                              this.handlePortSearch(
                                'originPorts',
                                query,
                                isAir ? 'AIR' : ['DRY', 'WET']
                              )
                            }
                            onFocus={() =>
                              this.handlePortSearch(
                                'originPorts',
                                '',
                                isAir ? 'AIR' : ['DRY', 'WET'],
                                'POL'
                              )
                            }
                            notFoundContent={
                              originPortsSearching ? <Spin style={{ marginLeft: '45%' }} /> : ''
                            }
                            placeholder="Search and Select Origin"
                            value={this.state.originPort}
                            onChange={(port: any, option: any) => {
                              if (!this.props.masterData?.allowSamePolPod && this.state.destinationPort === port && port) {
                                message.error('Origin and Destination Port cannot be same');
                                return;
                              }
                              this.setState({
                                originPort: port,
                                originCountry: option?.props ? option.props.countryCode : undefined,
                                originPortCountry: option?.props
                                  ? option.props.countryCode
                                  : undefined,
                                isOriginDryPort: !isAir && option?.props?.type === 'DRY',
                                originPortName: option?.props ? option.props.name : undefined,
                              });
                            }}
                          >
                            {originPorts?.map((item: any) => {
                              return (
                                <Option
                                  key={item.code}
                                  {...item}
                                  value={item.code}
                                  data-value={`${item.name} [${item.code}]`}
                                >
                                  <div>
                                    <span
                                      style={{ marginRight: '5px' }}
                                    >{`${item.name} [${item.code}]`}</span>
                                    {!isAir && item?.type === 'DRY' && (
                                      <button
                                        style={{
                                          float: 'right',
                                          fontSize: '9px',
                                          borderRadius: `${tokens.radius.md}px`,
                                          display: 'flex',
                                          alignContent: 'center',
                                          alignItems: 'center',
                                          alignSelf: 'center',
                                        }}
                                      >
                                        ICD
                                      </button>
                                    )}
                                  </div>
                                </Option>
                              );
                            })}
                          </Select>
                        </FormItem>
                        {isOriginDryPort && (
                          <FormItem style={{ marginLeft: '8px', width: '44%', marginBottom: 0 }}>
                            {getFieldDecorator(
                              'originPreferredWetPort',
                              {}
                            )(
                              <Select
                                disabled={visible}
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                optionLabelProp={'data-value'}
                                filterOption={() => true}
                                onSearch={(query) =>
                                  this.handlePortSearch('originPortsPre', query, 'WET')
                                }
                                onFocus={() => this.handlePortSearch('originPortsPre', '', 'WET')}
                                notFoundContent={
                                  originPortsPreSearching ? (
                                    <Spin style={{ marginLeft: '45%' }} />
                                  ) : (
                                    ''
                                  )
                                }
                                placeholder="Preferred Sea Port"
                              >
                                {originPortsPre?.map((item: any) => {
                                  return (
                                    <Select.Option
                                      key={item.code}
                                      value = {item.code}
                                      data-value={`${item.name} [${item.code}]`}
                                    >
                                      {`${item.name} [${item.code}]`}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            )}
                          </FormItem>
                        )}
                      </div>
                      {isOriginDryPort &&
                        mode === 'FCL' &&
                        this.renderHaulage('originHaulage', 'Haulage')}
                    </Col>
                  </Col>
                 
                  
               
                   <Col id = 'grid#destinationPort' className={classes.rowDiv}>
                    <Col  style={{ marginTop: 6, width: '25%'}}>
                    <strong className={classes.formTitles}>{resolveFieldLabel('grid#destinationPort', 'Destination', this.state.inquiryFieldLabelMap)}{(isDraft && draftMandatoryFields?.includes('destination')) || isDestinationPortRequired ? <Asterisk /> : null}</strong>
                    </Col>
                    <Col className={classes.destinationDiv}>
                      <div style={{ display: 'flex' }}>
                        <FormItem
                          style={{
                            width: isDestinationDryPort ? '47%' : '84%',
                            marginBottom: 0,
                          }}
                        >
                          <Select
                            disabled={visible || this.disableRatesSearchParams()}
                            allowClear
                            showSearch
                            filterOption={(inputValue, option) => true}
                            value={this.state.destinationPort}
                            optionLabelProp="data-value"
                            data-testId={'destinationPortDropdown'}
                            onSearch={(query) =>
                              this.handlePortSearch(
                                'destinationPorts',
                                query,
                                isAir ? 'AIR' : ['DRY', 'WET']
                              )
                            }
                            onFocus={() =>
                              this.handlePortSearch(
                                'destinationPorts',
                                '',
                                isAir ? 'AIR' : ['DRY', 'WET'],
                                'POD'
                              )
                            }
                            notFoundContent={
                              destinationPortsSearching ? (
                                <Spin style={{ marginLeft: '45%' }} />
                              ) : (
                                ''
                              )
                            }
                            placeholder="Search and Select Destination"
                            onChange={(port: any, option: any) => {
                              if (!this.props.masterData?.allowSamePolPod && this.state.originPort === port && port) {
                                message.error('Origin and Destination Port cannot be same');
                                return;
                              }
                              this.setState({
                                destinationCountry:
                                  option && option.props ? option.props.countryCode : undefined,
                                destinationPortCountry:
                                  option && option.props ? option.props.countryCode : undefined,
                                isDestinationDryPort:
                                  !isAir && option && option.props && option.props.type === 'DRY',
                                destinationPort: port,
                                destinationPortName:
                                  option && option.props ? option.props.name : undefined,
                              });
                            }}
                          >
                            {destinationPorts?.map((item: any) => {
                              return (
                                <Option
                                  key={item.code}
                                  {...item}
                                  value={item.code}
                                  data-value={`${item.name} [${item.code}]`}
                                >
                                  <div>
                                    <span
                                      style={{ marginRight: '5px' }}
                                    >{`${item.name} [${item.code}]`}</span>
                                    {!isAir && item.type === 'DRY' && (
                                      <button
                                        style={{
                                          float: 'right',
                                          fontSize: '9px',
                                          borderRadius: `${tokens.radius.md}px`,
                                          display: 'flex',
                                          alignContent: 'center',
                                          alignItems: 'center',
                                          alignSelf: 'center',
                                        }}
                                      >
                                        ICD
                                      </button>
                                    )}
                                  </div>
                                </Option>
                              );
                            })}
                          </Select>
                        </FormItem>
                        {isDestinationDryPort && (
                          <FormItem style={{ width: '46%', marginBottom: 0 }}>
                            {getFieldDecorator(
                              'destinationPreferredWetPort',
                              {}
                            )(
                              <Select
                                disabled={visible}
                                allowClear
                                showSearch
                                style={{ width: '98%', marginLeft: '7px' }}
                                optionLabelProp={'data-value'}
                                filterOption={() => true}
                                onSearch={(query) =>
                                  this.handlePortSearch('destinationPortsPre', query, 'WET')
                                }
                                onFocus={() =>
                                  this.handlePortSearch('destinationPortsPre', '', 'WET')
                                }
                                notFoundContent={
                                  destinationPortsPreSearching ? (
                                    <Spin style={{ marginLeft: '45%' }} />
                                  ) : (
                                    ''
                                  )
                                }
                                placeholder="Preferred Sea Port"
                              >
                                {destinationPortsPre.map((item: any) => {
                                  return (
                                    <Select.Option
                                      key={item.code}
                                      value={item.code}
                                      data-value={`${item.name} [${item.code}]`}
                                    >
                                      {`${item.name} [${item.code}]`}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            )}
                          </FormItem>
                        )}
                      </div>
                      {isDestinationDryPort &&
                        mode === 'FCL' &&
                        this.renderHaulage('destinationHaulage', 'Haulage')}
                    </Col>
                  </Col>
              
                </Row>

                <Row
                  gutter={[0,24]}
                  style={{
                    marginBottom: '0px',
                    marginRight: '10px',
                    verticalAlign: 'middle',
                  }}
                >
                  <Col id="grid#cargoAndProduct" className={classes.rowDiv}>
                      <span className={classNames(classes.formTitles, classes.gridLabelWidth)}> {resolveFieldLabel('grid#cargoAndProduct', 'Cargo & Product', this.state.inquiryFieldLabelMap)}{(isDraft && draftMandatoryFields?.includes('cargoType')) || !isDraft ? <Asterisk /> : null}</span>{' '}
                    <div className={classNames(classes.rowDiv, classes.gridInputFieldWidth)}>
                      <FormItem
                        style={{ width: '30%', marginBottom: 0 }}
                        className={classes.formItemSmallError}
                      >
                        {getFieldDecorator('cargoType', {
                          initialValue: this.fromDiscoverRates()
                            ? cargoSearched?.key?.cargo
                            : (!isDraft || (isDraft && draftMandatoryFields?.includes('cargoType'))) ? 'GENERAL' : undefined,
                          rules: [{ required: !visible && (!isDraft || (isDraft && draftMandatoryFields?.includes('cargoType'))), message: 'Cargo type is required' }],
                          trigger: undefined,
                        })(
                          <Select
                            disabled={visible || this.disableRatesSearchParams()}
                            showSearch
                            placeholder="Cargo Type"
                            optionLabelProp={'data-value'}
                            onChange={(cargo: any) => {
                              this.handleCargoChange(cargo);
                            }}
                          >
                            {cargoTypes?.map((item) => {
                              return (
                                <Option key={item.key} value={item.key} data-value={item.label}>
                                  {item.label}
                                </Option>
                              );
                            })}
                          </Select>
                        )}
                      </FormItem>
                      <FormItem
                        className={classes.formItemSmallError}
                        style={{
                          marginLeft: '6px',
                          width: showProductTempField ? '37%' : '57%',
                          marginBottom: 0,
                        }}
                      >
                        {getFieldDecorator('product', {
                          initialValue: this.fromDiscoverRates()
                            ? cargoSearched?.label?.product
                            : (!isDraft || (isDraft && draftMandatoryFields?.includes('productType'))) ? 'General Dry Goods' : undefined,
                          rules: [{ required: !visible && (!isDraft || (isDraft && draftMandatoryFields?.includes('productType'))) }],
                        })(
                          <Select
                            disabled={visible || this.disableRatesSearchParams()}
                            showSearch
                            placeholder="Select Product"
                            style={{ width: '100%' }}
                            optionLabelProp={'data-value'}
                            dropdownMatchSelectWidth={false}
                            onChange = {(val) => {
                              this.handleCargoProductTypeChange(val);
                            }}
                            notFoundContent={!this.getCargoType() && 'Please Select Cargo Type'}
                          >
                            {this.getProductOptions()}
                          </Select>
                        )}
                      </FormItem>
                      {showProductTempField && (
                        <React.Fragment>
                          <Form.Item
                            className={classes.formItemSmallError}
                            style={{ marginLeft: '6px', width: '18%', marginBottom: 0 }}
                          >
                            {getFieldDecorator('temperatureControlled', {
                              rules: [
                                {
                                  validator: (rule, value, cb) =>
                                    productTempValidation(
                                      rule,
                                      value,
                                      cb,
                                      reeferProductTempRange,
                                      product
                                    ),
                                },
                              ],
                            })(
                              <InputNumber
                                type="number"
                                style={{ width: '100%' }}
                                precision={2}
                                placeholder="0"
                              />
                            )}
                          </Form.Item>
                          <span style={{ margin: '8px 0 0 8px' }}>
                            °<span style={{ fontWeight: 600 }}>C</span>
                          </span>
                        </React.Fragment>
                      )}
                    </div>
                    <div style={{ marginBottom: '18px' }}>
                      {getFieldValue('cargoType') === CargoType.HAZ &&
                        mode === 'FCL' &&
                        ((!booking && isHazCargoDocumentsRequired) ||
                          (booking && !isHazCargoDocumentsRequired)) && (
                          <span className={classes.additionalDetails}>
                            Additional documents required for hazardous products.&nbsp;
                            <a
                              className={classes.docUpload}
                              href="#docUpload"
                              onClick={() =>
                                highlightDiv(
                                  document.getElementById('docUpload'),
                                  'rgba(24,144,255,0.02)',
                                  3000
                                )
                              }
                            >
                              Go to document upload.
                            </a>
                          </span>
                        )}
                    </div>                
                  </Col>
                  <Col
                    style={{ display: 'flex', flexDirection: 'column', marginBottom: '22px' }}
                    id='grid#stackable'
                  >
                    {this.renderStackable()}
                    {inquiryCustomFields?.isTiltable && this.renderCustomRadio(
                      inquiryCustomFields?.isTiltable?.prettyName || 'Tiltable',
                      'isTiltable',
                      (isDraft && draftMandatoryFields?.includes('isTiltable')) || 
                      (!isDraft && inquiryCustomFields?.isTiltable?.isMandatory) || 
                      false,
                      inquiryCustomFields?.isTiltable?.default || false,
                      true
                    )}
                    {this.getMode() === 'FCL' && (
                      <div
                        className={classes.rowDiv}
                        style={{
                          height: '30px',
                          marginBottom: '8px',
                        }}
                      >
                        <span
                          className={classes.formTitles}
                          style={{ whiteSpace: 'nowrap', width: '29%' }}
                        > 
                        </span>
                        <div className={classes.rowDiv}>
                          {}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <div id='grid#additionalCargoDetails'>
                  {
                    (getFieldValue('cargoType') === CargoType.HAZ ||
                    getFieldValue('cargoType') === CargoType.REEFER) &&
                    booking &&
                    mode === 'FCL' && (
                      <Row>
                        <Col span={3}></Col>
                        {this.renderAdditionalCargoDetails()}
                      </Row>
                    )
                  }
                </div>

                <div id="grid#packagingDetails">{this.renderPackagingDetails()} </div>
                <div id="grid#containerDetails">{this.renderContainerDetailsAndWeight()}</div>
                <div id="grid#productDetails">{this.renderCompleteProductDetails()}</div>
                <Row
                  gutter={24}
                  style={{
                    marginBottom: '0px',
                    marginRight: '10px',
                    verticalAlign: 'middle',
                  }}
                >
                  <div id='grid#defaultTnC'>
                    <Col span={3}>
                      <div
                        className={classes.rowDiv}
                        style={{ marginTop: this.getMode() === 'FCL' ? '0px' : '25px' }}
                        
                      >
                        <span className={classes.formTitles}> {resolveFieldLabel('grid#defaultTnC', 'Terms & Conditions', this.state.inquiryFieldLabelMap)}{(isDraft && draftMandatoryFields?.includes('termsAndConditions')) ? <Asterisk /> : null} </span>
                      </div>
                    </Col>
                    <Col  style={{ display: 'flex', flexDirection: 'column' }}>
                      <div className={classes.rowDiv}>
                        <FormItem style={{ width: '93%' }}>
                          {getFieldDecorator('terms', {
                            initialValue: masterData.termsAndConditions,
                            rules: [
                              {
                                required: isDraft && draftMandatoryFields?.includes('termsAndConditions'),
                                message: 'Terms and Conditions are required',
                              },
                            ],
                          })(
                            <Input.TextArea
                              placeholder={termsConditionsPlaceholder}
                              disabled={visibleBooking}
                              style={{ width: '95%', height: '150px' }}
                              autoComplete="new-password"
                            />
                          )}
                        </FormItem>
                      </div>
                    </Col>
                  </div>
                  <Col
                    span={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '22px',
                    }}
                  >
                    <div id='grid#cargoReadyDate'>{this.renderCargoReadyDate()}</div>
                    <div id='grid#internalReference' className={classes.rowDiv}>
                      <span
                        className={classes.formTitles}
                        style={{ whiteSpace: 'nowrap', width: '23%' }}
                      >
                         {resolveFieldLabel('grid#internalReference', inquiryCustomFields?.internalReferenceNumber?.isMandatory ? 'Internal Reference # *' : 'Internal Reference #',  this.state.inquiryFieldLabelMap)}
                      </span>
                      <FormItem className={classes.formItemSmallError} style={{ width: '60%' }}>
                        {getFieldDecorator(
                          'internalReferenceNumber',
                          {rules: [
                            {
                              required: inquiryCustomFields?.internalReferenceNumber?.isMandatory || false,
                              message: 'Required',
                            },
                          ]}
                        )(
                          <Input
                            disabled={[FCL, LCL, AIRCARGO].indexOf(this.getMode()) === -1 && booking}
                            placeholder="Enter Reference Number"
                            style={{ width: '80%' }}
                          />
                        )}
                      </FormItem>
                    </div>
                    <div id='grid#preferredSailingRange' className={classes.rowDiv}>
                      <span className={classes.formTitles} style={{ width: '23%' }}>
                        {
                          // TODO(code-cleanup): Find a way to replace these conditional for cleaner code!
                          CreateEnquiryFormConfig[this.getMode()].isAir ? (
                            resolveFieldLabel('grid#preferredFlyingRange', 'Preferred Flying Range', this.state.inquiryFieldLabelMap)
                          ) : (
                            <React.Fragment>
                              {resolveFieldLabel('grid#prederredSailingRange', 'Sailing Range', this.state.inquiryFieldLabelMap)}/ <br />
                              {resolveFieldLabel('grid#contractDuration', 'Contract Duration', this.state.inquiryFieldLabelMap)}
                            </React.Fragment>
                          )
                        }
                        {!this.isBookedFromSpotRates() ? <Asterisk /> : null}
                      </span>
                      <FormItem className={classes.formItemSmallError} style={{ width: '60%' }}>
                        {getFieldDecorator('preferredSailingRange', {
                          rules: [
                            {
                              required: !this.isBookedFromSpotRates(),
                              message: 'preferred sailing is required',
                            },
                          ],
                          initialValue: [
                            moment().endOf('day').add(7, 'day'),
                            moment().endOf('day').add(14, 'day'),
                          ],
                        })(
                          <RangePicker
                            allowClear
                            disabledDate={this.disablePastDate}
                            format="DD MMM YYYY"
                            style={{ width: '80%', marginBottom: '0px' }}
                            onChange={(date) => {
                              this.setState({
                                preferredSailingRange: date,
                              });
                            }}
                          />
                        )}
                      </FormItem>
                    </div>

                    {!booking && (
                      <div id='grid#inquiryClosingDate' className={classes.rowDiv}>
                        <span className={classes.formTitles} style={{ width: '23%' }}>
                        {resolveFieldLabel('grid#inquiryClosingDate', 'Inquiry Closing Date', this.state.inquiryFieldLabelMap)}{(!isDraft || (isDraft && draftMandatoryFields?.includes('deadline'))) ? <Asterisk /> : null}
                        </span>
                        <FormItem className={classes.formItemSmallError} style={{ width: '60%' }}>
                          {getFieldDecorator('inquiryClosing', {
                            rules: [
                              { required: !visible && (!isDraft || (isDraft && draftMandatoryFields?.includes('deadline'))), message: 'inquiry closing date is required' },
                            ],
                            initialValue: (!isDraft || (isDraft && draftMandatoryFields?.includes('deadline'))) ? masterData?.defaultDeadlineInHours ?
                              moment().add(masterData?.defaultDeadlineInHours, 'hours') :
                              moment().endOf('day').add(2, 'day') : undefined,
                          })(
                            <DatePicker
                              showTime
                              disabled={visible}
                              disabledDate={this.disableInquiryClosingDate}
                              disabledTime={disableInquiryClosingTimeUtil}
                              allowClear={false}
                              format="DD MMM YYYY | HH:mm"
                              style={{ width: '80%', marginBottom: '20px' }}
                              placeholder="Inquiry Closing Date"
                            />
                          )}
                        </FormItem>
                      </div>
                    )}
                    <div id='grid#inquiryCustomFields'>
                      {inquiryCustomFields?.shipmentName && this.renderCustomTextField(
                        inquiryCustomFields?.shipmentName?.prettyName || 'Shipment Name',
                        'shipmentName',
                        (isDraft && draftMandatoryFields?.includes('shipmentName')) || 
                        (!isDraft && inquiryCustomFields?.shipmentName?.isMandatory) || 
                        false,
                        inquiryCustomFields?.shipmentName?.default || undefined,
                      )}
                      {inquiryCustomFields?.requestor && this.renderCustomTextField(
                        inquiryCustomFields?.requestor?.prettyName || 'Requestor',
                        'requestor',
                        (isDraft && draftMandatoryFields?.includes('requestor')) || 
                        (!isDraft && inquiryCustomFields?.requestor?.isMandatory) || 
                        false,
                        inquiryCustomFields?.requestor?.default || undefined,
                      )}
                      {inquiryCustomFields?.typeOfContainer && this.renderCustomDropDown(
                        inquiryCustomFields?.typeOfContainer?.prettyName || 'Type of Container',
                        'typeOfContainer',
                        inquiryCustomFields?.typeOfContainer?.dropDown || [],
                        (isDraft && draftMandatoryFields?.includes('typeOfContainer')) || 
                        (!isDraft && inquiryCustomFields?.typeOfContainer?.isMandatory) || 
                        false,
                        inquiryCustomFields?.typeOfContainer?.default || undefined,
                      )}
                      {inquiryCustomFields?.serviceLevel && this.renderCustomDropDown(
                        inquiryCustomFields?.serviceLevel?.prettyName || 'Service Level',
                        'serviceLevel',
                        inquiryCustomFields?.serviceLevel?.dropDown || [],
                        (isDraft && draftMandatoryFields?.includes('serviceLevel')) || 
                        (!isDraft && inquiryCustomFields?.serviceLevel?.isMandatory) || 
                        false,
                        inquiryCustomFields?.serviceLevel?.default || undefined,
                      )}
                      {inquiryCustomFields?.typeOfMovement && this.renderCustomDropDown(
                        inquiryCustomFields?.typeOfMovement?.prettyName || 'Type of Import/Export',
                        'typeOfMovement',
                        inquiryCustomFields?.typeOfMovement?.dropDown || [],
                        (isDraft && draftMandatoryFields?.includes('typeOfMovement')) || 
                        (!isDraft && inquiryCustomFields?.typeOfMovement?.isMandatory) || 
                        false,
                        inquiryCustomFields?.typeOfMovement?.default || undefined,
                      )}
                      {(isDraft && inquiryCustomFields?.isDraftIncomplete) && this.renderCustomRadio(
                        inquiryCustomFields?.isDraftIncomplete?.prettyName || 'Draft Incomplete',
                        'isDraftIncomplete',
                        (isDraft && draftMandatoryFields?.includes('isDraftIncomplete')) || 
                        (!isDraft && inquiryCustomFields?.isDraftIncomplete?.isMandatory) || 
                        false,
                        inquiryCustomFields?.isDraftIncomplete?.default || undefined,
                      )}
                      {(isDraft && inquiryCustomFields?.remarks) && this.renderCustomTextField(
                        inquiryCustomFields?.remarks?.prettyName || 'Remarks',
                        'remarks',
                        (isDraft && draftMandatoryFields?.includes('remarks')) || 
                        (!isDraft && inquiryCustomFields?.remarks?.isMandatory) || 
                        false,
                        inquiryCustomFields?.remarks?.default || undefined,
                      )}
                    </div>
                  </Col>
                </Row>
                <div id='grid.additionalDetails'>
                  <Collapse
                    bordered={false}
                    activeKey={this.state.activeKey}
                    onChange={(e) => {
                      this.setState({ activeKey: e });
                    }}
                    style={{ backgroundColor: tokens.colors.bgWhite }}
                    
                  >
                    <Panel
                      header="Additional Details"
                      key="1"
                      style={{
                        border: 'none',
                      }}
                      className={visible ? '' : classes.panelHeader}
                    >
                      <Row
                        gutter={[0,24]}
                        style={{
                          marginBottom: '20px',
                          display: 'flex',
                          justifyContent: 'center',
                          marginRight: '30px',
                          verticalAlign: 'middle',
                        }}
                        id='movementType'
                      >
                        <Col span={12} style={{ display: 'flex', flexDirection: 'column' }}>
                          <div className={classes.rowDiv}>
                            <div style={{ width: '25%', marginTop: '10px' }}>
                              <span className={classes.formTitles}>
                              {resolveFieldLabel('grid#type', 'Type', this.state.inquiryFieldLabelMap)} </span>
                            </div>
                            <FormItem style={{ marginBottom: '0px', width: '70%' }}>
                              {getFieldDecorator('serviceType', {
                                // initialValue: this.fromDiscoverRates() && discoverRatesSearchFilters?.movementType?.toLowerCase() || !isDraft ? 'export' : 'import',
                                initialValue: serviceType
                            })(
                                <RadioGroup
                                  disabled={visibleBooking || ((this.fromDiscoverRates() || this.props.booking) && discoverRatesSearchFilters?.movementType)}
                                  options={[
                                    { label: 'Import', value: 'import' },
                                    { label: 'Export', value: 'export' },
                                  ]}
                                  onChange={(e) => this.handleServiceTypeChange(e)}
                                />
                              )}
                            </FormItem>
                          </div>
                        </Col>
                        <Col span={12}></Col>
                      </Row>
                      <Row
                        gutter={[0,24]}
                        style={{
                          marginRight: '0px',
                          verticalAlign: 'middle',
                          padding: 0,
                          border: '2px sol'
                        }}
                        id='incoterm'
                      >
                        <Col
                          span={12}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <div className={classes.rowDiv}>
                            <div style={{ width: '25%', marginTop: '6px' }}>
                              <span className={classes.formTitles}>Incoterm{(
                                ((!isDraft && this.props.isIncotermMandatory) || (isDraft && draftMandatoryFields?.includes('incoterm'))) 
                                && !booking
                              ) ? <Asterisk /> : null}</span>
                            </div>
                            <div style={{ width: '70%' }}>
                              <FormItem
                                style={{ marginTop: '0px', marginBottom: '8px' }}
                              >
                                {getFieldDecorator(
                                  'incoterm',
                                  {
                                    rules:[
                                      { required: (
                                        ((!isDraft && this.props.isIncotermMandatory) || (isDraft && draftMandatoryFields?.includes('incoterm'))) 
                                        && !booking
                                      ), message: 'Required' },
                                    ],
                                  },
                                  { initialValue: this.fromDiscoverRates() ? discoverRatesSearchFilters?.incoterm : undefined }
                                )(
                                  <Select
                                    disabled={visibleBooking || (this.fromDiscoverRates() && discoverRatesSearchFilters?.incoterm) || (this.props.booking && getFieldValue('incoterm'))}
                                    allowClear
                                    placeholder="Select Incoterm"
                                    style={{ width: '85%' }}
                                    optionLabelProp={'data-value'}
                                    onChange={(val) => {
                                      if (!getFieldValue('incoterm')) {
                                        this.setState({ showAddInputIncoterm: false });
                                        setFieldsValue({ incotermDetails: undefined });
                                      }
                                      this.prefillServicesAndMovementType(val);
                                    }}
                                    notFoundContent={
                                      isSearching ? (
                                        <div style={{ padding: '25px' }}>
                                          <Spin />
                                        </div>
                                      ) : (
                                        ''
                                      )
                                    }
                                  >
                                    {inquiryTypeToIncoterms?.[this.getInquiryType()]?.map((item) => (
                                      <Option key={item} value={item} data-value={item}>
                                        {item}
                                      </Option>
                                    ))}
                                  </Select>
                                )}
                              </FormItem>
                              {this.renderAddDetails('incoterm')}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row id='pickupAndDrop'>
                        <Col
                          span={12}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: 0
                          }}
                        >
                          <div className={classes.rowDiv} style={{ marginBottom: '15px' }}>
                            <div className={classes.gridLabelWidth}>
                              <span className={classes.formTitles}>  {resolveFieldLabel('grid#pickup&drop', 'Pickup & Drop', this.state.inquiryFieldLabelMap)}{(isDraft && draftMandatoryFields?.includes('pickupAndDrop')) ? <Asterisk /> : null} </span>
                            </div>
                            <div className={classes.gridInputFieldWidth} style={{ marginBottom: '24px' }}>
                              <FormItem style={{ marginBottom: 0 }}>
                                <Select
                                  disabled={visible}
                                  value={this.state.pickupAndDrop}
                                  placeholder="Port to Port"
                                  style={{ width: '85%' }}
                                  onChange={(val) => this.setState({ pickupAndDrop: val })}
                                  optionLabelProp={'data-value'}
                                  notFoundContent={
                                    isSearching ? (
                                      <div style={{ padding: '25px' }}>
                                        <Spin />
                                      </div>
                                    ) : (
                                      ''
                                    )
                                  }
                                >
                                  {masterData.allowedPickupAndDrop.map((item) => (
                                    <Option key={item} value={item} data-value={item}>
                                      {item}
                                    </Option>
                                  ))}
                                </Select>
                              </FormItem>
                              {this.showMovementType() && mode === 'FCL' && this.renderMovementType()}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row
                        gutter={24}
                        style={{
                          marginRight: '30px',
                          display: 'flex',
                          justifyContent: 'center',
                          verticalAlign: 'middle',
                        }}
                        id='detailsAndServices'
                      >
                        <Col
                          span={hasOriginAndDestinationServicesInGridConfig ? 24: 12}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxWidth: '100%',
                          }}
                          id='originDetailsAndServices'
                        >
                          <div className={classes.rowDiv}>
                            <div style={{ width: '25%', marginBottom: '15px' }}>
                            <span className={classes.formTitles}>{resolveFieldLabel('grid#additionalDetails.originCountry', 'Origin Country', this.state.inquiryFieldLabelMap)}{(isDraft && draftMandatoryFields?.includes('originPortCountry')) ? <Asterisk /> : null} </span>
                            </div>
                            <div style={{ width: '70%' }}>
                              <Select
                                showSearch
                                disabled={isOriginCountryDisabled}
                                value={this.state.originPortCountry}
                                placeholder="Select Origin Country"
                                optionLabelProp={'data-value'}
                                filterOption={(input, option) =>
                                  option.props['data-value'].toLowerCase().includes(input.toLowerCase())
                                    }
                                style={{ width: '85%' }}
                                onChange={(country) => {
                                  this.setState({
                                    originPortCountry: country,
                                  });
                                }}
                              >
                                {masterData.countriesList.map((item) => (
                                  <Option key={item.countryCode} value={item.countryCode} data-value={item.countryName}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                      <span style={{ marginRight: '5px' }}>{item.countryName}</span>
                                      <img src={item.flagS3Link} />
                                    </div>
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                          {(pickupAndDrop === 'Door to Port' || pickupAndDrop === 'Door to Door') && (
                            <div className={classes.rowDiv}>
                              <div style={{ width: '25%' }}>
                                  <span className={classes.formTitles}>{resolveFieldLabel('grid#additionalDetails.originAddress', 'Origin Address', this.state.inquiryFieldLabelMap)} *</span>
                              </div>
                              <FormItem style={{ marginBottom: '8px', width: '70%'}}>
                                {getFieldDecorator(
                                  'stuffingAddress',
                                  { initialValue: this.fromDiscoverRates() ? this.props.discoverRatesSelectedFilters?.stuffingLocationId : prefilledStuffingAddress }
                                )(
                                  <SelectAddress
                                    style={{ width: '85%' }}
                                    disabled={this.fromDiscoverRates() && this.props.discoverRatesSelectedFilters?.stuffingLocationId || this.props.booking}
                                    placeholder="Select Origin Location"
                                    shipperId={this.isEditOrBookingInquiry() ? this.state.shipperId: this.state.organisationId}
                                    cargoOperationType={CargoOperationType.STUFFING}
                                    addresses={stuffingAddresses}
                                    allowEdit={
                                      enableAddressMasterInMenu
                                        ? hasMasterCategoryEditPermission('ADDRESS', permissions)
                                        : true
                                    }

                                    labelInValue = {true}
                                    onChange={(item, option: any) => {
                                      // Clear the prefilled address so a manual selection is not reverted
                                      // to the stale prefilled value if the field unmounts and remounts.
                                      this.setState({ prefilledStuffingAddress: undefined });
                                      const optionProps = Array.isArray(option) ? option?.[0]?.props : option?.props;

                                      this.resetContactInfo('origin');
                                      const setCountry = !this.state.originPort && this.props.inquiryConfig?.allowVendorToSpecifyOrigin;
                                      if (optionProps) {
                                        this.setContactFromOption('origin', optionProps);
                                        if (setCountry) this.setState({ originCountry: optionProps?.countryCode, originPortCountry: optionProps?.countryCode });

                                      }
                                    }}

                                  />
                                )}
                              
                              </FormItem>
                            </div>
                          )}
                          {showOriginContactInfoInRender &&
                                  this.renderContactInfo(this.state.inchargeContactOrigin, 'origin')}
                          {this.renderStuffingLocation()}
                          {this.renderStuffingAddress()}
                          <div className={classes.rowDiv}>
                            <div style={{ width: '25%' }}>
                              <span
                                style={{ position: 'absolute', marginTop: '0px' }}
                                className={classes.formTitles}
                              >
                                {resolveFieldLabel('grid#originservices', 'Origin Services', this.state.inquiryFieldLabelMap)}{' '}
                              </span>
                            </div>
                            <div style={{ width: '70%' }}>
                              <Checkbox.Group
                                disabled={visible}
                                value={this.state.originServices}
                                onChange={(val) => {
                                  this.handleServiceChange(originServices, 'originServices', val);
                                  if (!this.state.originServices.length) {
                                    this.setState({ showAddInputOrigin: false });
                                    setFieldsValue({ originDetails: undefined });
                                  }
                                }}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                                options={this.state.originAllowedServices}
                              />
                              {inquiryModeExtraServices?.[mode] &&
                                this.renderAdditionalServices(originServices, 'originServices')}
                              {this.state.originServices?.length
                                ? this.renderAddDetails('origin')
                                : null}
                            </div>
                          </div>
                        </Col>
                        <Col
                          span={hasOriginAndDestinationServicesInGridConfig ? 24: 12}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxWidth: '100%',
                          }}
                          id='destinationDetailsAndServices'
                        >
                                <div className={classes.rowDiv}>
                                  <div className={classes.gridLabelWidth} style={{ margin: '5px 0px 15px 0px' }}>
                                  <span className={classes.formTitles}>{resolveFieldLabel('grid#additionalDetails.destinationCountry', 'Destination Country', this.state.inquiryFieldLabelMap)}{(isDraft && draftMandatoryFields?.includes('destinationPortCountry')) ? <Asterisk /> : null} </span>
                                  </div>
                                  <div className={classes.gridInputFieldWidth}>
                                    <Select
                                      showSearch
                                      disabled={isDestinationCountryDisabled}
                                      style={{ width: '85%' }}
                                      value={this.state.destinationPortCountry}
                                      placeholder="Select Destination Country"
                                      optionLabelProp={'data-value'}
                                      filterOption={(input, option) =>
                                        option.props['data-value'].toLowerCase().includes(input.toLowerCase())
                                      }
                                      onChange={(country) => {
                                        this.setState({
                                          destinationPortCountry: country,
                                        });
                                      }}
                                    >
                                      {masterData.countriesList.map((item) => (
                                        <Option key={item.countryCode} value={item.countryCode} data-value={item.countryName}>
                                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span style={{ marginRight: '5px' }}>{item.countryName}</span>
                                            <img src={item.flagS3Link} />
                                          </div>
                                        </Option>
                                      ))}
                                    </Select>
                                  </div>
                                </div>
                          {(pickupAndDrop === 'Port to Door' || pickupAndDrop === 'Door to Door') && (
                            <div className={classes.rowDiv}>
                              <div className={classes.gridLabelWidth}>
                                <span className={classes.formTitles} style={{ marginRight: '15px' }}>
                                  Destination Address*{' '}
                                </span>
                              </div>
                              <div className={classes.gridInputFieldWidth}>
                              <FormItem style={{ marginBottom: '8px', width: '100%' }}>
                                {getFieldDecorator(
                                  'deStuffingAddress',
                                  { initialValue: this.fromDiscoverRates() ? this.props.discoverRatesSelectedFilters?.destuffingLocationId : prefilledDestuffingAddress }
                                )(
                                  <SelectAddress
                                    style={{ width: '85%' }}
                                    disabled={this.fromDiscoverRates() && this.props.discoverRatesSelectedFilters?.destuffingLocationId || this.props.booking}
                                    placeholder="Select Destination Location"
                                    shipperId={this.isEditOrBookingInquiry() ? this.state.shipperId: this.state.organisationId}
                                    cargoOperationType={CargoOperationType.DESTUFFING}
                                    addresses={this.state.deStuffingAddresses}
                                    allowEdit={
                                      enableAddressMasterInMenu
                                        ? hasMasterCategoryEditPermission('ADDRESS', permissions)
                                        : true
                                    }

                                    labelInValue = {true}
                                    onChange={(item, option: any) => {
                                      // Clear the prefilled address so a manual selection is not reverted
                                      // to the stale prefilled value if the field unmounts and remounts.
                                      this.setState({ prefilledDestuffingAddress: undefined });
                                      const optionProps = Array.isArray(option) ? option?.[0]?.props : option?.props;

                                      this.resetContactInfo('destination');
                                      const setCountry = !this.state.destinationPort && this.props.inquiryConfig?.allowVendorToSpecifyDestination;
                                      if (optionProps) {
                                        this.setContactFromOption('destination', optionProps);
                                        if (setCountry) this.setState({ destinationCountry: optionProps?.countryCode, destinationPortCountry: optionProps?.countryCode });
                                      }
                                    }}
                                  />
                                )}
                              
                              </FormItem>
                              </div>
                            </div>
                          )}
                          {showDestinationContactInfoInRender &&
                                this.renderContactInfo(this.state.inchargeContactDestination, 'destination')}
                          {this.renderDeStuffingLocation()}
                          {this.renderDeStuffingAddress()}
                          <div className={classes.rowDiv}>
                            <div className={classes.gridLabelWidth} style={{ width: '32%', paddingBottom:"50px" }}>
                              <span
                                style={{ position: 'absolute', marginTop: '0px' }}
                                className={classes.formTitles}
                              >
                                 {resolveFieldLabel('grid#destinatioservices', 'Destination Services', this.state.inquiryFieldLabelMap)}{' '}
                              </span>
                            </div>
                            <div className={classes.gridInputFieldWidth}>
                              <Checkbox.Group
                                disabled={visible}
                                value={this.state.destinationServices}
                                onChange={(val) => {
                                  this.handleServiceChange(
                                    destinationServices,
                                    'destinationServices',
                                    val
                                  );
                                  if (!this.state.destinationServices.length) {
                                    this.setState({ showAddInputDestination: false });
                                    setFieldsValue({ destinationDetails: undefined });
                                  }
                                }}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                                options={this.state.destinationAllowedServices}
                              />
                              {inquiryModeExtraServices?.[mode] &&
                                this.renderAdditionalServices(
                                  destinationServices,
                                  'destinationServices'
                                )}
                              {this.state.destinationServices?.length
                                ? this.renderAddDetails('destination')
                                : null}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      {this.getMode() === 'FCL' && <div id='destinationFreeDays'>{this.renderDestinationFreeDays()}</div>}
                      {this.getMode() === 'FCL' && <div id='requiredOriginFreeDays'>{this.renderRequiredOriginFreeDays()}</div>}
                      <Row
                        gutter={24}
                        style={{
                          marginBottom: '22px',
                          verticalAlign: 'middle',
                          marginTop: '25px',
                        }}
                      >
                        <Col span={12} className={classes.formTitles}>
                          {this.renderPrefferedCarriers()}
                        </Col>
                      </Row>
                      {(this.getMode() === 'FCL' || this.getMode() === 'LCL') && this.renderBusinessType()}
                      {this.renderBusinessEntity()}
                      {(this.getMode() === 'FCL' || this.getMode() === 'LCL') && this.renderOtherDetails()}
                    {this.renderDocuments()}
                      <Row
                        gutter={24}
                        style={{
                          marginBottom: '30px',
                          verticalAlign: 'middle',
                          marginTop: '25px',
                        }}
                      >
                        <Col span={20} className={classes.formTitles}>
                          {this.renderReferenceRate()}
                        </Col>
                      </Row>
                    </Panel>
                  </Collapse>
                </div>
              </FormGridContainer>
              </>
            )}
            {this.state.createInquiryModalVisible && this.renderConfirmModal()}
          </div>
          {booking && (
            <div
              style={{
                flex: 1,
                marginBottom: '10px',
                height: 1,
                width: '100%',
                backgroundColor: '#D9D9D9',
              }}
            />
          )}
          <div
            style={{
              display: 'flex',
              paddingTop: '50px',
              marginBottom: '0px',
              flexDirection: 'row',
              justifyContent: 'space-between',
              borderTop: booking ? 'none' : '1px solid #D9D9D9',
            }}
          >
            <Row className={classes.inquiryAccessDiv} style={{ bottom: visible ? 10 : 30 }}>
              <Col span={4} style={{ fontWeight: tokens.fontWeight.semibold, color: tokens.colors.textSecondary }}>
                {booking ? 'Booking' : 'Inquiry'} Access*
              </Col>
 
              <Col span={10} className={classes.accessField}>
                <FormItem className={classes.formItemSmallError} style={{ marginBottom: 0 }}>
                  {getFieldDecorator('accessType', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: teamId && !booking ? teamLabel : accessType,
                  })(
                    <Select placeholder="Select Access" data-testid={'selectAccessDropdown'} onSelect={this.handleAccessTypeChange}>
                      {isDefaultInquiryTeamMapping && userData.role !== 'ADMIN' ? (
                        // For now userData.role === 'ADMIN' to test, but change it
                        // to userData.role !== 'ADMIN' before pushing
                        teamMappedAccessKeys?.map((item) => {
                          return (
                            <Select.Option
                              key={item}
                              value={item}
                              disabled={
                                (!!visibleAccessTypes.length && !visibleAccessTypes.includes(item)) ||
                                (item === 'TEAM' && teams && !(this.filterTeams(teams).length))
                              }
                            >
                              {accessIcons[item]} {visibleAccessTypeLabelsForTeamMapped[item]}
                            </Select.Option>
                          )
                        })
                      ): (
                        defaultAccessKeys?.map((item) => {
                          return (
                            <Select.Option
                              key={item}
                              value={item}
                              disabled={
                                (!!visibleAccessTypes.length && !visibleAccessTypes.includes(item)) ||
                                (item === 'TEAM' && teams && !this.filterTeams(teams).length)
                              }
                            >
                              {accessIcons[item]} {visibleAccessTypeLabel[item]}
                            </Select.Option>
                          );
                        })
                      )}
                      
                     
                    </Select>
                  )}
                </FormItem>
              </Col>
              {!!bookingAccessTeamsIds.length && (
                <Col span={10} className={classes.accessField}>
                  <FormItem className={classes.formItemSmallError} style={{ marginBottom: 0 }}>
                    <Select
                      placeholder="Teams"
                      mode="multiple"
                      maxTagCount={1}
                      value={Object.values(bookingAccessTeams)}
                    >
                      {bookingAccessTeamsIds.map((key) => {
                        return (
                          <Select.Option key={key} value={bookingAccessTeams[key]} disabled>
                            {bookingAccessTeams[key]}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </FormItem>
                </Col>
              )}
            </Row>
            <div>
              <Button
                style={{ marginRight: '30px', bottom: visible ? 10 : 30 }}
                onClick={() => {
                  sendEvent(
                    this.getInquiryGACategory(),
                    `${this.getInquiryActionLabel()} - Cancel`
                  );
                  this.handleFormCancel();
                }}
              >
                {' '}
                Cancel
              </Button>
              <Button
                type="primary"
                style={{
                  backgroundColor: tokens.colors.primary,
                  border: tokens.colors.primary,
                  bottom: visible ? 10 : 30,
                  borderRadius: `${tokens.radius.md}px`,
                  marginRight: visible ? '30px' : '100px',
                }}
                data-testid={'submitInquiryButton'}
                loading={this.state.creatingBooking}
                onClick={() => {
                  this.checkForErrors();
                }}
              >
                {' '}
                {visible || this.disableRatesSearchParams() ? 'Next' : 'Submit'}
              </Button>
            </div>
          </div>
        </Form>  
        {isSelectTeamModalVisible && (
          <TeamForInquiryAccessModal
            isVisible={isSelectTeamModalVisible}
            teams={this.filterTeams(teams)}
            onCancel={() => {
              this.setState({ isSelectTeamModalVisible: false });
              this.props.form.setFieldsValue({
                accessType: teamId && !this.props.booking ? teamName : accessType,
              });
            }}
            handleTeamSelect={this.handleTeamSelect}
            teamId={this.state.teamId}
            bookingAccessTeams={this.state.bookingAccessTeams}
            isBooking={this.props.booking}
          />
        )}
        {isFFSelectionModalVisible && (
          <FFSelectionModal
            isVisible={isFFSelectionModalVisible}
            onModalClose={() => this.setState({ isFFSelectionModalVisible: false })}
            handleFFSelectionSend={this.handleFFSelectionSend}
            uniqueOrganisationList={this.getUniqueOrgNames}
            isLoading={isLoading}
            fromSendInquiryDiscoverRates={location?.state?.sendInquiry}
          />
        )}
        {isSendInquiryWithKYCVisible && (
          <SendInquiryInConnectionsModal
            isVisible={isSendInquiryWithKYCVisible}
            uniqueOrganisationList={this.getUniqueOrgNames}
            onModalClose={() => this.setState({ isSendInquiryWithKYCVisible: false })}
            onSuccess={() =>
              history.push(
                getInquiryShipperRoute(isValidArray(modeList) ? `modeList=${modeList}` : '')
              )
            }
            inquiryData={inquiryDataResponse}
          />
        )}
        {addProduct && <NewProduct handleClose={(success: boolean) => this.handleAddProduct()} />}
        {!visible && this.state.creatingInquiry && (
          <CreateInquiryLoader
            onClose={this.onCreateInquiryLoaderClose}
            visible={this.state.creatingInquiry}
            type={match.path.includes('edit')}
          />
        )}
        {!visible && this.state.sendInquiryModalVisible && (
          <SendRFQ
            referenceNumber={inquiryData.data?.referenceNumber}
            deadline={inquiryData.data.deadline}
            inquiryId={inquiryData.data.id}
            inquiryMode={inquiryData.data.mode}
            inquiryData={inquiryData}
            originCountry={this.state.originCountry}
            destinationCountry={this.state.destinationCountry}
            sentFfIds={sentFFIds.length > 0 ? sentFFIds : []}
            visible={this.state.sendInquiryModalVisible}
            handleOk={() => this.handleFormCancel(false)}
            handleCancel={() => this.handleFormCancel(false)}
            fromCreateInquiry={true}
          />
        )}
        {!visible && this.state.showProtip && (
          <CreateInquiryProtip
            submitInquiry={INQUIRY_SEND_ACTIONS && !isDraft ? this.onProtipClose(true) : this.onProtipClose(false)}
            // calling onProtip directly from here
            inquiryData={this.state.inquiryData}
            visible={this.state.showProtip}
          />
        )}
      </div>
    );
  }
}
const getDimensions = (masterData: any, dimensionName: string) => {
  const shippingLines: any = [];
  masterData.globalShippingLines.map((item) => {
    shippingLines.push(item);
  });
  return shippingLines;
};

const getUpperCaseDimensionLayout = createSelector([getDimensions], (dimensions) => {
  const dimensionSorted = dimensions.map((val: any) => ({
    key: val.id,
    label: val.name.toUpperCase(),
  }));
  dimensionSorted.sort((firstValue, secondValue) =>
    firstValue.label.localeCompare(secondValue.label)
  );
  return dimensionSorted;
});
const mapStateToProps = (
  { staticData, masterData, inquiryReducer, inquiryShipperReducer, discoverRatesReducer, organisation, execution  },

  { }
) => ({
  staticData,
  masterData: inquiryReducer.masterData,
  globalShippingLines: globalShippingLines(masterData),
  permissions: masterData.permissions,
  airCarriers: globalAirlines(masterData),
  currencies: masterData.currencySymbols,
  referenceRateBasis: inquiryReducer.masterData.referenceRateBasis,
  cargoTypes: masterData.cargoTypeList,
  cargoList: masterData.cargoList,
  discoverRatesSearchFilters: discoverRatesReducer.searchFilters,
  discoverRatesSelectedFilters: discoverRatesReducer.selectedFilters,
  timezone: masterData.timezone,
  containerList: masterData.containerList,
  createInquiryData: inquiryShipperReducer.createInquiryData,
  modeList: inquiryShipperReducer.appliedFilters?.modeList,
  isCargoWtMandatory: masterData.modules.cargo_wt_settings,
  showRoadInsteadOfDomestic:masterData.modules?.show_road_instead_of_domestic,
  businessEntities: inquiryReducer?.masterData?.businessEntities,
  incotermToServices: inquiryReducer.masterData.incotermToServices,
  incotermToPickupAndDrop: inquiryReducer.masterData.incotermToPickupAndDrop,
  isTemperatureControlledMandatory: masterData.modules.is_temperature_controlled_mandatory,
  inquiryModeExtraServices: inquiryReducer.masterData.inquiryModeExtraServices,
  visibleAccessTypes: masterData?.visibleAccessTypes?.INQUIRY ?? [],
  isHazCargoDocumentsRequired: masterData.modules.haz_cargo_documents_required,
  inquiryTypeToIncoterms: inquiryReducer?.masterData?.inquiryTypeToIncoterms ?? { EXPORT: [], IMPORT: [] },
  productTypes: inquiryReducer?.masterData?.productTypes,
  isIncotermMandatory: masterData.modules.is_incoterm_mandatory,
  orgCurrency: organisation?.orgDetails?.defaultCurrency ?? 'USD',
  customFieldsForInquiry: masterData?.customFieldsForInquiry,
  mandatoryFieldsInDraft: masterData?.mandatoryFieldsInInquiryDraft,
  isDefaultInquiryTeamMapping: masterData.modules?.enable_default_inquiry_team_mapping,
  inquiryFormPrefill: masterData?.modules?.inquiry_form_prefill,
  skipAdditionalCargoDetailsInBooking: masterData?.modules?.skip_additional_cargo_details_in_booking,
  userData: masterData.userData,
  allInquiriesData: inquiryShipperReducer?.allInquiries,
  inquiryDefaultFormConfig: masterData?.inquiryDefaults?.defaultFormFieldConfig,
  isParentOrg: organisation?.orgDetails?.isParentOrg,
  exportBehaviorEnabled: inquiryReducer.masterData.inquiryFormPrefillExportBehavior || false,
  allowDestinationCountryEditInInquiry: inquiryReducer.masterData.allowDestinationCountryEditInInquiry || false,
  defaultInquiryMovementType: inquiryReducer.masterData.defaultInquiryMovementType,
  defaultOriginDestinationServiceSelection: inquiryReducer.masterData.defaultOriginDestinationServiceSelection || false,
  inquiryConfig: masterData.inquiry,
  enableAddressMasterInMenu: masterData.modules.enable_address_master_in_menu || false,
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(
    {
      setCreateInquiryData,
    },
    dispatch
  );
};

const options: HocOptions = {
  connectRedux: {
    useRedux: true,
    mapStateToProps,
    mapDispatchToProps,
  },
  connectForm: {
    useForm: true,
  },
  connectJss: {
    useJss: true,
    styleSheet: styles,
  },
  permissionOptions: {
    nonNegotiable: [INQUIRY_SHIPPER, INQUIRY_FROM_PROCURE, PermissionTypes.INQUIRY_CREATE_UPDATE_ACTIONS],
  },
  connectRouter: true,
  useInquiryMasterData: true,
  ignoreWithAuth: true,
};

const CreateNewEnquiry = GenericHoc(options)(CreateEnquiry);
export default CreateNewEnquiry;
